import * as e from "react";
import t, { Children as n, Component as r, Fragment as i, createContext as a, createElement as o, forwardRef as s, isValidElement as c, useCallback as l, useContext as u, useEffect as d, useId as f, useImperativeHandle as p, useInsertionEffect as m, useLayoutEffect as h, useMemo as g, useRef as _, useState as v } from "react";
import { Fragment as y, jsx as b, jsxs as x } from "react/jsx-runtime";
import * as S from "react-dom";
import C from "react-dom";
//#region \0rolldown/runtime.js
var w = Object.create, T = Object.defineProperty, E = Object.getOwnPropertyDescriptor, D = Object.getOwnPropertyNames, ee = Object.getPrototypeOf, te = Object.prototype.hasOwnProperty, ne = (e, t) => () => (e && (t = e(e = 0)), t), re = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), O = (e, t) => {
	let n = {};
	for (var r in e) T(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || T(n, Symbol.toStringTag, { value: "Module" }), n;
}, k = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = D(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !te.call(e, s) && s !== n && T(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = E(t, s)) || r.enumerable
	});
	return e;
}, A = (e, t, n) => (n = e == null ? {} : w(ee(e)), k(t || !e || !e.__esModule ? T(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), ie = (e) => te.call(e, "module.exports") ? e["module.exports"] : k(T({}, "__esModule", { value: !0 }), e), ae = "-", oe = (e) => {
	let t = ce(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			let n = e.split(ae);
			return n[0] === "" && n.length !== 1 && n.shift(), se(n, t) || M(e);
		},
		getConflictingClassGroupIds: (e, t) => {
			let i = n[e] || [];
			return t && r[e] ? [...i, ...r[e]] : i;
		}
	};
}, se = (e, t) => {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? se(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(ae);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}, j = /^\[(.+)\]$/, M = (e) => {
	if (j.test(e)) {
		let t = j.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}, ce = (e) => {
	let { theme: t, classGroups: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	for (let e in n) le(n[e], r, e, t);
	return r;
}, le = (e, t, n, r) => {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : N(t, e);
			r.classGroupId = n;
			return;
		}
		if (typeof e == "function") {
			if (ue(e)) {
				le(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
			return;
		}
		Object.entries(e).forEach(([e, i]) => {
			le(i, N(t, e), n, r);
		});
	});
}, N = (e, t) => {
	let n = e;
	return t.split(ae).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}, ue = (e) => e.isThemeGetter, de = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = (i, a) => {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	};
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}, fe = "!", pe = ":", me = 1, he = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a;
		for (let o = 0; o < e.length; o++) {
			let s = e[o];
			if (n === 0 && r === 0) {
				if (s === pe) {
					t.push(e.slice(i, o)), i = o + me;
					continue;
				}
				if (s === "/") {
					a = o;
					continue;
				}
			}
			s === "[" ? n++ : s === "]" ? n-- : s === "(" ? r++ : s === ")" && r--;
		}
		let o = t.length === 0 ? e : e.substring(i), s = ge(o);
		return {
			modifiers: t,
			hasImportantModifier: s !== o,
			baseClassName: s,
			maybePostfixModifierPosition: a && a > i ? a - i : void 0
		};
	};
	if (t) {
		let e = t + pe, n = r;
		r = (t) => t.startsWith(e) ? n(t.substring(e.length)) : {
			isExternal: !0,
			modifiers: [],
			hasImportantModifier: !1,
			baseClassName: t,
			maybePostfixModifierPosition: void 0
		};
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, ge = (e) => e.endsWith(fe) ? e.substring(0, e.length - 1) : e.startsWith(fe) ? e.substring(1) : e, _e = (e) => {
	let t = Object.fromEntries(e.orderSensitiveModifiers.map((e) => [e, !0]));
	return (e) => {
		if (e.length <= 1) return e;
		let n = [], r = [];
		return e.forEach((e) => {
			e[0] === "[" || t[e] ? (n.push(...r.sort(), e), r = []) : r.push(e);
		}), n.push(...r.sort()), n;
	};
}, ve = (e) => ({
	cache: de(e.cacheSize),
	parseClassName: he(e),
	sortModifiers: _e(e),
	...oe(e)
}), ye = /\s+/, be = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a } = t, o = [], s = e.trim().split(ye), c = "";
	for (let e = s.length - 1; e >= 0; --e) {
		let t = s[e], { isExternal: l, modifiers: u, hasImportantModifier: d, baseClassName: f, maybePostfixModifierPosition: p } = n(t);
		if (l) {
			c = t + (c.length > 0 ? " " + c : c);
			continue;
		}
		let m = !!p, h = r(m ? f.substring(0, p) : f);
		if (!h) {
			if (!m) {
				c = t + (c.length > 0 ? " " + c : c);
				continue;
			}
			if (h = r(f), !h) {
				c = t + (c.length > 0 ? " " + c : c);
				continue;
			}
			m = !1;
		}
		let g = a(u).join(":"), _ = d ? g + fe : g, v = _ + h;
		if (o.includes(v)) continue;
		o.push(v);
		let y = i(h, m);
		for (let e = 0; e < y.length; ++e) {
			let t = y[e];
			o.push(_ + t);
		}
		c = t + (c.length > 0 ? " " + c : c);
	}
	return c;
};
function xe() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = Se(t)) && (r && (r += " "), r += n);
	return r;
}
var Se = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Se(e[r])) && (n && (n += " "), n += t);
	return n;
};
function Ce(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = ve(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = be(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(xe.apply(null, arguments));
	};
}
var P = (e) => {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}, we = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Te = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ee = /^\d+\/\d+$/, De = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Oe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ke = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Ae = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, je = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Me = (e) => Ee.test(e), F = (e) => !!e && !Number.isNaN(Number(e)), Ne = (e) => !!e && Number.isInteger(Number(e)), Pe = (e) => e.endsWith("%") && F(e.slice(0, -1)), Fe = (e) => De.test(e), Ie = () => !0, Le = (e) => Oe.test(e) && !ke.test(e), Re = () => !1, ze = (e) => Ae.test(e), Be = (e) => je.test(e), Ve = (e) => !I(e) && !L(e), He = (e) => et(e, it, Re), I = (e) => we.test(e), Ue = (e) => et(e, at, Le), We = (e) => et(e, ot, F), Ge = (e) => et(e, nt, Re), Ke = (e) => et(e, rt, Be), qe = (e) => et(e, ct, ze), L = (e) => Te.test(e), Je = (e) => tt(e, at), Ye = (e) => tt(e, st), Xe = (e) => tt(e, nt), Ze = (e) => tt(e, it), Qe = (e) => tt(e, rt), $e = (e) => tt(e, ct, !0), et = (e, t, n) => {
	let r = we.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, tt = (e, t, n = !1) => {
	let r = Te.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, nt = (e) => e === "position" || e === "percentage", rt = (e) => e === "image" || e === "url", it = (e) => e === "length" || e === "size" || e === "bg-size", at = (e) => e === "length", ot = (e) => e === "number", st = (e) => e === "family-name", ct = (e) => e === "shadow", lt = /* @__PURE__ */ Ce(() => {
	let e = P("color"), t = P("font"), n = P("text"), r = P("font-weight"), i = P("tracking"), a = P("leading"), o = P("breakpoint"), s = P("container"), c = P("spacing"), l = P("radius"), u = P("shadow"), d = P("inset-shadow"), f = P("text-shadow"), p = P("drop-shadow"), m = P("blur"), h = P("perspective"), g = P("aspect"), _ = P("ease"), v = P("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		L,
		I
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		L,
		I,
		c
	], T = () => [
		Me,
		"full",
		"auto",
		...w()
	], E = () => [
		Ne,
		"none",
		"subgrid",
		L,
		I
	], D = () => [
		"auto",
		{ span: [
			"full",
			Ne,
			L,
			I
		] },
		Ne,
		L,
		I
	], ee = () => [
		Ne,
		"auto",
		L,
		I
	], te = () => [
		"auto",
		"min",
		"max",
		"fr",
		L,
		I
	], ne = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], re = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], O = () => ["auto", ...w()], k = () => [
		Me,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], A = () => [
		e,
		L,
		I
	], ie = () => [
		...b(),
		Xe,
		Ge,
		{ position: [L, I] }
	], ae = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], oe = () => [
		"auto",
		"cover",
		"contain",
		Ze,
		He,
		{ size: [L, I] }
	], se = () => [
		Pe,
		Je,
		Ue
	], j = () => [
		"",
		"none",
		"full",
		l,
		L,
		I
	], M = () => [
		"",
		F,
		Je,
		Ue
	], ce = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], le = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], N = () => [
		F,
		Pe,
		Xe,
		Ge
	], ue = () => [
		"",
		"none",
		m,
		L,
		I
	], de = () => [
		"none",
		F,
		L,
		I
	], fe = () => [
		"none",
		F,
		L,
		I
	], pe = () => [
		F,
		L,
		I
	], me = () => [
		Me,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [Fe],
			breakpoint: [Fe],
			color: [Ie],
			container: [Fe],
			"drop-shadow": [Fe],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Ve],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [Fe],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [Fe],
			shadow: [Fe],
			spacing: ["px", F],
			text: [Fe],
			"text-shadow": [Fe],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				Me,
				I,
				L,
				g
			] }],
			container: ["container"],
			columns: [{ columns: [
				F,
				I,
				L,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{ start: T() }],
			end: [{ end: T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				Ne,
				"auto",
				L,
				I
			] }],
			basis: [{ basis: [
				Me,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				F,
				Me,
				"auto",
				"initial",
				"none",
				I
			] }],
			grow: [{ grow: [
				"",
				F,
				L,
				I
			] }],
			shrink: [{ shrink: [
				"",
				F,
				L,
				I
			] }],
			order: [{ order: [
				Ne,
				"first",
				"last",
				"none",
				L,
				I
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": ee() }],
			"col-end": [{ "col-end": ee() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": ee() }],
			"row-end": [{ "row-end": ee() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": te() }],
			"auto-rows": [{ "auto-rows": te() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...ne(), "normal"] }],
			"justify-items": [{ "justify-items": [...re(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...re()] }],
			"align-content": [{ content: ["normal", ...ne()] }],
			"align-items": [{ items: [...re(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...re(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": ne() }],
			"place-items": [{ "place-items": [...re(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...re()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: O() }],
			mx: [{ mx: O() }],
			my: [{ my: O() }],
			ms: [{ ms: O() }],
			me: [{ me: O() }],
			mt: [{ mt: O() }],
			mr: [{ mr: O() }],
			mb: [{ mb: O() }],
			ml: [{ ml: O() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: k() }],
			w: [{ w: [
				s,
				"screen",
				...k()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...k()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...k()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...k()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...k()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...k()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Je,
				Ue
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				L,
				We
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				Pe,
				I
			] }],
			"font-family": [{ font: [
				Ye,
				I,
				t
			] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				L,
				I
			] }],
			"line-clamp": [{ "line-clamp": [
				F,
				"none",
				L,
				We
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				L,
				I
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				L,
				I
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: A() }],
			"text-color": [{ text: A() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...ce(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				F,
				"from-font",
				"auto",
				L,
				Ue
			] }],
			"text-decoration-color": [{ decoration: A() }],
			"underline-offset": [{ "underline-offset": [
				F,
				"auto",
				L,
				I
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				L,
				I
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				L,
				I
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: ie() }],
			"bg-repeat": [{ bg: ae() }],
			"bg-size": [{ bg: oe() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						Ne,
						L,
						I
					],
					radial: [
						"",
						L,
						I
					],
					conic: [
						Ne,
						L,
						I
					]
				},
				Qe,
				Ke
			] }],
			"bg-color": [{ bg: A() }],
			"gradient-from-pos": [{ from: se() }],
			"gradient-via-pos": [{ via: se() }],
			"gradient-to-pos": [{ to: se() }],
			"gradient-from": [{ from: A() }],
			"gradient-via": [{ via: A() }],
			"gradient-to": [{ to: A() }],
			rounded: [{ rounded: j() }],
			"rounded-s": [{ "rounded-s": j() }],
			"rounded-e": [{ "rounded-e": j() }],
			"rounded-t": [{ "rounded-t": j() }],
			"rounded-r": [{ "rounded-r": j() }],
			"rounded-b": [{ "rounded-b": j() }],
			"rounded-l": [{ "rounded-l": j() }],
			"rounded-ss": [{ "rounded-ss": j() }],
			"rounded-se": [{ "rounded-se": j() }],
			"rounded-ee": [{ "rounded-ee": j() }],
			"rounded-es": [{ "rounded-es": j() }],
			"rounded-tl": [{ "rounded-tl": j() }],
			"rounded-tr": [{ "rounded-tr": j() }],
			"rounded-br": [{ "rounded-br": j() }],
			"rounded-bl": [{ "rounded-bl": j() }],
			"border-w": [{ border: M() }],
			"border-w-x": [{ "border-x": M() }],
			"border-w-y": [{ "border-y": M() }],
			"border-w-s": [{ "border-s": M() }],
			"border-w-e": [{ "border-e": M() }],
			"border-w-t": [{ "border-t": M() }],
			"border-w-r": [{ "border-r": M() }],
			"border-w-b": [{ "border-b": M() }],
			"border-w-l": [{ "border-l": M() }],
			"divide-x": [{ "divide-x": M() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": M() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...ce(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...ce(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: A() }],
			"border-color-x": [{ "border-x": A() }],
			"border-color-y": [{ "border-y": A() }],
			"border-color-s": [{ "border-s": A() }],
			"border-color-e": [{ "border-e": A() }],
			"border-color-t": [{ "border-t": A() }],
			"border-color-r": [{ "border-r": A() }],
			"border-color-b": [{ "border-b": A() }],
			"border-color-l": [{ "border-l": A() }],
			"divide-color": [{ divide: A() }],
			"outline-style": [{ outline: [
				...ce(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				F,
				L,
				I
			] }],
			"outline-w": [{ outline: [
				"",
				F,
				Je,
				Ue
			] }],
			"outline-color": [{ outline: A() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				$e,
				qe
			] }],
			"shadow-color": [{ shadow: A() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				$e,
				qe
			] }],
			"inset-shadow-color": [{ "inset-shadow": A() }],
			"ring-w": [{ ring: M() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: A() }],
			"ring-offset-w": [{ "ring-offset": [F, Ue] }],
			"ring-offset-color": [{ "ring-offset": A() }],
			"inset-ring-w": [{ "inset-ring": M() }],
			"inset-ring-color": [{ "inset-ring": A() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				$e,
				qe
			] }],
			"text-shadow-color": [{ "text-shadow": A() }],
			opacity: [{ opacity: [
				F,
				L,
				I
			] }],
			"mix-blend": [{ "mix-blend": [
				...le(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": le() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [F] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": N() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": N() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": A() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": A() }],
			"mask-image-t-from-pos": [{ "mask-t-from": N() }],
			"mask-image-t-to-pos": [{ "mask-t-to": N() }],
			"mask-image-t-from-color": [{ "mask-t-from": A() }],
			"mask-image-t-to-color": [{ "mask-t-to": A() }],
			"mask-image-r-from-pos": [{ "mask-r-from": N() }],
			"mask-image-r-to-pos": [{ "mask-r-to": N() }],
			"mask-image-r-from-color": [{ "mask-r-from": A() }],
			"mask-image-r-to-color": [{ "mask-r-to": A() }],
			"mask-image-b-from-pos": [{ "mask-b-from": N() }],
			"mask-image-b-to-pos": [{ "mask-b-to": N() }],
			"mask-image-b-from-color": [{ "mask-b-from": A() }],
			"mask-image-b-to-color": [{ "mask-b-to": A() }],
			"mask-image-l-from-pos": [{ "mask-l-from": N() }],
			"mask-image-l-to-pos": [{ "mask-l-to": N() }],
			"mask-image-l-from-color": [{ "mask-l-from": A() }],
			"mask-image-l-to-color": [{ "mask-l-to": A() }],
			"mask-image-x-from-pos": [{ "mask-x-from": N() }],
			"mask-image-x-to-pos": [{ "mask-x-to": N() }],
			"mask-image-x-from-color": [{ "mask-x-from": A() }],
			"mask-image-x-to-color": [{ "mask-x-to": A() }],
			"mask-image-y-from-pos": [{ "mask-y-from": N() }],
			"mask-image-y-to-pos": [{ "mask-y-to": N() }],
			"mask-image-y-from-color": [{ "mask-y-from": A() }],
			"mask-image-y-to-color": [{ "mask-y-to": A() }],
			"mask-image-radial": [{ "mask-radial": [L, I] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": N() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": N() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": A() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": A() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [F] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": N() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": N() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": A() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": A() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: ie() }],
			"mask-repeat": [{ mask: ae() }],
			"mask-size": [{ mask: oe() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				L,
				I
			] }],
			filter: [{ filter: [
				"",
				"none",
				L,
				I
			] }],
			blur: [{ blur: ue() }],
			brightness: [{ brightness: [
				F,
				L,
				I
			] }],
			contrast: [{ contrast: [
				F,
				L,
				I
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				$e,
				qe
			] }],
			"drop-shadow-color": [{ "drop-shadow": A() }],
			grayscale: [{ grayscale: [
				"",
				F,
				L,
				I
			] }],
			"hue-rotate": [{ "hue-rotate": [
				F,
				L,
				I
			] }],
			invert: [{ invert: [
				"",
				F,
				L,
				I
			] }],
			saturate: [{ saturate: [
				F,
				L,
				I
			] }],
			sepia: [{ sepia: [
				"",
				F,
				L,
				I
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				L,
				I
			] }],
			"backdrop-blur": [{ "backdrop-blur": ue() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				F,
				L,
				I
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				F,
				L,
				I
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				F,
				L,
				I
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				F,
				L,
				I
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				F,
				L,
				I
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				F,
				L,
				I
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				F,
				L,
				I
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				F,
				L,
				I
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				L,
				I
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				F,
				"initial",
				L,
				I
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				L,
				I
			] }],
			delay: [{ delay: [
				F,
				L,
				I
			] }],
			animate: [{ animate: [
				"none",
				v,
				L,
				I
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				L,
				I
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: de() }],
			"rotate-x": [{ "rotate-x": de() }],
			"rotate-y": [{ "rotate-y": de() }],
			"rotate-z": [{ "rotate-z": de() }],
			scale: [{ scale: fe() }],
			"scale-x": [{ "scale-x": fe() }],
			"scale-y": [{ "scale-y": fe() }],
			"scale-z": [{ "scale-z": fe() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: pe() }],
			"skew-x": [{ "skew-x": pe() }],
			"skew-y": [{ "skew-y": pe() }],
			transform: [{ transform: [
				L,
				I,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: me() }],
			"translate-x": [{ "translate-x": me() }],
			"translate-y": [{ "translate-y": me() }],
			"translate-z": [{ "translate-z": me() }],
			"translate-none": ["translate-none"],
			accent: [{ accent: A() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: A() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				L,
				I
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				L,
				I
			] }],
			fill: [{ fill: ["none", ...A()] }],
			"stroke-w": [{ stroke: [
				F,
				Je,
				Ue,
				We
			] }],
			stroke: [{ stroke: ["none", ...A()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
}), ut = "\n  group justify-center\n  text-lg font-medium no-underline\n  px-5 rounded-xl h-11\n  flex items-center gap-2\n  transition-all min-w-fit\n\n  disabled:pointer-events-none\n  data-[is-disabled=true]:pointer-events-none\n\n  data-[size=\"medium\"]:h-12\n  data-[size=\"large\"]:h-16\n\n  data-[variant=\"primary\"]:bg-primary-100\n  data-[variant=\"primary\"]:text-white\n  data-[variant=\"primary\"]:hover:bg-primary-200\n  data-[variant=\"primary\"]:disabled:bg-gray-250\n  data-[variant=\"primary\"]:data-[is-disabled=true]:bg-gray-250\n  data-[variant=\"primary\"]:data-[inverse=true]:bg-white\n  data-[variant=\"primary\"]:data-[inverse=true]:text-primary-100\n  data-[variant=\"primary\"]:data-[inverse=true]:hover:bg-white\n  data-[variant=\"primary\"]:data-[inverse=true]:hover:text-primary-200\n  data-[variant=\"primary\"]:data-[inverse=true]:disabled:bg-gray-200\n  data-[variant=\"primary\"]:data-[inverse=true]:disabled:text-white\n  data-[variant=\"primary\"]:data-[inverse=true]:data-[is-disabled=true]:bg-gray-200\n  data-[variant=\"primary\"]:data-[inverse=true]:data-[is-disabled=true]:text-white\n\n  data-[variant=\"secondary\"]:border\n  data-[variant=\"secondary\"]:border-solid\n  data-[variant=\"secondary\"]:border-gray-150\n  data-[variant=\"secondary\"]:text-primary-100\n  data-[variant=\"secondary\"]:hover:border-primary-50\n  data-[variant=\"secondary\"]:hover:text-primary-50\n  data-[variant=\"secondary\"]:disabled:text-gray-250\n  data-[variant=\"secondary\"]:disabled:border-gray-250\n  data-[variant=\"secondary\"]:data-[is-disabled=true]:text-gray-250\n  data-[variant=\"secondary\"]:data-[is-disabled=true]:border-gray-250\n  data-[variant=\"secondary\"]:data-[inverse=true]:text-white\n  data-[variant=\"secondary\"]:data-[inverse=true]:border-white\n\n  data-[variant=\"ghost\"]:text-primary-100\n  data-[variant=\"ghost\"]:hover:text-primary-50\n  data-[variant=\"ghost\"]:disabled:text-gray-250\n  data-[variant=\"ghost\"]:data-[is-disabled=true]:text-gray-250\n\n  data-[variant=\"ghost\"]:data-[inverse=true]:text-white\n", dt = "h-6 w-6", ft = t.forwardRef(({ children: e, className: n = "", variant: r = "primary", size: i = "small", prefixIcon: a, suffixIcon: o, isDisabled: s = !1, inverse: c = !1, onClick: l, type: u = "button", ...d }, f) => /* @__PURE__ */ x("button", {
	onClick: (e) => {
		l && l(e);
	},
	className: lt(ut, n),
	disabled: s,
	"data-variant": r,
	"data-size": i,
	"data-inverse": c,
	type: u,
	...d,
	children: [
		a && t.cloneElement(a, {
			...a.props,
			className: lt(dt, a.props.className)
		}),
		e,
		o && t.cloneElement(o, {
			...o.props,
			className: lt(dt, o.props.className)
		})
	]
}));
ft.displayName = "Button";
//#endregion
//#region src/components/Card/styles.ts
var pt = "\n  font-sans\n  rounded-lg p-9 relative\n  border border-solid border-gray-150\n  transition-all\n\n  bg-white\n  text-gray-400\n", mt = "\n    bg-cover bg-center\n    w-full\n    h-60\n";
//#endregion
//#region src/components/Card/index.tsx
function ht({ children: e, imageSRC: t }) {
	return /* @__PURE__ */ x("div", {
		className: pt,
		children: [t && /* @__PURE__ */ b("div", {
			className: mt,
			style: { backgroundImage: `url("${t}")` }
		}), e]
	});
}
//#endregion
//#region src/components/ColorIcon/styles.ts
var gt = "\n  p-1 rounded-full inline-flex items-center justify-center transition-colors\n\n  bg-[var(--background)]\n  group-hover/color-icon:bg-[var(--fill)]\n  group-data-[is-active=true]/color-icon:bg-[var(--fill)]\n\n  sm:p-1.5\n", _t = "\n  w-3.5 h-3.5 transition-colors\n\n  fill-[var(--fill)]\n  group-hover/color-icon:fill-base-white\n  group-data-[is-active=true]/color-icon:fill-base-white\n";
//#endregion
//#region src/components/ColorIcon/index.tsx
function vt({ element: e, backgroundColor: n = "gray", fillColor: r = "black" }) {
	return /* @__PURE__ */ b("span", {
		className: gt,
		"data-testid": "icon-background",
		"data-background-color": n,
		"data-fill-color": r,
		style: {
			"--background": n,
			"--fill": r
		},
		children: t.cloneElement(e, {
			className: _t,
			"aria-hidden": "true",
			"data-testid": "icon"
		})
	});
}
//#endregion
//#region ../../node_modules/vite-plugin-node-polyfills/shims/process/dist/index.js
function yt(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function bt() {
	throw Error("setTimeout has not been defined");
}
function xt() {
	throw Error("clearTimeout has not been defined");
}
function St(e) {
	if (kt === setTimeout) return setTimeout(e, 0);
	if ((kt === bt || !kt) && setTimeout) return kt = setTimeout, setTimeout(e, 0);
	try {
		return kt(e, 0);
	} catch {
		try {
			return kt.call(null, e, 0);
		} catch {
			return kt.call(this, e, 0);
		}
	}
}
function Ct(e) {
	if (At === clearTimeout) return clearTimeout(e);
	if ((At === xt || !At) && clearTimeout) return At = clearTimeout, clearTimeout(e);
	try {
		return At(e);
	} catch {
		try {
			return At.call(null, e);
		} catch {
			return At.call(this, e);
		}
	}
}
function wt() {
	!Mt || !Nt || (Mt = !1, Nt.length ? jt = Nt.concat(jt) : Pt = -1, jt.length && Tt());
}
function Tt() {
	if (!Mt) {
		var e = St(wt);
		Mt = !0;
		for (var t = jt.length; t;) {
			for (Nt = jt, jt = []; ++Pt < t;) Nt && Nt[Pt].run();
			Pt = -1, t = jt.length;
		}
		Nt = null, Mt = !1, Ct(e);
	}
}
function Et(e, t) {
	this.fun = e, this.array = t;
}
function Dt() {}
var Ot, R, kt, At, jt, Mt, Nt, Pt, Ft, z, It = ne((() => {
	Ot = { exports: {} }, R = Ot.exports = {}, (function() {
		try {
			kt = typeof setTimeout == "function" ? setTimeout : bt;
		} catch {
			kt = bt;
		}
		try {
			At = typeof clearTimeout == "function" ? clearTimeout : xt;
		} catch {
			At = xt;
		}
	})(), jt = [], Mt = !1, Pt = -1, R.nextTick = function(e) {
		var t = Array(arguments.length - 1);
		if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
		jt.push(new Et(e, t)), jt.length === 1 && !Mt && St(Tt);
	}, Et.prototype.run = function() {
		this.fun.apply(null, this.array);
	}, R.title = "browser", R.browser = !0, R.env = {}, R.argv = [], R.version = "", R.versions = {}, R.on = Dt, R.addListener = Dt, R.once = Dt, R.off = Dt, R.removeListener = Dt, R.removeAllListeners = Dt, R.emit = Dt, R.prependListener = Dt, R.prependOnceListener = Dt, R.listeners = function(e) {
		return [];
	}, R.binding = function(e) {
		throw Error("process.binding is not supported");
	}, R.cwd = function() {
		return "/";
	}, R.chdir = function(e) {
		throw Error("process.chdir is not supported");
	}, R.umask = function() {
		return 0;
	}, Ft = Ot.exports, z = /* @__PURE__ */ yt(Ft);
})), Lt = function(e) {
	return Rt(e) && !zt(e);
};
function Rt(e) {
	return !!e && typeof e == "object";
}
function zt(e) {
	var t = Object.prototype.toString.call(e);
	return t === "[object RegExp]" || t === "[object Date]" || Vt(e);
}
var Bt = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
function Vt(e) {
	return e.$$typeof === Bt;
}
function Ht(e) {
	return Array.isArray(e) ? [] : {};
}
function Ut(e, t) {
	return t.clone !== !1 && t.isMergeableObject(e) ? Kt(Ht(e), e, t) : e;
}
function Wt(e, t, n) {
	return e.concat(t).map(function(e) {
		return Ut(e, n);
	});
}
function Gt(e, t, n) {
	var r = {};
	return n.isMergeableObject(e) && Object.keys(e).forEach(function(t) {
		r[t] = Ut(e[t], n);
	}), Object.keys(t).forEach(function(i) {
		!n.isMergeableObject(t[i]) || !e[i] ? r[i] = Ut(t[i], n) : r[i] = Kt(e[i], t[i], n);
	}), r;
}
function Kt(e, t, n) {
	n ||= {}, n.arrayMerge = n.arrayMerge || Wt, n.isMergeableObject = n.isMergeableObject || Lt;
	var r = Array.isArray(t);
	return r === Array.isArray(e) ? r ? n.arrayMerge(e, t, n) : Gt(e, t, n) : Ut(t, n);
}
Kt.all = function(e, t) {
	if (!Array.isArray(e)) throw Error("first argument should be an array");
	return e.reduce(function(e, n) {
		return Kt(e, n, t);
	}, {});
};
var qt = Kt, Jt = globalThis || self, Yt = typeof Jt == "object" && Jt && Jt.Object === Object && Jt, Xt = typeof self == "object" && self && self.Object === Object && self, Zt = Yt || Xt || Function("return this")(), Qt = Zt.Symbol, $t = Object.prototype, en = $t.hasOwnProperty, tn = $t.toString, nn = Qt ? Qt.toStringTag : void 0;
function rn(e) {
	var t = en.call(e, nn), n = e[nn];
	try {
		e[nn] = void 0;
		var r = !0;
	} catch {}
	var i = tn.call(e);
	return r && (t ? e[nn] = n : delete e[nn]), i;
}
//#endregion
//#region ../../node_modules/lodash-es/_objectToString.js
var an = Object.prototype.toString;
function on(e) {
	return an.call(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_baseGetTag.js
var sn = "[object Null]", cn = "[object Undefined]", ln = Qt ? Qt.toStringTag : void 0;
function un(e) {
	return e == null ? e === void 0 ? cn : sn : ln && ln in Object(e) ? rn(e) : on(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_overArg.js
function dn(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../node_modules/lodash-es/_getPrototype.js
var fn = dn(Object.getPrototypeOf, Object);
//#endregion
//#region ../../node_modules/lodash-es/isObjectLike.js
function pn(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../node_modules/lodash-es/isPlainObject.js
var mn = "[object Object]", hn = Function.prototype, gn = Object.prototype, _n = hn.toString, vn = gn.hasOwnProperty, yn = _n.call(Object);
function bn(e) {
	if (!pn(e) || un(e) != mn) return !1;
	var t = fn(e);
	if (t === null) return !0;
	var n = vn.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n instanceof n && _n.call(n) == yn;
}
//#endregion
//#region ../../node_modules/lodash-es/_listCacheClear.js
function xn() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../node_modules/lodash-es/eq.js
function Sn(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../node_modules/lodash-es/_assocIndexOf.js
function Cn(e, t) {
	for (var n = e.length; n--;) if (Sn(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../node_modules/lodash-es/_listCacheDelete.js
var wn = Array.prototype.splice;
function Tn(e) {
	var t = this.__data__, n = Cn(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : wn.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../node_modules/lodash-es/_listCacheGet.js
function En(e) {
	var t = this.__data__, n = Cn(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../node_modules/lodash-es/_listCacheHas.js
function Dn(e) {
	return Cn(this.__data__, e) > -1;
}
//#endregion
//#region ../../node_modules/lodash-es/_listCacheSet.js
function On(e, t) {
	var n = this.__data__, r = Cn(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../node_modules/lodash-es/_ListCache.js
function kn(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
kn.prototype.clear = xn, kn.prototype.delete = Tn, kn.prototype.get = En, kn.prototype.has = Dn, kn.prototype.set = On;
//#endregion
//#region ../../node_modules/lodash-es/_stackClear.js
function An() {
	this.__data__ = new kn(), this.size = 0;
}
//#endregion
//#region ../../node_modules/lodash-es/_stackDelete.js
function jn(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region ../../node_modules/lodash-es/_stackGet.js
function Mn(e) {
	return this.__data__.get(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_stackHas.js
function Nn(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../node_modules/lodash-es/isObject.js
function Pn(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../node_modules/lodash-es/isFunction.js
var Fn = "[object AsyncFunction]", In = "[object Function]", Ln = "[object GeneratorFunction]", Rn = "[object Proxy]";
function zn(e) {
	if (!Pn(e)) return !1;
	var t = un(e);
	return t == In || t == Ln || t == Fn || t == Rn;
}
//#endregion
//#region ../../node_modules/lodash-es/_coreJsData.js
var Bn = Zt["__core-js_shared__"], Vn = function() {
	var e = /[^.]+$/.exec(Bn && Bn.keys && Bn.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function Hn(e) {
	return !!Vn && Vn in e;
}
//#endregion
//#region ../../node_modules/lodash-es/_toSource.js
var Un = Function.prototype.toString;
function Wn(e) {
	if (e != null) {
		try {
			return Un.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../node_modules/lodash-es/_baseIsNative.js
var Gn = /[\\^$.*+?()[\]{}|]/g, Kn = /^\[object .+?Constructor\]$/, qn = Function.prototype, Jn = Object.prototype, Yn = qn.toString, Xn = Jn.hasOwnProperty, Zn = RegExp("^" + Yn.call(Xn).replace(Gn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Qn(e) {
	return !Pn(e) || Hn(e) ? !1 : (zn(e) ? Zn : Kn).test(Wn(e));
}
//#endregion
//#region ../../node_modules/lodash-es/_getValue.js
function $n(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../node_modules/lodash-es/_getNative.js
function er(e, t) {
	var n = $n(e, t);
	return Qn(n) ? n : void 0;
}
//#endregion
//#region ../../node_modules/lodash-es/_Map.js
var tr = er(Zt, "Map"), nr = er(Object, "create");
//#endregion
//#region ../../node_modules/lodash-es/_hashClear.js
function rr() {
	this.__data__ = nr ? nr(null) : {}, this.size = 0;
}
//#endregion
//#region ../../node_modules/lodash-es/_hashDelete.js
function ir(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../node_modules/lodash-es/_hashGet.js
var ar = "__lodash_hash_undefined__", or = Object.prototype.hasOwnProperty;
function sr(e) {
	var t = this.__data__;
	if (nr) {
		var n = t[e];
		return n === ar ? void 0 : n;
	}
	return or.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../node_modules/lodash-es/_hashHas.js
var cr = Object.prototype.hasOwnProperty;
function lr(e) {
	var t = this.__data__;
	return nr ? t[e] !== void 0 : cr.call(t, e);
}
//#endregion
//#region ../../node_modules/lodash-es/_hashSet.js
var ur = "__lodash_hash_undefined__";
function dr(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = nr && t === void 0 ? ur : t, this;
}
//#endregion
//#region ../../node_modules/lodash-es/_Hash.js
function fr(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
fr.prototype.clear = rr, fr.prototype.delete = ir, fr.prototype.get = sr, fr.prototype.has = lr, fr.prototype.set = dr;
//#endregion
//#region ../../node_modules/lodash-es/_mapCacheClear.js
function pr() {
	this.size = 0, this.__data__ = {
		hash: new fr(),
		map: new (tr || kn)(),
		string: new fr()
	};
}
//#endregion
//#region ../../node_modules/lodash-es/_isKeyable.js
function mr(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../node_modules/lodash-es/_getMapData.js
function hr(e, t) {
	var n = e.__data__;
	return mr(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../node_modules/lodash-es/_mapCacheDelete.js
function gr(e) {
	var t = hr(this, e).delete(e);
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../node_modules/lodash-es/_mapCacheGet.js
function _r(e) {
	return hr(this, e).get(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_mapCacheHas.js
function vr(e) {
	return hr(this, e).has(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_mapCacheSet.js
function yr(e, t) {
	var n = hr(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../node_modules/lodash-es/_MapCache.js
function br(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
br.prototype.clear = pr, br.prototype.delete = gr, br.prototype.get = _r, br.prototype.has = vr, br.prototype.set = yr;
//#endregion
//#region ../../node_modules/lodash-es/_stackSet.js
var xr = 200;
function Sr(e, t) {
	var n = this.__data__;
	if (n instanceof kn) {
		var r = n.__data__;
		if (!tr || r.length < xr - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new br(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region ../../node_modules/lodash-es/_Stack.js
function Cr(e) {
	var t = this.__data__ = new kn(e);
	this.size = t.size;
}
Cr.prototype.clear = An, Cr.prototype.delete = jn, Cr.prototype.get = Mn, Cr.prototype.has = Nn, Cr.prototype.set = Sr;
//#endregion
//#region ../../node_modules/lodash-es/_arrayEach.js
function wr(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region ../../node_modules/lodash-es/_defineProperty.js
var Tr = function() {
	try {
		var e = er(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}();
//#endregion
//#region ../../node_modules/lodash-es/_baseAssignValue.js
function Er(e, t, n) {
	t == "__proto__" && Tr ? Tr(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region ../../node_modules/lodash-es/_assignValue.js
var Dr = Object.prototype.hasOwnProperty;
function Or(e, t, n) {
	var r = e[t];
	(!(Dr.call(e, t) && Sn(r, n)) || n === void 0 && !(t in e)) && Er(e, t, n);
}
//#endregion
//#region ../../node_modules/lodash-es/_copyObject.js
function kr(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? Er(n, s, c) : Or(n, s, c);
	}
	return n;
}
//#endregion
//#region ../../node_modules/lodash-es/_baseTimes.js
function Ar(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region ../../node_modules/lodash-es/_baseIsArguments.js
var jr = "[object Arguments]";
function Mr(e) {
	return pn(e) && un(e) == jr;
}
//#endregion
//#region ../../node_modules/lodash-es/isArguments.js
var Nr = Object.prototype, Pr = Nr.hasOwnProperty, Fr = Nr.propertyIsEnumerable, Ir = Mr(function() {
	return arguments;
}()) ? Mr : function(e) {
	return pn(e) && Pr.call(e, "callee") && !Fr.call(e, "callee");
}, Lr = Array.isArray;
//#endregion
//#region ../../node_modules/lodash-es/stubFalse.js
function Rr() {
	return !1;
}
//#endregion
//#region ../../node_modules/lodash-es/isBuffer.js
var zr = typeof exports == "object" && exports && !exports.nodeType && exports, Br = zr && typeof module == "object" && module && !module.nodeType && module, Vr = Br && Br.exports === zr ? Zt.Buffer : void 0, Hr = (Vr ? Vr.isBuffer : void 0) || Rr, Ur = 9007199254740991, Wr = /^(?:0|[1-9]\d*)$/;
function Gr(e, t) {
	var n = typeof e;
	return t ??= Ur, !!t && (n == "number" || n != "symbol" && Wr.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region ../../node_modules/lodash-es/isLength.js
var Kr = 9007199254740991;
function qr(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Kr;
}
//#endregion
//#region ../../node_modules/lodash-es/_baseIsTypedArray.js
var Jr = "[object Arguments]", Yr = "[object Array]", Xr = "[object Boolean]", Zr = "[object Date]", Qr = "[object Error]", $r = "[object Function]", ei = "[object Map]", ti = "[object Number]", ni = "[object Object]", ri = "[object RegExp]", ii = "[object Set]", ai = "[object String]", oi = "[object WeakMap]", si = "[object ArrayBuffer]", ci = "[object DataView]", li = "[object Float32Array]", ui = "[object Float64Array]", di = "[object Int8Array]", fi = "[object Int16Array]", pi = "[object Int32Array]", mi = "[object Uint8Array]", hi = "[object Uint8ClampedArray]", gi = "[object Uint16Array]", _i = "[object Uint32Array]", B = {};
B[li] = B[ui] = B[di] = B[fi] = B[pi] = B[mi] = B[hi] = B[gi] = B[_i] = !0, B[Jr] = B[Yr] = B[si] = B[Xr] = B[ci] = B[Zr] = B[Qr] = B[$r] = B[ei] = B[ti] = B[ni] = B[ri] = B[ii] = B[ai] = B[oi] = !1;
function vi(e) {
	return pn(e) && qr(e.length) && !!B[un(e)];
}
//#endregion
//#region ../../node_modules/lodash-es/_baseUnary.js
function yi(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../node_modules/lodash-es/_nodeUtil.js
var bi = typeof exports == "object" && exports && !exports.nodeType && exports, xi = bi && typeof module == "object" && module && !module.nodeType && module, Si = xi && xi.exports === bi && Yt.process, Ci = function() {
	try {
		return xi && xi.require && xi.require("util").types || Si && Si.binding && Si.binding("util");
	} catch {}
}(), wi = Ci && Ci.isTypedArray, Ti = wi ? yi(wi) : vi, Ei = Object.prototype.hasOwnProperty;
function Di(e, t) {
	var n = Lr(e), r = !n && Ir(e), i = !n && !r && Hr(e), a = !n && !r && !i && Ti(e), o = n || r || i || a, s = o ? Ar(e.length, String) : [], c = s.length;
	for (var l in e) (t || Ei.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Gr(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region ../../node_modules/lodash-es/_isPrototype.js
var Oi = Object.prototype;
function ki(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || Oi);
}
//#endregion
//#region ../../node_modules/lodash-es/_nativeKeys.js
var Ai = dn(Object.keys, Object), ji = Object.prototype.hasOwnProperty;
function Mi(e) {
	if (!ki(e)) return Ai(e);
	var t = [];
	for (var n in Object(e)) ji.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region ../../node_modules/lodash-es/isArrayLike.js
function Ni(e) {
	return e != null && qr(e.length) && !zn(e);
}
//#endregion
//#region ../../node_modules/lodash-es/keys.js
function Pi(e) {
	return Ni(e) ? Di(e) : Mi(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_baseAssign.js
function Fi(e, t) {
	return e && kr(t, Pi(t), e);
}
//#endregion
//#region ../../node_modules/lodash-es/_nativeKeysIn.js
function Ii(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region ../../node_modules/lodash-es/_baseKeysIn.js
var Li = Object.prototype.hasOwnProperty;
function Ri(e) {
	if (!Pn(e)) return Ii(e);
	var t = ki(e), n = [];
	for (var r in e) r == "constructor" && (t || !Li.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region ../../node_modules/lodash-es/keysIn.js
function zi(e) {
	return Ni(e) ? Di(e, !0) : Ri(e);
}
//#endregion
//#region ../../node_modules/lodash-es/_baseAssignIn.js
function Bi(e, t) {
	return e && kr(t, zi(t), e);
}
//#endregion
//#region ../../node_modules/lodash-es/_cloneBuffer.js
var Vi = typeof exports == "object" && exports && !exports.nodeType && exports, Hi = Vi && typeof module == "object" && module && !module.nodeType && module, Ui = Hi && Hi.exports === Vi ? Zt.Buffer : void 0, Wi = Ui ? Ui.allocUnsafe : void 0;
function Gi(e, t) {
	if (t) return e.slice();
	var n = e.length, r = Wi ? Wi(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region ../../node_modules/lodash-es/_copyArray.js
function Ki(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region ../../node_modules/lodash-es/_arrayFilter.js
function qi(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region ../../node_modules/lodash-es/stubArray.js
function Ji() {
	return [];
}
//#endregion
//#region ../../node_modules/lodash-es/_getSymbols.js
var Yi = Object.prototype.propertyIsEnumerable, Xi = Object.getOwnPropertySymbols, Zi = Xi ? function(e) {
	return e == null ? [] : (e = Object(e), qi(Xi(e), function(t) {
		return Yi.call(e, t);
	}));
} : Ji;
//#endregion
//#region ../../node_modules/lodash-es/_copySymbols.js
function Qi(e, t) {
	return kr(e, Zi(e), t);
}
//#endregion
//#region ../../node_modules/lodash-es/_arrayPush.js
function $i(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region ../../node_modules/lodash-es/_getSymbolsIn.js
var ea = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) $i(t, Zi(e)), e = fn(e);
	return t;
} : Ji;
//#endregion
//#region ../../node_modules/lodash-es/_copySymbolsIn.js
function ta(e, t) {
	return kr(e, ea(e), t);
}
//#endregion
//#region ../../node_modules/lodash-es/_baseGetAllKeys.js
function na(e, t, n) {
	var r = t(e);
	return Lr(e) ? r : $i(r, n(e));
}
//#endregion
//#region ../../node_modules/lodash-es/_getAllKeys.js
function ra(e) {
	return na(e, Pi, Zi);
}
//#endregion
//#region ../../node_modules/lodash-es/_getAllKeysIn.js
function ia(e) {
	return na(e, zi, ea);
}
//#endregion
//#region ../../node_modules/lodash-es/_DataView.js
var aa = er(Zt, "DataView"), oa = er(Zt, "Promise"), sa = er(Zt, "Set"), ca = er(Zt, "WeakMap"), la = "[object Map]", ua = "[object Object]", da = "[object Promise]", fa = "[object Set]", pa = "[object WeakMap]", ma = "[object DataView]", ha = Wn(aa), ga = Wn(tr), _a = Wn(oa), va = Wn(sa), ya = Wn(ca), ba = un;
(aa && ba(new aa(/* @__PURE__ */ new ArrayBuffer(1))) != ma || tr && ba(new tr()) != la || oa && ba(oa.resolve()) != da || sa && ba(new sa()) != fa || ca && ba(new ca()) != pa) && (ba = function(e) {
	var t = un(e), n = t == ua ? e.constructor : void 0, r = n ? Wn(n) : "";
	if (r) switch (r) {
		case ha: return ma;
		case ga: return la;
		case _a: return da;
		case va: return fa;
		case ya: return pa;
	}
	return t;
});
var xa = ba, Sa = Object.prototype.hasOwnProperty;
function Ca(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && Sa.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region ../../node_modules/lodash-es/_Uint8Array.js
var wa = Zt.Uint8Array;
//#endregion
//#region ../../node_modules/lodash-es/_cloneArrayBuffer.js
function Ta(e) {
	var t = new e.constructor(e.byteLength);
	return new wa(t).set(new wa(e)), t;
}
//#endregion
//#region ../../node_modules/lodash-es/_cloneDataView.js
function Ea(e, t) {
	var n = t ? Ta(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region ../../node_modules/lodash-es/_cloneRegExp.js
var Da = /\w*$/;
function Oa(e) {
	var t = new e.constructor(e.source, Da.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region ../../node_modules/lodash-es/_cloneSymbol.js
var ka = Qt ? Qt.prototype : void 0, Aa = ka ? ka.valueOf : void 0;
function ja(e) {
	return Aa ? Object(Aa.call(e)) : {};
}
//#endregion
//#region ../../node_modules/lodash-es/_cloneTypedArray.js
function Ma(e, t) {
	var n = t ? Ta(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region ../../node_modules/lodash-es/_initCloneByTag.js
var Na = "[object Boolean]", Pa = "[object Date]", Fa = "[object Map]", Ia = "[object Number]", La = "[object RegExp]", Ra = "[object Set]", za = "[object String]", Ba = "[object Symbol]", Va = "[object ArrayBuffer]", Ha = "[object DataView]", Ua = "[object Float32Array]", Wa = "[object Float64Array]", Ga = "[object Int8Array]", Ka = "[object Int16Array]", qa = "[object Int32Array]", Ja = "[object Uint8Array]", Ya = "[object Uint8ClampedArray]", Xa = "[object Uint16Array]", Za = "[object Uint32Array]";
function Qa(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case Va: return Ta(e);
		case Na:
		case Pa: return new r(+e);
		case Ha: return Ea(e, n);
		case Ua:
		case Wa:
		case Ga:
		case Ka:
		case qa:
		case Ja:
		case Ya:
		case Xa:
		case Za: return Ma(e, n);
		case Fa: return new r();
		case Ia:
		case za: return new r(e);
		case La: return Oa(e);
		case Ra: return new r();
		case Ba: return ja(e);
	}
}
//#endregion
//#region ../../node_modules/lodash-es/_baseCreate.js
var $a = Object.create, eo = function() {
	function e() {}
	return function(t) {
		if (!Pn(t)) return {};
		if ($a) return $a(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region ../../node_modules/lodash-es/_initCloneObject.js
function to(e) {
	return typeof e.constructor == "function" && !ki(e) ? eo(fn(e)) : {};
}
//#endregion
//#region ../../node_modules/lodash-es/_baseIsMap.js
var no = "[object Map]";
function ro(e) {
	return pn(e) && xa(e) == no;
}
//#endregion
//#region ../../node_modules/lodash-es/isMap.js
var io = Ci && Ci.isMap, ao = io ? yi(io) : ro, oo = "[object Set]";
function so(e) {
	return pn(e) && xa(e) == oo;
}
//#endregion
//#region ../../node_modules/lodash-es/isSet.js
var co = Ci && Ci.isSet, lo = co ? yi(co) : so, uo = 1, fo = 2, po = 4, mo = "[object Arguments]", ho = "[object Array]", go = "[object Boolean]", _o = "[object Date]", vo = "[object Error]", yo = "[object Function]", bo = "[object GeneratorFunction]", xo = "[object Map]", So = "[object Number]", Co = "[object Object]", wo = "[object RegExp]", To = "[object Set]", Eo = "[object String]", Do = "[object Symbol]", Oo = "[object WeakMap]", ko = "[object ArrayBuffer]", Ao = "[object DataView]", jo = "[object Float32Array]", Mo = "[object Float64Array]", No = "[object Int8Array]", Po = "[object Int16Array]", Fo = "[object Int32Array]", Io = "[object Uint8Array]", Lo = "[object Uint8ClampedArray]", Ro = "[object Uint16Array]", zo = "[object Uint32Array]", V = {};
V[mo] = V[ho] = V[ko] = V[Ao] = V[go] = V[_o] = V[jo] = V[Mo] = V[No] = V[Po] = V[Fo] = V[xo] = V[So] = V[Co] = V[wo] = V[To] = V[Eo] = V[Do] = V[Io] = V[Lo] = V[Ro] = V[zo] = !0, V[vo] = V[yo] = V[Oo] = !1;
function Bo(e, t, n, r, i, a) {
	var o, s = t & uo, c = t & fo, l = t & po;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!Pn(e)) return e;
	var u = Lr(e);
	if (u) {
		if (o = Ca(e), !s) return Ki(e, o);
	} else {
		var d = xa(e), f = d == yo || d == bo;
		if (Hr(e)) return Gi(e, s);
		if (d == Co || d == mo || f && !i) {
			if (o = c || f ? {} : to(e), !s) return c ? ta(e, Bi(o, e)) : Qi(e, Fi(o, e));
		} else {
			if (!V[d]) return i ? e : {};
			o = Qa(e, d, s);
		}
	}
	a ||= new Cr();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), lo(e) ? e.forEach(function(r) {
		o.add(Bo(r, t, n, r, e, a));
	}) : ao(e) && e.forEach(function(r, i) {
		o.set(i, Bo(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? ia : ra : c ? zi : Pi)(e);
	return wr(m || e, function(r, i) {
		m && (i = r, r = e[i]), Or(o, i, Bo(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region ../../node_modules/lodash-es/cloneDeep.js
var Vo = 1, Ho = 4;
function Uo(e) {
	return Bo(e, Vo | Ho);
}
//#endregion
//#region ../../node_modules/react-fast-compare/index.js
var Wo = /* @__PURE__ */ re(((e, t) => {
	var n = Array.isArray, r = Object.keys, i = Object.prototype.hasOwnProperty, a = typeof Element < "u";
	function o(e, t) {
		if (e === t) return !0;
		if (e && t && typeof e == "object" && typeof t == "object") {
			var s = n(e), c = n(t), l, u, d;
			if (s && c) {
				if (u = e.length, u != t.length) return !1;
				for (l = u; l-- !== 0;) if (!o(e[l], t[l])) return !1;
				return !0;
			}
			if (s != c) return !1;
			var f = e instanceof Date, p = t instanceof Date;
			if (f != p) return !1;
			if (f && p) return e.getTime() == t.getTime();
			var m = e instanceof RegExp, h = t instanceof RegExp;
			if (m != h) return !1;
			if (m && h) return e.toString() == t.toString();
			var g = r(e);
			if (u = g.length, u !== r(t).length) return !1;
			for (l = u; l-- !== 0;) if (!i.call(t, g[l])) return !1;
			if (a && e instanceof Element && t instanceof Element) return e === t;
			for (l = u; l-- !== 0;) if (d = g[l], !(d === "_owner" && e.$$typeof) && !o(e[d], t[d])) return !1;
			return !0;
		}
		return e !== e && t !== t;
	}
	t.exports = function(e, t) {
		try {
			return o(e, t);
		} catch (e) {
			if (e.message && e.message.match(/stack|recursion/i) || e.number === -2146828260) return console.warn("Warning: react-fast-compare does not handle circular references.", e.name, e.message), !1;
			throw e;
		}
	};
}));
//#endregion
//#region ../../node_modules/tiny-warning/dist/tiny-warning.esm.js
It();
var Go = z.env.NODE_ENV === "production";
function H(e, t) {
	if (!Go) {
		if (e) return;
		var n = "Warning: " + t;
		typeof console < "u" && console.warn(n);
		try {
			throw Error(n);
		} catch {}
	}
}
//#endregion
//#region ../../node_modules/lodash-es/clone.js
var Ko = 4;
function qo(e) {
	return Bo(e, Ko);
}
//#endregion
//#region ../../node_modules/lodash-es/_arrayMap.js
function Jo(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region ../../node_modules/lodash-es/isSymbol.js
var Yo = "[object Symbol]";
function Xo(e) {
	return typeof e == "symbol" || pn(e) && un(e) == Yo;
}
//#endregion
//#region ../../node_modules/lodash-es/memoize.js
var Zo = "Expected a function";
function Qo(e, t) {
	if (typeof e != "function" || t != null && typeof t != "function") throw TypeError(Zo);
	var n = function() {
		var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
		if (a.has(i)) return a.get(i);
		var o = e.apply(this, r);
		return n.cache = a.set(i, o) || a, o;
	};
	return n.cache = new (Qo.Cache || br)(), n;
}
Qo.Cache = br;
//#endregion
//#region ../../node_modules/lodash-es/_memoizeCapped.js
var $o = 500;
function es(e) {
	var t = Qo(e, function(e) {
		return n.size === $o && n.clear(), e;
	}), n = t.cache;
	return t;
}
//#endregion
//#region ../../node_modules/lodash-es/_stringToPath.js
var ts = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ns = /\\(\\)?/g, rs = es(function(e) {
	var t = [];
	return e.charCodeAt(0) === 46 && t.push(""), e.replace(ts, function(e, n, r, i) {
		t.push(r ? i.replace(ns, "$1") : n || e);
	}), t;
}), is = Infinity;
function as(e) {
	if (typeof e == "string" || Xo(e)) return e;
	var t = e + "";
	return t == "0" && 1 / e == -is ? "-0" : t;
}
//#endregion
//#region ../../node_modules/lodash-es/_baseToString.js
var os = Infinity, ss = Qt ? Qt.prototype : void 0, cs = ss ? ss.toString : void 0;
function ls(e) {
	if (typeof e == "string") return e;
	if (Lr(e)) return Jo(e, ls) + "";
	if (Xo(e)) return cs ? cs.call(e) : "";
	var t = e + "";
	return t == "0" && 1 / e == -os ? "-0" : t;
}
//#endregion
//#region ../../node_modules/lodash-es/toString.js
function us(e) {
	return e == null ? "" : ls(e);
}
//#endregion
//#region ../../node_modules/lodash-es/toPath.js
function ds(e) {
	return Lr(e) ? Jo(e, as) : Xo(e) ? [e] : Ki(rs(us(e)));
}
//#endregion
//#region ../../node_modules/react-is/cjs/react-is.production.min.js
var fs = /* @__PURE__ */ re(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), ps = /* @__PURE__ */ re(((e) => {
	It(), z.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, ee = i, te = h, ne = m, re = r, O = o, k = a, A = f, ie = !1;
		function ae(e) {
			return ie || (ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), oe(e) || x(e) === l;
		}
		function oe(e) {
			return x(e) === u;
		}
		function se(e) {
			return x(e) === c;
		}
		function j(e) {
			return x(e) === s;
		}
		function M(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function ce(e) {
			return x(e) === d;
		}
		function le(e) {
			return x(e) === i;
		}
		function N(e) {
			return x(e) === h;
		}
		function ue(e) {
			return x(e) === m;
		}
		function de(e) {
			return x(e) === r;
		}
		function fe(e) {
			return x(e) === o;
		}
		function pe(e) {
			return x(e) === a;
		}
		function me(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = ee, e.Lazy = te, e.Memo = ne, e.Portal = re, e.Profiler = O, e.StrictMode = k, e.Suspense = A, e.isAsyncMode = ae, e.isConcurrentMode = oe, e.isContextConsumer = se, e.isContextProvider = j, e.isElement = M, e.isForwardRef = ce, e.isFragment = le, e.isLazy = N, e.isMemo = ue, e.isPortal = de, e.isProfiler = fe, e.isStrictMode = pe, e.isSuspense = me, e.isValidElementType = b, e.typeOf = x;
	})();
})), ms = /* @__PURE__ */ re(((e, t) => {
	It(), z.env.NODE_ENV === "production" ? t.exports = fs() : t.exports = ps();
})), hs = /* @__PURE__ */ re(((e, t) => {
	var n = ms(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
}));
//#endregion
//#region ../../node_modules/formik/dist/formik.esm.js
It();
var gs = /* @__PURE__ */ A(Wo()), _s = /* @__PURE__ */ A(hs());
function U() {
	return U = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, U.apply(this, arguments);
}
function vs(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function ys(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
function bs(e) {
	if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
var xs = /* @__PURE__ */ a(void 0);
xs.displayName = "FormikContext";
var Ss = xs.Provider, Cs = xs.Consumer;
function ws() {
	var e = u(xs);
	return !e && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.")), e;
}
var Ts = function(e) {
	return Array.isArray(e) && e.length === 0;
}, W = function(e) {
	return typeof e == "function";
}, Es = function(e) {
	return typeof e == "object" && !!e;
}, Ds = function(e) {
	return String(Math.floor(Number(e))) === e;
}, Os = function(e) {
	return Object.prototype.toString.call(e) === "[object String]";
}, ks = function(e) {
	return n.count(e) === 0;
}, As = function(e) {
	return Es(e) && W(e.then);
};
function js(e) {
	if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
	try {
		return e.activeElement || e.body;
	} catch {
		return e.body;
	}
}
function G(e, t, n, r) {
	r === void 0 && (r = 0);
	for (var i = ds(t); e && r < i.length;) e = e[i[r++]];
	return r !== i.length && !e || e === void 0 ? n : e;
}
function Ms(e, t, n) {
	for (var r = qo(e), i = r, a = 0, o = ds(t); a < o.length - 1; a++) {
		var s = o[a], c = G(e, o.slice(0, a + 1));
		if (c && (Es(c) || Array.isArray(c))) i = i[s] = qo(c);
		else {
			var l = o[a + 1];
			i = i[s] = Ds(l) && Number(l) >= 0 ? [] : {};
		}
	}
	return (a === 0 ? e : i)[o[a]] === n ? e : (n === void 0 ? delete i[o[a]] : i[o[a]] = n, a === 0 && n === void 0 && delete r[o[a]], r);
}
function Ns(e, t, n, r) {
	n === void 0 && (n = /* @__PURE__ */ new WeakMap()), r === void 0 && (r = {});
	for (var i = 0, a = Object.keys(e); i < a.length; i++) {
		var o = a[i], s = e[o];
		Es(s) ? n.get(s) || (n.set(s, !0), r[o] = Array.isArray(s) ? [] : {}, Ns(s, t, n, r[o])) : r[o] = t;
	}
	return r;
}
function Ps(e, t) {
	switch (t.type) {
		case "SET_VALUES": return U({}, e, { values: t.payload });
		case "SET_TOUCHED": return U({}, e, { touched: t.payload });
		case "SET_ERRORS": return (0, gs.default)(e.errors, t.payload) ? e : U({}, e, { errors: t.payload });
		case "SET_STATUS": return U({}, e, { status: t.payload });
		case "SET_ISSUBMITTING": return U({}, e, { isSubmitting: t.payload });
		case "SET_ISVALIDATING": return U({}, e, { isValidating: t.payload });
		case "SET_FIELD_VALUE": return U({}, e, { values: Ms(e.values, t.payload.field, t.payload.value) });
		case "SET_FIELD_TOUCHED": return U({}, e, { touched: Ms(e.touched, t.payload.field, t.payload.value) });
		case "SET_FIELD_ERROR": return U({}, e, { errors: Ms(e.errors, t.payload.field, t.payload.value) });
		case "RESET_FORM": return U({}, e, t.payload);
		case "SET_FORMIK_STATE": return t.payload(e);
		case "SUBMIT_ATTEMPT": return U({}, e, {
			touched: Ns(e.values, !0),
			isSubmitting: !0,
			submitCount: e.submitCount + 1
		});
		case "SUBMIT_FAILURE": return U({}, e, { isSubmitting: !1 });
		case "SUBMIT_SUCCESS": return U({}, e, { isSubmitting: !1 });
		default: return e;
	}
}
var Fs = {}, Is = {};
function Ls(e) {
	var t = e.validateOnChange, n = t === void 0 ? !0 : t, r = e.validateOnBlur, i = r === void 0 ? !0 : r, a = e.validateOnMount, o = a === void 0 ? !1 : a, s = e.isInitialValid, c = e.enableReinitialize, u = c === void 0 ? !1 : c, f = e.onSubmit, p = ys(e, [
		"validateOnChange",
		"validateOnBlur",
		"validateOnMount",
		"isInitialValid",
		"enableReinitialize",
		"onSubmit"
	]), m = U({
		validateOnChange: n,
		validateOnBlur: i,
		validateOnMount: o,
		onSubmit: f
	}, p), h = _(m.initialValues), y = _(m.initialErrors || Fs), b = _(m.initialTouched || Is), x = _(m.initialStatus), S = _(!1), C = _({});
	z.env.NODE_ENV !== "production" && d(function() {
		s !== void 0 && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead."));
	}, []), d(function() {
		return S.current = !0, function() {
			S.current = !1;
		};
	}, []);
	var w = v(0)[1], T = _({
		values: Uo(m.initialValues),
		errors: Uo(m.initialErrors) || Fs,
		touched: Uo(m.initialTouched) || Is,
		status: Uo(m.initialStatus),
		isSubmitting: !1,
		isValidating: !1,
		submitCount: 0
	}), E = T.current, D = l(function(e) {
		var t = T.current;
		T.current = Ps(t, e), t !== T.current && w(function(e) {
			return e + 1;
		});
	}, []), ee = l(function(e, t) {
		return new Promise(function(n, r) {
			var i = m.validate(e, t);
			i == null ? n(Fs) : As(i) ? i.then(function(e) {
				n(e || Fs);
			}, function(e) {
				z.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", e), r(e);
			}) : n(i);
		});
	}, [m.validate]), te = l(function(e, t) {
		var n = m.validationSchema, r = W(n) ? n(t) : n, i = t && r.validateAt ? r.validateAt(t, e) : Vs(e, r);
		return new Promise(function(e, t) {
			i.then(function() {
				e(Fs);
			}, function(n) {
				n.name === "ValidationError" ? e(Bs(n)) : (z.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", n), t(n));
			});
		});
	}, [m.validationSchema]), ne = l(function(e, t) {
		return new Promise(function(n) {
			return n(C.current[e].validate(t));
		});
	}, []), re = l(function(e) {
		var t = Object.keys(C.current).filter(function(e) {
			return W(C.current[e].validate);
		}), n = t.length > 0 ? t.map(function(t) {
			return ne(t, G(e, t));
		}) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
		return Promise.all(n).then(function(e) {
			return e.reduce(function(e, n, r) {
				return n === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || n && (e = Ms(e, t[r], n)), e;
			}, {});
		});
	}, [ne]), O = l(function(e) {
		return Promise.all([
			re(e),
			m.validationSchema ? te(e) : {},
			m.validate ? ee(e) : {}
		]).then(function(e) {
			var t = e[0], n = e[1], r = e[2];
			return qt.all([
				t,
				n,
				r
			], { arrayMerge: Us });
		});
	}, [
		m.validate,
		m.validationSchema,
		re,
		ee,
		te
	]), k = qs(function(e) {
		return e === void 0 && (e = E.values), D({
			type: "SET_ISVALIDATING",
			payload: !0
		}), O(e).then(function(e) {
			return S.current && (D({
				type: "SET_ISVALIDATING",
				payload: !1
			}), D({
				type: "SET_ERRORS",
				payload: e
			})), e;
		});
	});
	d(function() {
		o && S.current === !0 && (0, gs.default)(h.current, m.initialValues) && k(h.current);
	}, [o, k]);
	var A = l(function(e) {
		var t = e && e.values ? e.values : h.current, n = e && e.errors ? e.errors : y.current ? y.current : m.initialErrors || {}, r = e && e.touched ? e.touched : b.current ? b.current : m.initialTouched || {}, i = e && e.status ? e.status : x.current ? x.current : m.initialStatus;
		h.current = t, y.current = n, b.current = r, x.current = i;
		var a = function() {
			D({
				type: "RESET_FORM",
				payload: {
					isSubmitting: !!e && !!e.isSubmitting,
					errors: n,
					touched: r,
					status: i,
					values: t,
					isValidating: !!e && !!e.isValidating,
					submitCount: e && e.submitCount && typeof e.submitCount == "number" ? e.submitCount : 0
				}
			});
		};
		if (m.onReset) {
			var o = m.onReset(E.values, ye);
			As(o) ? o.then(a) : a();
		} else a();
	}, [
		m.initialErrors,
		m.initialStatus,
		m.initialTouched,
		m.onReset
	]);
	d(function() {
		S.current === !0 && !(0, gs.default)(h.current, m.initialValues) && u && (h.current = m.initialValues, A(), o && k(h.current));
	}, [
		u,
		m.initialValues,
		A,
		o,
		k
	]), d(function() {
		u && S.current === !0 && !(0, gs.default)(y.current, m.initialErrors) && (y.current = m.initialErrors || Fs, D({
			type: "SET_ERRORS",
			payload: m.initialErrors || Fs
		}));
	}, [u, m.initialErrors]), d(function() {
		u && S.current === !0 && !(0, gs.default)(b.current, m.initialTouched) && (b.current = m.initialTouched || Is, D({
			type: "SET_TOUCHED",
			payload: m.initialTouched || Is
		}));
	}, [u, m.initialTouched]), d(function() {
		u && S.current === !0 && !(0, gs.default)(x.current, m.initialStatus) && (x.current = m.initialStatus, D({
			type: "SET_STATUS",
			payload: m.initialStatus
		}));
	}, [
		u,
		m.initialStatus,
		m.initialTouched
	]);
	var ie = qs(function(e) {
		if (C.current[e] && W(C.current[e].validate)) {
			var t = G(E.values, e), n = C.current[e].validate(t);
			return As(n) ? (D({
				type: "SET_ISVALIDATING",
				payload: !0
			}), n.then(function(e) {
				return e;
			}).then(function(t) {
				D({
					type: "SET_FIELD_ERROR",
					payload: {
						field: e,
						value: t
					}
				}), D({
					type: "SET_ISVALIDATING",
					payload: !1
				});
			})) : (D({
				type: "SET_FIELD_ERROR",
				payload: {
					field: e,
					value: n
				}
			}), Promise.resolve(n));
		} else if (m.validationSchema) return D({
			type: "SET_ISVALIDATING",
			payload: !0
		}), te(E.values, e).then(function(e) {
			return e;
		}).then(function(t) {
			D({
				type: "SET_FIELD_ERROR",
				payload: {
					field: e,
					value: G(t, e)
				}
			}), D({
				type: "SET_ISVALIDATING",
				payload: !1
			});
		});
		return Promise.resolve();
	}), ae = l(function(e, t) {
		var n = t.validate;
		C.current[e] = { validate: n };
	}, []), oe = l(function(e) {
		delete C.current[e];
	}, []), se = qs(function(e, t) {
		return D({
			type: "SET_TOUCHED",
			payload: e
		}), (t === void 0 ? i : t) ? k(E.values) : Promise.resolve();
	}), j = l(function(e) {
		D({
			type: "SET_ERRORS",
			payload: e
		});
	}, []), M = qs(function(e, t) {
		var r = W(e) ? e(E.values) : e;
		return D({
			type: "SET_VALUES",
			payload: r
		}), (t === void 0 ? n : t) ? k(r) : Promise.resolve();
	}), ce = l(function(e, t) {
		D({
			type: "SET_FIELD_ERROR",
			payload: {
				field: e,
				value: t
			}
		});
	}, []), le = qs(function(e, t, r) {
		return D({
			type: "SET_FIELD_VALUE",
			payload: {
				field: e,
				value: t
			}
		}), (r === void 0 ? n : r) ? k(Ms(E.values, e, t)) : Promise.resolve();
	}), N = l(function(e, t) {
		var n = t, r = e, i;
		if (!Os(e)) {
			e.persist && e.persist();
			var a = e.target ? e.target : e.currentTarget, o = a.type, s = a.name, c = a.id, l = a.value, u = a.checked, d = a.outerHTML, f = a.options, p = a.multiple;
			n = t || s || c, !n && z.env.NODE_ENV !== "production" && zs({
				htmlContent: d,
				documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
				handlerName: "handleChange"
			}), r = /number|range/.test(o) ? (i = parseFloat(l), isNaN(i) ? "" : i) : /checkbox/.test(o) ? Gs(G(E.values, n), u, l) : f && p ? Ws(f) : l;
		}
		n && le(n, r);
	}, [le, E.values]), ue = qs(function(e) {
		if (Os(e)) return function(t) {
			return N(t, e);
		};
		N(e);
	}), de = qs(function(e, t, n) {
		return t === void 0 && (t = !0), D({
			type: "SET_FIELD_TOUCHED",
			payload: {
				field: e,
				value: t
			}
		}), (n === void 0 ? i : n) ? k(E.values) : Promise.resolve();
	}), fe = l(function(e, t) {
		e.persist && e.persist();
		var n = e.target, r = n.name, i = n.id, a = n.outerHTML, o = t || r || i;
		!o && z.env.NODE_ENV !== "production" && zs({
			htmlContent: a,
			documentationAnchorLink: "handleblur-e-any--void",
			handlerName: "handleBlur"
		}), de(o, !0);
	}, [de]), pe = qs(function(e) {
		if (Os(e)) return function(t) {
			return fe(t, e);
		};
		fe(e);
	}), me = l(function(e) {
		W(e) ? D({
			type: "SET_FORMIK_STATE",
			payload: e
		}) : D({
			type: "SET_FORMIK_STATE",
			payload: function() {
				return e;
			}
		});
	}, []), he = l(function(e) {
		D({
			type: "SET_STATUS",
			payload: e
		});
	}, []), ge = l(function(e) {
		D({
			type: "SET_ISSUBMITTING",
			payload: e
		});
	}, []), _e = qs(function() {
		return D({ type: "SUBMIT_ATTEMPT" }), k().then(function(e) {
			var t = e instanceof Error;
			if (!t && Object.keys(e).length === 0) {
				var n;
				try {
					if (n = be(), n === void 0) return;
				} catch (e) {
					throw e;
				}
				return Promise.resolve(n).then(function(e) {
					return S.current && D({ type: "SUBMIT_SUCCESS" }), e;
				}).catch(function(e) {
					if (S.current) throw D({ type: "SUBMIT_FAILURE" }), e;
				});
			} else if (S.current && (D({ type: "SUBMIT_FAILURE" }), t)) throw e;
		});
	}), ve = qs(function(e) {
		if (e && e.preventDefault && W(e.preventDefault) && e.preventDefault(), e && e.stopPropagation && W(e.stopPropagation) && e.stopPropagation(), z.env.NODE_ENV !== "production" && typeof document < "u") {
			var t = js();
			t !== null && t instanceof HTMLButtonElement && !(t.attributes && t.attributes.getNamedItem("type")) && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type=\"submit\"`. If this is not a submit button, please add `type=\"button\"`."));
		}
		_e().catch(function(e) {
			console.warn("Warning: An unhandled error was caught from submitForm()", e);
		});
	}), ye = {
		resetForm: A,
		validateForm: k,
		validateField: ie,
		setErrors: j,
		setFieldError: ce,
		setFieldTouched: de,
		setFieldValue: le,
		setStatus: he,
		setSubmitting: ge,
		setTouched: se,
		setValues: M,
		setFormikState: me,
		submitForm: _e
	}, be = qs(function() {
		return f(E.values, ye);
	}), xe = qs(function(e) {
		e && e.preventDefault && W(e.preventDefault) && e.preventDefault(), e && e.stopPropagation && W(e.stopPropagation) && e.stopPropagation(), A();
	}), Se = l(function(e) {
		return {
			value: G(E.values, e),
			error: G(E.errors, e),
			touched: !!G(E.touched, e),
			initialValue: G(h.current, e),
			initialTouched: !!G(b.current, e),
			initialError: G(y.current, e)
		};
	}, [
		E.errors,
		E.touched,
		E.values
	]), Ce = l(function(e) {
		return {
			setValue: function(t, n) {
				return le(e, t, n);
			},
			setTouched: function(t, n) {
				return de(e, t, n);
			},
			setError: function(t) {
				return ce(e, t);
			}
		};
	}, [
		le,
		de,
		ce
	]), P = l(function(e) {
		var t = Es(e), n = t ? e.name : e, r = G(E.values, n), i = {
			name: n,
			value: r,
			onChange: ue,
			onBlur: pe
		};
		if (t) {
			var a = e.type, o = e.value, s = e.as, c = e.multiple;
			a === "checkbox" ? o === void 0 ? i.checked = !!r : (i.checked = !!(Array.isArray(r) && ~r.indexOf(o)), i.value = o) : a === "radio" ? (i.checked = r === o, i.value = o) : s === "select" && c && (i.value = i.value || [], i.multiple = !0);
		}
		return i;
	}, [
		pe,
		ue,
		E.values
	]), we = g(function() {
		return !(0, gs.default)(h.current, E.values);
	}, [h.current, E.values]), Te = g(function() {
		return s === void 0 || we ? E.errors && Object.keys(E.errors).length === 0 : s !== !1 && W(s) ? s(m) : s;
	}, [
		s,
		we,
		E.errors,
		m
	]);
	return U({}, E, {
		initialValues: h.current,
		initialErrors: y.current,
		initialTouched: b.current,
		initialStatus: x.current,
		handleBlur: pe,
		handleChange: ue,
		handleReset: xe,
		handleSubmit: ve,
		resetForm: A,
		setErrors: j,
		setFormikState: me,
		setFieldTouched: de,
		setFieldValue: le,
		setFieldError: ce,
		setStatus: he,
		setSubmitting: ge,
		setTouched: se,
		setValues: M,
		submitForm: _e,
		validateForm: k,
		validateField: ie,
		isValid: Te,
		dirty: we,
		unregisterField: oe,
		registerField: ae,
		getFieldProps: P,
		getFieldMeta: Se,
		getFieldHelpers: Ce,
		validateOnBlur: i,
		validateOnChange: n,
		validateOnMount: o
	});
}
function Rs(e) {
	var t = Ls(e), r = e.component, i = e.children, a = e.render, s = e.innerRef;
	return p(s, function() {
		return t;
	}), z.env.NODE_ENV !== "production" && d(function() {
		e.render && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>"));
	}, []), o(Ss, { value: t }, r ? o(r, t) : a ? a(t) : i ? W(i) ? i(t) : ks(i) ? null : n.only(i) : null);
}
function zs(e) {
	var t = e.htmlContent, n = e.documentationAnchorLink, r = e.handlerName;
	console.warn("Warning: Formik called `" + r + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + t + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + n + "\n  ");
}
function Bs(e) {
	var t = {};
	if (e.inner) {
		if (e.inner.length === 0) return Ms(t, e.path, e.message);
		for (var n = e.inner, r = Array.isArray(n), i = 0, n = r ? n : n[Symbol.iterator]();;) {
			var a;
			if (r) {
				if (i >= n.length) break;
				a = n[i++];
			} else {
				if (i = n.next(), i.done) break;
				a = i.value;
			}
			var o = a;
			G(t, o.path) || (t = Ms(t, o.path, o.message));
		}
	}
	return t;
}
function Vs(e, t, n, r) {
	n === void 0 && (n = !1);
	var i = Hs(e);
	return t[n ? "validateSync" : "validate"](i, {
		abortEarly: !1,
		context: r || i
	});
}
function Hs(e) {
	var t = Array.isArray(e) ? [] : {};
	for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
		var r = String(n);
		Array.isArray(e[r]) === !0 ? t[r] = e[r].map(function(e) {
			return Array.isArray(e) === !0 || bn(e) ? Hs(e) : e === "" ? void 0 : e;
		}) : bn(e[r]) ? t[r] = Hs(e[r]) : t[r] = e[r] === "" ? void 0 : e[r];
	}
	return t;
}
function Us(e, t, n) {
	var r = e.slice();
	return t.forEach(function(t, i) {
		r[i] === void 0 ? r[i] = n.clone !== !1 && n.isMergeableObject(t) ? qt(Array.isArray(t) ? [] : {}, t, n) : t : n.isMergeableObject(t) ? r[i] = qt(e[i], t, n) : e.indexOf(t) === -1 && r.push(t);
	}), r;
}
function Ws(e) {
	return Array.from(e).filter(function(e) {
		return e.selected;
	}).map(function(e) {
		return e.value;
	});
}
function Gs(e, t, n) {
	if (typeof e == "boolean") return !!t;
	var r = [], i = !1, a = -1;
	if (Array.isArray(e)) r = e, a = e.indexOf(n), i = a >= 0;
	else if (!n || n == "true" || n == "false") return !!t;
	return t && n && !i ? r.concat(n) : i ? r.slice(0, a).concat(r.slice(a + 1)) : r;
}
var Ks = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? h : d;
function qs(e) {
	var t = _(e);
	return Ks(function() {
		t.current = e;
	}), l(function() {
		var e = [...arguments];
		return t.current.apply(void 0, e);
	}, []);
}
function Js(e) {
	var t = ws(), n = t.getFieldProps, r = t.getFieldMeta, i = t.getFieldHelpers, a = t.registerField, o = t.unregisterField, s = Es(e) ? e : { name: e }, c = s.name, l = s.validate;
	d(function() {
		return c && a(c, { validate: l }), function() {
			c && o(c);
		};
	}, [
		a,
		o,
		c,
		l
	]), z.env.NODE_ENV !== "production" && !t && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component")), !c && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "Invalid field name. Either pass `useField` a string or an object containing a `name` key."));
	var u = g(function() {
		return i(c);
	}, [i, c]);
	return [
		n(s),
		r(c),
		u
	];
}
function Ys(e) {
	var t = e.validate, n = e.name, r = e.render, i = e.children, a = e.as, s = e.component, c = e.className, l = ys(e, [
		"validate",
		"name",
		"render",
		"children",
		"as",
		"component",
		"className"
	]), u = ys(ws(), ["validate", "validationSchema"]);
	z.env.NODE_ENV !== "production" && d(function() {
		r && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + n + "\" render={({field, form}) => ...} /> with <Field name=\"" + n + "\">{({field, form, meta}) => ...}</Field>")), a && i && W(i) && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.")), s && i && W(i) && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.")), r && i && !ks(i) && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored"));
	}, []);
	var f = u.registerField, p = u.unregisterField;
	d(function() {
		return f(n, { validate: t }), function() {
			p(n);
		};
	}, [
		f,
		p,
		n,
		t
	]);
	var m = u.getFieldProps(U({ name: n }, l)), h = u.getFieldMeta(n), g = {
		field: m,
		form: u
	};
	if (r) return r(U({}, g, { meta: h }));
	if (W(i)) return i(U({}, g, { meta: h }));
	if (s) {
		if (typeof s == "string") {
			var _ = l.innerRef, v = ys(l, ["innerRef"]);
			return o(s, U({ ref: _ }, m, v, { className: c }), i);
		}
		return o(s, U({
			field: m,
			form: u
		}, l, { className: c }), i);
	}
	var y = a || "input";
	if (typeof y == "string") {
		var b = l.innerRef, x = ys(l, ["innerRef"]);
		return o(y, U({ ref: b }, m, x, { className: c }), i);
	}
	return o(y, U({}, m, l, { className: c }), i);
}
var Xs = /* @__PURE__ */ s(function(e, t) {
	var n = e.action, r = ys(e, ["action"]), i = n ?? "#", a = ws(), s = a.handleReset, c = a.handleSubmit;
	return o("form", U({
		onSubmit: c,
		ref: t,
		onReset: s,
		action: i
	}, r));
});
Xs.displayName = "Form";
function Zs(e) {
	var t = function(t) {
		return o(Cs, null, function(n) {
			return !n && (z.env.NODE_ENV === "production" ? H(!1) : H(!1, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + e.name)), o(e, U({}, t, { formik: n }));
		});
	}, n = e.displayName || e.name || e.constructor && e.constructor.name || "Component";
	return t.WrappedComponent = e, t.displayName = "FormikConnect(" + n + ")", (0, _s.default)(t, e);
}
var Qs = function(e, t, n) {
	var r = nc(e), i = r[t];
	return r.splice(t, 1), r.splice(n, 0, i), r;
}, $s = function(e, t, n) {
	var r = nc(e), i = r[t];
	return r[t] = r[n], r[n] = i, r;
}, ec = function(e, t, n) {
	var r = nc(e);
	return r.splice(t, 0, n), r;
}, tc = function(e, t, n) {
	var r = nc(e);
	return r[t] = n, r;
}, nc = function(e) {
	if (!e) return [];
	if (Array.isArray(e)) return [].concat(e);
	var t = Object.keys(e).map(function(e) {
		return parseInt(e);
	}).reduce(function(e, t) {
		return t > e ? t : e;
	}, 0);
	return Array.from(U({}, e, { length: t + 1 }));
}, rc = function(e, t) {
	var n = typeof e == "function" ? e : t;
	return function(e) {
		return Array.isArray(e) || Es(e) ? n(nc(e)) : e;
	};
}, ic = /* @__PURE__ */ function(e) {
	vs(t, e);
	function t(t) {
		var n = e.call(this, t) || this;
		return n.updateArrayField = function(e, t, r) {
			var i = n.props, a = i.name, o = i.formik.setFormikState;
			o(function(n) {
				var i = rc(r, e), o = rc(t, e), s = Ms(n.values, a, e(G(n.values, a))), c = r ? i(G(n.errors, a)) : void 0, l = t ? o(G(n.touched, a)) : void 0;
				return Ts(c) && (c = void 0), Ts(l) && (l = void 0), U({}, n, {
					values: s,
					errors: r ? Ms(n.errors, a, c) : n.errors,
					touched: t ? Ms(n.touched, a, l) : n.touched
				});
			});
		}, n.push = function(e) {
			return n.updateArrayField(function(t) {
				return [].concat(nc(t), [Uo(e)]);
			}, !1, !1);
		}, n.handlePush = function(e) {
			return function() {
				return n.push(e);
			};
		}, n.swap = function(e, t) {
			return n.updateArrayField(function(n) {
				return $s(n, e, t);
			}, !0, !0);
		}, n.handleSwap = function(e, t) {
			return function() {
				return n.swap(e, t);
			};
		}, n.move = function(e, t) {
			return n.updateArrayField(function(n) {
				return Qs(n, e, t);
			}, !0, !0);
		}, n.handleMove = function(e, t) {
			return function() {
				return n.move(e, t);
			};
		}, n.insert = function(e, t) {
			return n.updateArrayField(function(n) {
				return ec(n, e, t);
			}, function(t) {
				return ec(t, e, null);
			}, function(t) {
				return ec(t, e, null);
			});
		}, n.handleInsert = function(e, t) {
			return function() {
				return n.insert(e, t);
			};
		}, n.replace = function(e, t) {
			return n.updateArrayField(function(n) {
				return tc(n, e, t);
			}, !1, !1);
		}, n.handleReplace = function(e, t) {
			return function() {
				return n.replace(e, t);
			};
		}, n.unshift = function(e) {
			var t = -1;
			return n.updateArrayField(function(n) {
				var r = n ? [e].concat(n) : [e];
				return t = r.length, r;
			}, function(e) {
				return e ? [null].concat(e) : [null];
			}, function(e) {
				return e ? [null].concat(e) : [null];
			}), t;
		}, n.handleUnshift = function(e) {
			return function() {
				return n.unshift(e);
			};
		}, n.handleRemove = function(e) {
			return function() {
				return n.remove(e);
			};
		}, n.handlePop = function() {
			return function() {
				return n.pop();
			};
		}, n.remove = n.remove.bind(bs(n)), n.pop = n.pop.bind(bs(n)), n;
	}
	var r = t.prototype;
	return r.componentDidUpdate = function(e) {
		this.props.validateOnChange && this.props.formik.validateOnChange && !(0, gs.default)(G(e.formik.values, e.name), G(this.props.formik.values, this.props.name)) && this.props.formik.validateForm(this.props.formik.values);
	}, r.remove = function(e) {
		var t;
		return this.updateArrayField(function(n) {
			var r = n ? nc(n) : [];
			return t ||= r[e], W(r.splice) && r.splice(e, 1), W(r.every) && r.every(function(e) {
				return e === void 0;
			}) ? [] : r;
		}, !0, !0), t;
	}, r.pop = function() {
		var e;
		return this.updateArrayField(function(t) {
			var n = t.slice();
			return e ||= n && n.pop && n.pop(), n;
		}, !0, !0), e;
	}, r.render = function() {
		var e = {
			push: this.push,
			pop: this.pop,
			swap: this.swap,
			move: this.move,
			insert: this.insert,
			replace: this.replace,
			unshift: this.unshift,
			remove: this.remove,
			handlePush: this.handlePush,
			handlePop: this.handlePop,
			handleSwap: this.handleSwap,
			handleMove: this.handleMove,
			handleInsert: this.handleInsert,
			handleReplace: this.handleReplace,
			handleUnshift: this.handleUnshift,
			handleRemove: this.handleRemove
		}, t = this.props, r = t.component, i = t.render, a = t.children, s = t.name, c = t.formik, l = ys(c, ["validate", "validationSchema"]), u = U({}, e, {
			form: l,
			name: s
		});
		return r ? o(r, u) : i ? i(u) : a ? typeof a == "function" ? a(u) : ks(a) ? null : n.only(a) : null;
	}, t;
}(r);
ic.defaultProps = { validateOnChange: !0 };
var ac = /* @__PURE__ */ Zs(/* @__PURE__ */ function(e) {
	vs(t, e);
	function t() {
		return e.apply(this, arguments) || this;
	}
	var n = t.prototype;
	return n.shouldComponentUpdate = function(e) {
		return G(this.props.formik.errors, this.props.name) !== G(e.formik.errors, this.props.name) || G(this.props.formik.touched, this.props.name) !== G(e.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(e).length;
	}, n.render = function() {
		var e = this.props, t = e.component, n = e.formik, r = e.render, i = e.children, a = e.name, s = ys(e, [
			"component",
			"formik",
			"render",
			"children",
			"name"
		]), c = G(n.touched, a), l = G(n.errors, a);
		return c && l ? r ? W(r) ? r(l) : null : i ? W(i) ? i(l) : null : t ? o(t, s, l) : l : null;
	}, t;
}(r)), oc = t.createContext({}), sc = () => u(oc), cc = "w-full", lc = "flex ml-5 mt-2 text-xs text-feedback-danger-200";
//#endregion
//#region src/components/Form/Root/Button/index.tsx
function uc({ disableOnSubmit: e, disableOnNotDirty: t, disableOnNotValid: n, isDisabled: r, ...i }) {
	let { isSubmitting: a, dirty: o, isValid: s } = ws(), { isForcedDirty: c, onNavigationEvent: l } = sc(), u = (e) => {
		l(() => i.onClick);
	}, d = g(() => !!(r || e && a || t && !o || t && typeof c == "boolean" && !c || n && !s), [
		e,
		t,
		r,
		a,
		c,
		o,
		s,
		n
	]);
	return /* @__PURE__ */ b(ft, {
		...i,
		isDisabled: d,
		onClick: i.type !== "submit" && (o || c !== void 0 && c) ? u : i.onClick
	});
}
//#endregion
//#region node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var dc = a({});
//#endregion
//#region node_modules/framer-motion/dist/es/utils/use-constant.mjs
function fc(e) {
	let t = _(null);
	return t.current === null && (t.current = e()), t.current;
}
//#endregion
//#region node_modules/framer-motion/dist/es/utils/is-browser.mjs
var pc = typeof window < "u", mc = pc ? h : d, hc = /* @__PURE__ */ a(null);
//#endregion
//#region node_modules/motion-utils/dist/es/array.mjs
function gc(e, t) {
	e.indexOf(t) === -1 && e.push(t);
}
function _c(e, t) {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}
//#endregion
//#region node_modules/motion-utils/dist/es/clamp.mjs
var vc = (e, t, n) => n > t ? t : n < e ? e : n;
//#endregion
//#region node_modules/motion-utils/dist/es/format-error-message.mjs
function yc(e, t) {
	return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
//#endregion
//#region node_modules/motion-utils/dist/es/errors.mjs
It();
var bc = () => {}, xc = () => {};
z.env.NODE_ENV !== "production" && (bc = (e, t, n) => {
	!e && typeof console < "u" && console.warn(yc(t, n));
}, xc = (e, t, n) => {
	if (!e) throw Error(yc(t, n));
});
//#endregion
//#region node_modules/motion-utils/dist/es/global-config.mjs
var Sc = {}, Cc = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
//#endregion
//#region node_modules/motion-utils/dist/es/is-object.mjs
function wc(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region node_modules/motion-utils/dist/es/is-zero-value-string.mjs
var Tc = (e) => /^0[^.\s]+$/u.test(e);
//#endregion
//#region node_modules/motion-utils/dist/es/memo.mjs
/* @__NO_SIDE_EFFECTS__ */
function Ec(e) {
	let t;
	return () => (t === void 0 && (t = e()), t);
}
//#endregion
//#region node_modules/motion-utils/dist/es/noop.mjs
var Dc = /* @__NO_SIDE_EFFECTS__ */ (e) => e, Oc = (e, t) => (n) => t(e(n)), kc = (...e) => e.reduce(Oc), Ac = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
	let r = t - e;
	return r === 0 ? 1 : (n - e) / r;
}, jc = class {
	constructor() {
		this.subscriptions = [];
	}
	add(e) {
		return gc(this.subscriptions, e), () => _c(this.subscriptions, e);
	}
	notify(e, t, n) {
		let r = this.subscriptions.length;
		if (r) if (r === 1) this.subscriptions[0](e, t, n);
		else for (let i = 0; i < r; i++) {
			let r = this.subscriptions[i];
			r && r(e, t, n);
		}
	}
	getSize() {
		return this.subscriptions.length;
	}
	clear() {
		this.subscriptions.length = 0;
	}
}, Mc = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Nc = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
//#endregion
//#region node_modules/motion-utils/dist/es/velocity-per-second.mjs
function Pc(e, t) {
	return t ? 1e3 / t * e : 0;
}
//#endregion
//#region node_modules/motion-utils/dist/es/warn-once.mjs
var Fc = /* @__PURE__ */ new Set();
function Ic(e, t, n) {
	e || Fc.has(t) || (console.warn(yc(t, n)), Fc.add(t));
}
//#endregion
//#region node_modules/motion-utils/dist/es/easing/cubic-bezier.mjs
var Lc = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, Rc = 1e-7, zc = 12;
function Bc(e, t, n, r, i) {
	let a, o, s = 0;
	do
		o = t + (n - t) / 2, a = Lc(o, r, i) - e, a > 0 ? n = o : t = o;
	while (Math.abs(a) > Rc && ++s < zc);
	return o;
}
function Vc(e, t, n, r) {
	if (e === t && n === r) return Dc;
	let i = (t) => Bc(t, 0, 1, e, n);
	return (e) => e === 0 || e === 1 ? e : Lc(i(e), t, r);
}
//#endregion
//#region node_modules/motion-utils/dist/es/easing/modifiers/mirror.mjs
var Hc = (e) => (t) => t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Uc = (e) => (t) => 1 - e(1 - t), Wc = /* @__PURE__ */ Vc(.33, 1.53, .69, .99), Gc = /* @__PURE__ */ Uc(Wc), Kc = /* @__PURE__ */ Hc(Gc), qc = (e) => (e *= 2) < 1 ? .5 * Gc(e) : .5 * (2 - 2 ** (-10 * (e - 1))), Jc = (e) => 1 - Math.sin(Math.acos(e)), Yc = Uc(Jc), Xc = Hc(Jc), Zc = /* @__PURE__ */ Vc(.42, 0, 1, 1), Qc = /* @__PURE__ */ Vc(0, 0, .58, 1), $c = /* @__PURE__ */ Vc(.42, 0, .58, 1), el = (e) => Array.isArray(e) && typeof e[0] != "number", tl = (e) => Array.isArray(e) && typeof e[0] == "number", nl = {
	linear: Dc,
	easeIn: Zc,
	easeInOut: $c,
	easeOut: Qc,
	circIn: Jc,
	circInOut: Xc,
	circOut: Yc,
	backIn: Gc,
	backInOut: Kc,
	backOut: Wc,
	anticipate: qc
}, rl = (e) => typeof e == "string", il = (e) => {
	if (tl(e)) {
		xc(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
		let [t, n, r, i] = e;
		return Vc(t, n, r, i);
	} else if (rl(e)) return xc(nl[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), nl[e];
	return e;
}, al = [
	"setup",
	"read",
	"resolveKeyframes",
	"preUpdate",
	"update",
	"preRender",
	"render",
	"postRender"
], ol = {
	value: null,
	addProjectionMetrics: null
};
//#endregion
//#region node_modules/motion-dom/dist/es/frameloop/render-step.mjs
function sl(e, t) {
	let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, a = !1, o = /* @__PURE__ */ new WeakSet(), s = {
		delta: 0,
		timestamp: 0,
		isProcessing: !1
	}, c = 0;
	function l(t) {
		o.has(t) && (u.schedule(t), e()), c++, t(s);
	}
	let u = {
		schedule: (e, t = !1, a = !1) => {
			let s = a && i ? n : r;
			return t && o.add(e), s.has(e) || s.add(e), e;
		},
		cancel: (e) => {
			r.delete(e), o.delete(e);
		},
		process: (e) => {
			if (s = e, i) {
				a = !0;
				return;
			}
			i = !0, [n, r] = [r, n], n.forEach(l), t && ol.value && ol.value.frameloop[t].push(c), c = 0, n.clear(), i = !1, a && (a = !1, u.process(e));
		}
	};
	return u;
}
//#endregion
//#region node_modules/motion-dom/dist/es/frameloop/batcher.mjs
var cl = 40;
function ll(e, t) {
	let n = !1, r = !0, i = {
		delta: 0,
		timestamp: 0,
		isProcessing: !1
	}, a = () => n = !0, o = al.reduce((e, n) => (e[n] = sl(a, t ? n : void 0), e), {}), { setup: s, read: c, resolveKeyframes: l, preUpdate: u, update: d, preRender: f, render: p, postRender: m } = o, h = () => {
		let a = Sc.useManualTiming ? i.timestamp : performance.now();
		n = !1, Sc.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(a - i.timestamp, cl), 1)), i.timestamp = a, i.isProcessing = !0, s.process(i), c.process(i), l.process(i), u.process(i), d.process(i), f.process(i), p.process(i), m.process(i), i.isProcessing = !1, n && t && (r = !1, e(h));
	}, g = () => {
		n = !0, r = !0, i.isProcessing || e(h);
	};
	return {
		schedule: al.reduce((e, t) => {
			let r = o[t];
			return e[t] = (e, t = !1, i = !1) => (n || g(), r.schedule(e, t, i)), e;
		}, {}),
		cancel: (e) => {
			for (let t = 0; t < al.length; t++) o[al[t]].cancel(e);
		},
		state: i,
		steps: o
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/frameloop/frame.mjs
var { schedule: K, cancel: ul, state: q, steps: dl } = /* @__PURE__ */ ll(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Dc, !0), fl;
function pl() {
	fl = void 0;
}
var ml = {
	now: () => (fl === void 0 && ml.set(q.isProcessing || Sc.useManualTiming ? q.timestamp : performance.now()), fl),
	set: (e) => {
		fl = e, queueMicrotask(pl);
	}
}, hl = {
	layout: 0,
	mainThread: 0,
	waapi: 0
}, gl = (e) => (t) => typeof t == "string" && t.startsWith(e), _l = /* @__PURE__ */ gl("--"), vl = /* @__PURE__ */ gl("var(--"), yl = (e) => vl(e) ? bl.test(e.split("/*")[0].trim()) : !1, bl = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, xl = {
	test: (e) => typeof e == "number",
	parse: parseFloat,
	transform: (e) => e
}, Sl = {
	...xl,
	transform: (e) => vc(0, 1, e)
}, Cl = {
	...xl,
	default: 1
}, wl = (e) => Math.round(e * 1e5) / 1e5, Tl = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/utils/is-nullish.mjs
function El(e) {
	return e == null;
}
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/utils/single-color-regex.mjs
var Dl = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Ol = (e, t) => (n) => !!(typeof n == "string" && Dl.test(n) && n.startsWith(e) || t && !El(n) && Object.prototype.hasOwnProperty.call(n, t)), kl = (e, t, n) => (r) => {
	if (typeof r != "string") return r;
	let [i, a, o, s] = r.match(Tl);
	return {
		[e]: parseFloat(i),
		[t]: parseFloat(a),
		[n]: parseFloat(o),
		alpha: s === void 0 ? 1 : parseFloat(s)
	};
}, Al = (e) => vc(0, 255, e), jl = {
	...xl,
	transform: (e) => Math.round(Al(e))
}, Ml = {
	test: /* @__PURE__ */ Ol("rgb", "red"),
	parse: /* @__PURE__ */ kl("red", "green", "blue"),
	transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + jl.transform(e) + ", " + jl.transform(t) + ", " + jl.transform(n) + ", " + wl(Sl.transform(r)) + ")"
};
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/color/hex.mjs
function Nl(e) {
	let t = "", n = "", r = "", i = "";
	return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
		red: parseInt(t, 16),
		green: parseInt(n, 16),
		blue: parseInt(r, 16),
		alpha: i ? parseInt(i, 16) / 255 : 1
	};
}
var Pl = {
	test: /* @__PURE__ */ Ol("#"),
	parse: Nl,
	transform: Ml.transform
}, Fl = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
	test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
	parse: parseFloat,
	transform: (t) => `${t}${e}`
}), Il = /* @__PURE__ */ Fl("deg"), Ll = /* @__PURE__ */ Fl("%"), J = /* @__PURE__ */ Fl("px"), Rl = /* @__PURE__ */ Fl("vh"), zl = /* @__PURE__ */ Fl("vw"), Bl = {
	...Ll,
	parse: (e) => Ll.parse(e) / 100,
	transform: (e) => Ll.transform(e * 100)
}, Vl = {
	test: /* @__PURE__ */ Ol("hsl", "hue"),
	parse: /* @__PURE__ */ kl("hue", "saturation", "lightness"),
	transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ll.transform(wl(t)) + ", " + Ll.transform(wl(n)) + ", " + wl(Sl.transform(r)) + ")"
}, Y = {
	test: (e) => Ml.test(e) || Pl.test(e) || Vl.test(e),
	parse: (e) => Ml.test(e) ? Ml.parse(e) : Vl.test(e) ? Vl.parse(e) : Pl.parse(e),
	transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Ml.transform(e) : Vl.transform(e),
	getAnimatableNone: (e) => {
		let t = Y.parse(e);
		return t.alpha = 0, Y.transform(t);
	}
}, Hl = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/complex/index.mjs
function Ul(e) {
	return isNaN(e) && typeof e == "string" && (e.match(Tl)?.length || 0) + (e.match(Hl)?.length || 0) > 0;
}
var Wl = "number", Gl = "color", Kl = "var", ql = "var(", Jl = "${}", Yl = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Xl(e) {
	let t = e.toString(), n = [], r = {
		color: [],
		number: [],
		var: []
	}, i = [], a = 0;
	return {
		values: n,
		split: t.replace(Yl, (e) => (Y.test(e) ? (r.color.push(a), i.push(Gl), n.push(Y.parse(e))) : e.startsWith(ql) ? (r.var.push(a), i.push(Kl), n.push(e)) : (r.number.push(a), i.push(Wl), n.push(parseFloat(e))), ++a, Jl)).split(Jl),
		indexes: r,
		types: i
	};
}
function Zl(e) {
	return Xl(e).values;
}
function Ql(e) {
	let { split: t, types: n } = Xl(e), r = t.length;
	return (e) => {
		let i = "";
		for (let a = 0; a < r; a++) if (i += t[a], e[a] !== void 0) {
			let t = n[a];
			t === Wl ? i += wl(e[a]) : t === Gl ? i += Y.transform(e[a]) : i += e[a];
		}
		return i;
	};
}
var $l = (e) => typeof e == "number" ? 0 : Y.test(e) ? Y.getAnimatableNone(e) : e;
function eu(e) {
	let t = Zl(e);
	return Ql(e)(t.map($l));
}
var tu = {
	test: Ul,
	parse: Zl,
	createTransformer: Ql,
	getAnimatableNone: eu
};
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/color/hsla-to-rgba.mjs
function nu(e, t, n) {
	return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function ru({ hue: e, saturation: t, lightness: n, alpha: r }) {
	e /= 360, t /= 100, n /= 100;
	let i = 0, a = 0, o = 0;
	if (!t) i = a = o = n;
	else {
		let r = n < .5 ? n * (1 + t) : n + t - n * t, s = 2 * n - r;
		i = nu(s, r, e + 1 / 3), a = nu(s, r, e), o = nu(s, r, e - 1 / 3);
	}
	return {
		red: Math.round(i * 255),
		green: Math.round(a * 255),
		blue: Math.round(o * 255),
		alpha: r
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/mix/immediate.mjs
function iu(e, t) {
	return (n) => n > 0 ? t : e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/mix/number.mjs
var X = (e, t, n) => e + (t - e) * n, au = (e, t, n) => {
	let r = e * e, i = n * (t * t - r) + r;
	return i < 0 ? 0 : Math.sqrt(i);
}, ou = [
	Pl,
	Ml,
	Vl
], su = (e) => ou.find((t) => t.test(e));
function cu(e) {
	let t = su(e);
	if (bc(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t) return !1;
	let n = t.parse(e);
	return t === Vl && (n = ru(n)), n;
}
var lu = (e, t) => {
	let n = cu(e), r = cu(t);
	if (!n || !r) return iu(e, t);
	let i = { ...n };
	return (e) => (i.red = au(n.red, r.red, e), i.green = au(n.green, r.green, e), i.blue = au(n.blue, r.blue, e), i.alpha = X(n.alpha, r.alpha, e), Ml.transform(i));
}, uu = new Set(["none", "hidden"]);
function du(e, t) {
	return uu.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/mix/complex.mjs
function fu(e, t) {
	return (n) => X(e, t, n);
}
function pu(e) {
	return typeof e == "number" ? fu : typeof e == "string" ? yl(e) ? iu : Y.test(e) ? lu : _u : Array.isArray(e) ? mu : typeof e == "object" ? Y.test(e) ? lu : hu : iu;
}
function mu(e, t) {
	let n = [...e], r = n.length, i = e.map((e, n) => pu(e)(e, t[n]));
	return (e) => {
		for (let t = 0; t < r; t++) n[t] = i[t](e);
		return n;
	};
}
function hu(e, t) {
	let n = {
		...e,
		...t
	}, r = {};
	for (let i in n) e[i] !== void 0 && t[i] !== void 0 && (r[i] = pu(e[i])(e[i], t[i]));
	return (e) => {
		for (let t in r) n[t] = r[t](e);
		return n;
	};
}
function gu(e, t) {
	let n = [], r = {
		color: 0,
		var: 0,
		number: 0
	};
	for (let i = 0; i < t.values.length; i++) {
		let a = t.types[i], o = e.indexes[a][r[a]];
		n[i] = e.values[o] ?? 0, r[a]++;
	}
	return n;
}
var _u = (e, t) => {
	let n = tu.createTransformer(t), r = Xl(e), i = Xl(t);
	return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? uu.has(e) && !i.values.length || uu.has(t) && !r.values.length ? du(e, t) : kc(mu(gu(r, i), i.values), n) : (bc(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), iu(e, t));
};
//#endregion
//#region node_modules/motion-dom/dist/es/utils/mix/index.mjs
function vu(e, t, n) {
	return typeof e == "number" && typeof t == "number" && typeof n == "number" ? X(e, t, n) : pu(e)(e, t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/drivers/frame.mjs
var yu = (e) => {
	let t = ({ timestamp: t }) => e(t);
	return {
		start: (e = !0) => K.update(t, e),
		stop: () => ul(t),
		now: () => q.isProcessing ? q.timestamp : ml.now()
	};
}, bu = (e, t, n = 10) => {
	let r = "", i = Math.max(Math.round(t / n), 2);
	for (let t = 0; t < i; t++) r += Math.round(e(t / (i - 1)) * 1e4) / 1e4 + ", ";
	return `linear(${r.substring(0, r.length - 2)})`;
}, xu = 2e4;
function Su(e) {
	let t = 0, n = e.next(t);
	for (; !n.done && t < 2e4;) t += 50, n = e.next(t);
	return t >= 2e4 ? Infinity : t;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/utils/create-generator-easing.mjs
function Cu(e, t = 100, n) {
	let r = n({
		...e,
		keyframes: [0, t]
	}), i = Math.min(Su(r), xu);
	return {
		type: "keyframes",
		ease: (e) => r.next(i * e).value / t,
		duration: /* @__PURE__ */ Nc(i)
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/utils/velocity.mjs
var wu = 5;
function Tu(e, t, n) {
	let r = Math.max(t - wu, 0);
	return Pc(n - e(r), t - r);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/spring/defaults.mjs
var Z = {
	stiffness: 100,
	damping: 10,
	mass: 1,
	velocity: 0,
	duration: 800,
	bounce: .3,
	visualDuration: .3,
	restSpeed: {
		granular: .01,
		default: 2
	},
	restDelta: {
		granular: .005,
		default: .5
	},
	minDuration: .01,
	maxDuration: 10,
	minDamping: .05,
	maxDamping: 1
}, Eu = .001;
function Du({ duration: e = Z.duration, bounce: t = Z.bounce, velocity: n = Z.velocity, mass: r = Z.mass }) {
	let i, a;
	bc(e <= /* @__PURE__ */ Mc(Z.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
	let o = 1 - t;
	o = vc(Z.minDamping, Z.maxDamping, o), e = vc(Z.minDuration, Z.maxDuration, /* @__PURE__ */ Nc(e)), o < 1 ? (i = (t) => {
		let r = t * o, i = r * e, a = r - n, s = Au(t, o), c = Math.exp(-i);
		return Eu - a / s * c;
	}, a = (t) => {
		let r = t * o * e, a = r * n + n, s = o ** 2 * t ** 2 * e, c = Math.exp(-r), l = Au(t ** 2, o);
		return (-i(t) + Eu > 0 ? -1 : 1) * ((a - s) * c) / l;
	}) : (i = (t) => {
		let r = Math.exp(-t * e), i = (t - n) * e + 1;
		return -Eu + r * i;
	}, a = (t) => Math.exp(-t * e) * ((n - t) * (e * e)));
	let s = 5 / e, c = ku(i, a, s);
	if (e = /* @__PURE__ */ Mc(e), isNaN(c)) return {
		stiffness: Z.stiffness,
		damping: Z.damping,
		duration: e
	};
	{
		let t = c ** 2 * r;
		return {
			stiffness: t,
			damping: o * 2 * Math.sqrt(r * t),
			duration: e
		};
	}
}
var Ou = 12;
function ku(e, t, n) {
	let r = n;
	for (let n = 1; n < Ou; n++) r -= e(r) / t(r);
	return r;
}
function Au(e, t) {
	return e * Math.sqrt(1 - t * t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/spring/index.mjs
var ju = ["duration", "bounce"], Mu = [
	"stiffness",
	"damping",
	"mass"
];
function Nu(e, t) {
	return t.some((t) => e[t] !== void 0);
}
function Pu(e) {
	let t = {
		velocity: Z.velocity,
		stiffness: Z.stiffness,
		damping: Z.damping,
		mass: Z.mass,
		isResolvedFromDuration: !1,
		...e
	};
	if (!Nu(e, Mu) && Nu(e, ju)) if (e.visualDuration) {
		let n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * vc(.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
		t = {
			...t,
			mass: Z.mass,
			stiffness: i,
			damping: a
		};
	} else {
		let n = Du(e);
		t = {
			...t,
			...n,
			mass: Z.mass
		}, t.isResolvedFromDuration = !0;
	}
	return t;
}
function Fu(e = Z.visualDuration, t = Z.bounce) {
	let n = typeof e == "object" ? e : {
		visualDuration: e,
		keyframes: [0, 1],
		bounce: t
	}, { restSpeed: r, restDelta: i } = n, a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = {
		done: !1,
		value: a
	}, { stiffness: c, damping: l, mass: u, duration: d, velocity: f, isResolvedFromDuration: p } = Pu({
		...n,
		velocity: -/* @__PURE__ */ Nc(n.velocity || 0)
	}), m = f || 0, h = l / (2 * Math.sqrt(c * u)), g = o - a, _ = /* @__PURE__ */ Nc(Math.sqrt(c / u)), v = Math.abs(g) < 5;
	r ||= v ? Z.restSpeed.granular : Z.restSpeed.default, i ||= v ? Z.restDelta.granular : Z.restDelta.default;
	let y;
	if (h < 1) {
		let e = Au(_, h);
		y = (t) => o - Math.exp(-h * _ * t) * ((m + h * _ * g) / e * Math.sin(e * t) + g * Math.cos(e * t));
	} else if (h === 1) y = (e) => o - Math.exp(-_ * e) * (g + (m + _ * g) * e);
	else {
		let e = _ * Math.sqrt(h * h - 1);
		y = (t) => {
			let n = Math.exp(-h * _ * t), r = Math.min(e * t, 300);
			return o - n * ((m + h * _ * g) * Math.sinh(r) + e * g * Math.cosh(r)) / e;
		};
	}
	let b = {
		calculatedDuration: p && d || null,
		next: (e) => {
			let t = y(e);
			if (p) s.done = e >= d;
			else {
				let n = e === 0 ? m : 0;
				h < 1 && (n = e === 0 ? /* @__PURE__ */ Mc(m) : Tu(y, e, t));
				let a = Math.abs(n) <= r, c = Math.abs(o - t) <= i;
				s.done = a && c;
			}
			return s.value = s.done ? o : t, s;
		},
		toString: () => {
			let e = Math.min(Su(b), xu), t = bu((t) => b.next(e * t).value, e, 30);
			return e + "ms " + t;
		},
		toTransition: () => {}
	};
	return b;
}
Fu.applyToOptions = (e) => {
	let t = Cu(e, 100, Fu);
	return e.ease = t.ease, e.duration = /* @__PURE__ */ Mc(t.duration), e.type = "keyframes", e;
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/inertia.mjs
function Iu({ keyframes: e, velocity: t = 0, power: n = .8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: c, restDelta: l = .5, restSpeed: u }) {
	let d = e[0], f = {
		done: !1,
		value: d
	}, p = (e) => s !== void 0 && e < s || c !== void 0 && e > c, m = (e) => s === void 0 ? c : c === void 0 || Math.abs(s - e) < Math.abs(c - e) ? s : c, h = n * t, g = d + h, _ = o === void 0 ? g : o(g);
	_ !== g && (h = _ - d);
	let v = (e) => -h * Math.exp(-e / r), y = (e) => _ + v(e), b = (e) => {
		let t = v(e), n = y(e);
		f.done = Math.abs(t) <= l, f.value = f.done ? _ : n;
	}, x, S, C = (e) => {
		p(f.value) && (x = e, S = Fu({
			keyframes: [f.value, m(f.value)],
			velocity: Tu(y, e, f.value),
			damping: i,
			stiffness: a,
			restDelta: l,
			restSpeed: u
		}));
	};
	return C(0), {
		calculatedDuration: null,
		next: (e) => {
			let t = !1;
			return !S && x === void 0 && (t = !0, b(e), C(e)), x !== void 0 && e >= x ? S.next(e - x) : (!t && b(e), f);
		}
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/interpolate.mjs
function Lu(e, t, n) {
	let r = [], i = n || Sc.mix || vu, a = e.length - 1;
	for (let n = 0; n < a; n++) {
		let a = i(e[n], e[n + 1]);
		t && (a = kc(Array.isArray(t) ? t[n] || Dc : t, a)), r.push(a);
	}
	return r;
}
function Ru(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
	let a = e.length;
	if (xc(a === t.length, "Both input and output ranges must be the same length", "range-length"), a === 1) return () => t[0];
	if (a === 2 && t[0] === t[1]) return () => t[1];
	let o = e[0] === e[1];
	e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
	let s = Lu(t, r, i), c = s.length, l = (n) => {
		if (o && n < e[0]) return t[0];
		let r = 0;
		if (c > 1) for (; r < e.length - 2 && !(n < e[r + 1]); r++);
		let i = /* @__PURE__ */ Ac(e[r], e[r + 1], n);
		return s[r](i);
	};
	return n ? (t) => l(vc(e[0], e[a - 1], t)) : l;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/offsets/fill.mjs
function zu(e, t) {
	let n = e[e.length - 1];
	for (let r = 1; r <= t; r++) {
		let i = /* @__PURE__ */ Ac(0, t, r);
		e.push(X(n, 1, i));
	}
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/offsets/default.mjs
function Bu(e) {
	let t = [0];
	return zu(t, e.length - 1), t;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/offsets/time.mjs
function Vu(e, t) {
	return e.map((e) => e * t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/keyframes.mjs
function Hu(e, t) {
	return e.map(() => t || $c).splice(0, e.length - 1);
}
function Uu({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
	let i = el(r) ? r.map(il) : il(r), a = {
		done: !1,
		value: t[0]
	}, o = Ru(Vu(n && n.length === t.length ? n : Bu(t), e), t, { ease: Array.isArray(i) ? i : Hu(t, i) });
	return {
		calculatedDuration: e,
		next: (t) => (a.value = o(t), a.done = t >= e, a)
	};
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/get-final.mjs
var Wu = (e) => e !== null;
function Gu(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
	let a = e.filter(Wu), o = i < 0 || t && n !== "loop" && t % 2 == 1 ? 0 : a.length - 1;
	return !o || r === void 0 ? a[o] : r;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/replace-transition-type.mjs
var Ku = {
	decay: Iu,
	inertia: Iu,
	tween: Uu,
	keyframes: Uu,
	spring: Fu
};
function qu(e) {
	typeof e.type == "string" && (e.type = Ku[e.type]);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/WithPromise.mjs
var Ju = class {
	constructor() {
		this.updateFinished();
	}
	get finished() {
		return this._finished;
	}
	updateFinished() {
		this._finished = new Promise((e) => {
			this.resolve = e;
		});
	}
	notifyFinished() {
		this.resolve();
	}
	then(e, t) {
		return this.finished.then(e, t);
	}
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/JSAnimation.mjs
It();
var Yu = (e) => e / 100, Xu = class extends Ju {
	constructor(e) {
		super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
			let { motionValue: e } = this.options;
			e && e.updatedAt !== ml.now() && this.tick(ml.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
		}, hl.mainThread++, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
	}
	initAnimation() {
		let { options: e } = this;
		qu(e);
		let { type: t = Uu, repeat: n = 0, repeatDelay: r = 0, repeatType: i, velocity: a = 0 } = e, { keyframes: o } = e, s = t || Uu;
		z.env.NODE_ENV !== "production" && s !== Uu && xc(o.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${o}`, "spring-two-frames"), s !== Uu && typeof o[0] != "number" && (this.mixKeyframes = kc(Yu, vu(o[0], o[1])), o = [0, 100]);
		let c = s({
			...e,
			keyframes: o
		});
		i === "mirror" && (this.mirroredGenerator = s({
			...e,
			keyframes: [...o].reverse(),
			velocity: -a
		})), c.calculatedDuration === null && (c.calculatedDuration = Su(c));
		let { calculatedDuration: l } = c;
		this.calculatedDuration = l, this.resolvedDuration = l + r, this.totalDuration = this.resolvedDuration * (n + 1) - r, this.generator = c;
	}
	updateTime(e) {
		let t = Math.round(e - this.startTime) * this.playbackSpeed;
		this.holdTime === null ? this.currentTime = t : this.currentTime = this.holdTime;
	}
	tick(e, t = !1) {
		let { generator: n, totalDuration: r, mixKeyframes: i, mirroredGenerator: a, resolvedDuration: o, calculatedDuration: s } = this;
		if (this.startTime === null) return n.next(0);
		let { delay: c = 0, keyframes: l, repeat: u, repeatType: d, repeatDelay: f, type: p, onUpdate: m, finalKeyframe: h } = this.options;
		this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - r / this.speed, this.startTime)), t ? this.currentTime = e : this.updateTime(e);
		let g = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), _ = this.playbackSpeed >= 0 ? g < 0 : g > r;
		this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
		let v = this.currentTime, y = n;
		if (u) {
			let e = Math.min(this.currentTime, r) / o, t = Math.floor(e), n = e % 1;
			!n && e >= 1 && (n = 1), n === 1 && t--, t = Math.min(t, u + 1), t % 2 && (d === "reverse" ? (n = 1 - n, f && (n -= f / o)) : d === "mirror" && (y = a)), v = vc(0, 1, n) * o;
		}
		let b = _ ? {
			done: !1,
			value: l[0]
		} : y.next(v);
		i && (b.value = i(b.value));
		let { done: x } = b;
		!_ && s !== null && (x = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
		let S = this.holdTime === null && (this.state === "finished" || this.state === "running" && x);
		return S && p !== Iu && (b.value = Gu(l, this.options, h, this.speed)), m && m(b.value), S && this.finish(), b;
	}
	then(e, t) {
		return this.finished.then(e, t);
	}
	get duration() {
		return /* @__PURE__ */ Nc(this.calculatedDuration);
	}
	get time() {
		return /* @__PURE__ */ Nc(this.currentTime);
	}
	set time(e) {
		e = /* @__PURE__ */ Mc(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver?.start(!1);
	}
	get speed() {
		return this.playbackSpeed;
	}
	set speed(e) {
		this.updateTime(ml.now());
		let t = this.playbackSpeed !== e;
		this.playbackSpeed = e, t && (this.time = /* @__PURE__ */ Nc(this.currentTime));
	}
	play() {
		if (this.isStopped) return;
		let { driver: e = yu, startTime: t } = this.options;
		this.driver ||= e((e) => this.tick(e)), this.options.onPlay?.();
		let n = this.driver.now();
		this.state === "finished" ? (this.updateFinished(), this.startTime = n) : this.holdTime === null ? this.startTime ||= t ?? n : this.startTime = n - this.holdTime, this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
	}
	pause() {
		this.state = "paused", this.updateTime(ml.now()), this.holdTime = this.currentTime;
	}
	complete() {
		this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
	}
	finish() {
		this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
	}
	cancel() {
		this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
	}
	teardown() {
		this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null, hl.mainThread--;
	}
	stopDriver() {
		this.driver &&= (this.driver.stop(), void 0);
	}
	sample(e) {
		return this.startTime = 0, this.tick(e, !0);
	}
	attachTimeline(e) {
		return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), e.observe(this);
	}
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/utils/fill-wildcards.mjs
function Zu(e) {
	for (let t = 1; t < e.length; t++) e[t] ?? (e[t] = e[t - 1]);
}
//#endregion
//#region node_modules/motion-dom/dist/es/render/dom/parse-transform.mjs
var Qu = (e) => e * 180 / Math.PI, $u = (e) => td(Qu(Math.atan2(e[1], e[0]))), ed = {
	x: 4,
	y: 5,
	translateX: 4,
	translateY: 5,
	scaleX: 0,
	scaleY: 3,
	scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
	rotate: $u,
	rotateZ: $u,
	skewX: (e) => Qu(Math.atan(e[1])),
	skewY: (e) => Qu(Math.atan(e[2])),
	skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, td = (e) => (e %= 360, e < 0 && (e += 360), e), nd = $u, rd = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), id = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), ad = {
	x: 12,
	y: 13,
	z: 14,
	translateX: 12,
	translateY: 13,
	translateZ: 14,
	scaleX: rd,
	scaleY: id,
	scale: (e) => (rd(e) + id(e)) / 2,
	rotateX: (e) => td(Qu(Math.atan2(e[6], e[5]))),
	rotateY: (e) => td(Qu(Math.atan2(-e[2], e[0]))),
	rotateZ: nd,
	rotate: nd,
	skewX: (e) => Qu(Math.atan(e[4])),
	skewY: (e) => Qu(Math.atan(e[1])),
	skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function od(e) {
	return +!!e.includes("scale");
}
function sd(e, t) {
	if (!e || e === "none") return od(t);
	let n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u), r, i;
	if (n) r = ad, i = n;
	else {
		let t = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
		r = ed, i = t;
	}
	if (!i) return od(t);
	let a = r[t], o = i[1].split(",").map(ld);
	return typeof a == "function" ? a(o) : o[a];
}
var cd = (e, t) => {
	let { transform: n = "none" } = getComputedStyle(e);
	return sd(n, t);
};
function ld(e) {
	return parseFloat(e.trim());
}
//#endregion
//#region node_modules/motion-dom/dist/es/render/utils/keys-transform.mjs
var ud = [
	"transformPerspective",
	"x",
	"y",
	"z",
	"translateX",
	"translateY",
	"translateZ",
	"scale",
	"scaleX",
	"scaleY",
	"rotate",
	"rotateX",
	"rotateY",
	"rotateZ",
	"skew",
	"skewX",
	"skewY"
], dd = new Set(ud), fd = (e) => e === xl || e === J, pd = new Set([
	"x",
	"y",
	"z"
]), md = ud.filter((e) => !pd.has(e));
function hd(e) {
	let t = [];
	return md.forEach((n) => {
		let r = e.getValue(n);
		r !== void 0 && (t.push([n, r.get()]), r.set(+!!n.startsWith("scale")));
	}), t;
}
var gd = {
	width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
	height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
	top: (e, { top: t }) => parseFloat(t),
	left: (e, { left: t }) => parseFloat(t),
	bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
	right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
	x: (e, { transform: t }) => sd(t, "x"),
	y: (e, { transform: t }) => sd(t, "y")
};
gd.translateX = gd.x, gd.translateY = gd.y;
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/KeyframesResolver.mjs
var _d = /* @__PURE__ */ new Set(), vd = !1, yd = !1, bd = !1;
function xd() {
	if (yd) {
		let e = Array.from(_d).filter((e) => e.needsMeasurement), t = new Set(e.map((e) => e.element)), n = /* @__PURE__ */ new Map();
		t.forEach((e) => {
			let t = hd(e);
			t.length && (n.set(e, t), e.render());
		}), e.forEach((e) => e.measureInitialState()), t.forEach((e) => {
			e.render();
			let t = n.get(e);
			t && t.forEach(([t, n]) => {
				e.getValue(t)?.set(n);
			});
		}), e.forEach((e) => e.measureEndState()), e.forEach((e) => {
			e.suspendedScrollY !== void 0 && window.scrollTo(0, e.suspendedScrollY);
		});
	}
	yd = !1, vd = !1, _d.forEach((e) => e.complete(bd)), _d.clear();
}
function Sd() {
	_d.forEach((e) => {
		e.readKeyframes(), e.needsMeasurement && (yd = !0);
	});
}
function Cd() {
	bd = !0, Sd(), xd(), bd = !1;
}
var wd = class {
	constructor(e, t, n, r, i, a = !1) {
		this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = n, this.motionValue = r, this.element = i, this.isAsync = a;
	}
	scheduleResolve() {
		this.state = "scheduled", this.isAsync ? (_d.add(this), vd || (vd = !0, K.read(Sd), K.resolveKeyframes(xd))) : (this.readKeyframes(), this.complete());
	}
	readKeyframes() {
		let { unresolvedKeyframes: e, name: t, element: n, motionValue: r } = this;
		if (e[0] === null) {
			let i = r?.get(), a = e[e.length - 1];
			if (i !== void 0) e[0] = i;
			else if (n && t) {
				let r = n.readValue(t, a);
				r != null && (e[0] = r);
			}
			e[0] === void 0 && (e[0] = a), r && i === void 0 && r.set(e[0]);
		}
		Zu(e);
	}
	setFinalKeyframe() {}
	measureInitialState() {}
	renderEndStyles() {}
	measureEndState() {}
	complete(e = !1) {
		this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), _d.delete(this);
	}
	cancel() {
		this.state === "scheduled" && (_d.delete(this), this.state = "pending");
	}
	resume() {
		this.state === "pending" && this.scheduleResolve();
	}
}, Td = (e) => e.startsWith("--");
//#endregion
//#region node_modules/motion-dom/dist/es/render/dom/style-set.mjs
function Ed(e, t, n) {
	Td(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var Dd = /* @__PURE__ */ Ec(() => window.ScrollTimeline !== void 0), Od = {};
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/memo.mjs
function kd(e, t) {
	let n = /* @__PURE__ */ Ec(e);
	return () => Od[t] ?? n();
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/supports/linear-easing.mjs
var Ad = /* @__PURE__ */ kd(() => {
	try {
		document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
	} catch {
		return !1;
	}
	return !0;
}, "linearEasing"), jd = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Md = {
	linear: "linear",
	ease: "ease",
	easeIn: "ease-in",
	easeOut: "ease-out",
	easeInOut: "ease-in-out",
	circIn: /* @__PURE__ */ jd([
		0,
		.65,
		.55,
		1
	]),
	circOut: /* @__PURE__ */ jd([
		.55,
		0,
		1,
		.45
	]),
	backIn: /* @__PURE__ */ jd([
		.31,
		.01,
		.66,
		-.59
	]),
	backOut: /* @__PURE__ */ jd([
		.33,
		1.53,
		.69,
		.99
	])
};
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/easing/map-easing.mjs
function Nd(e, t) {
	if (e) return typeof e == "function" ? Ad() ? bu(e, t) : "ease-out" : tl(e) ? jd(e) : Array.isArray(e) ? e.map((e) => Nd(e, t) || Md.easeOut) : Md[e];
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/start-waapi-animation.mjs
function Pd(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeOut", times: c } = {}, l = void 0) {
	let u = { [t]: n };
	c && (u.offset = c);
	let d = Nd(s, i);
	Array.isArray(d) && (u.easing = d), ol.value && hl.waapi++;
	let f = {
		delay: r,
		duration: i,
		easing: Array.isArray(d) ? "linear" : d,
		fill: "both",
		iterations: a + 1,
		direction: o === "reverse" ? "alternate" : "normal"
	};
	l && (f.pseudoElement = l);
	let p = e.animate(u, f);
	return ol.value && p.finished.finally(() => {
		hl.waapi--;
	}), p;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function Fd(e) {
	return typeof e == "function" && "applyToOptions" in e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/utils/apply-generator.mjs
function Id({ type: e, ...t }) {
	return Fd(e) && Ad() ? e.applyToOptions(t) : (t.duration ??= 300, t.ease ??= "easeOut", t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/NativeAnimation.mjs
var Ld = class extends Ju {
	constructor(e) {
		if (super(), this.finishedTime = null, this.isStopped = !1, !e) return;
		let { element: t, name: n, keyframes: r, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: o, onComplete: s } = e;
		this.isPseudoElement = !!i, this.allowFlatten = a, this.options = e, xc(typeof e.type != "string", "Mini animate() doesn't support \"type\" as a string.", "mini-spring");
		let c = Id(e);
		this.animation = Pd(t, n, r, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
			if (this.finishedTime = this.time, !i) {
				let e = Gu(r, this.options, o, this.speed);
				this.updateMotionValue ? this.updateMotionValue(e) : Ed(t, n, e), this.animation.cancel();
			}
			s?.(), this.notifyFinished();
		};
	}
	play() {
		this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
	}
	pause() {
		this.animation.pause();
	}
	complete() {
		this.animation.finish?.();
	}
	cancel() {
		try {
			this.animation.cancel();
		} catch {}
	}
	stop() {
		if (this.isStopped) return;
		this.isStopped = !0;
		let { state: e } = this;
		e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
	}
	commitStyles() {
		this.isPseudoElement || this.animation.commitStyles?.();
	}
	get duration() {
		let e = this.animation.effect?.getComputedTiming?.().duration || 0;
		return /* @__PURE__ */ Nc(Number(e));
	}
	get time() {
		return /* @__PURE__ */ Nc(Number(this.animation.currentTime) || 0);
	}
	set time(e) {
		this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Mc(e);
	}
	get speed() {
		return this.animation.playbackRate;
	}
	set speed(e) {
		e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
	}
	get state() {
		return this.finishedTime === null ? this.animation.playState : "finished";
	}
	get startTime() {
		return Number(this.animation.startTime);
	}
	set startTime(e) {
		this.animation.startTime = e;
	}
	attachTimeline({ timeline: e, observe: t }) {
		return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, e && Dd() ? (this.animation.timeline = e, Dc) : t(this);
	}
}, Rd = {
	anticipate: qc,
	backInOut: Kc,
	circInOut: Xc
};
function zd(e) {
	return e in Rd;
}
function Bd(e) {
	typeof e.ease == "string" && zd(e.ease) && (e.ease = Rd[e.ease]);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/NativeAnimationExtended.mjs
var Vd = 10, Hd = class extends Ld {
	constructor(e) {
		Bd(e), qu(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
	}
	updateMotionValue(e) {
		let { motionValue: t, onUpdate: n, onComplete: r, element: i, ...a } = this.options;
		if (!t) return;
		if (e !== void 0) {
			t.set(e);
			return;
		}
		let o = new Xu({
			...a,
			autoplay: !1
		}), s = /* @__PURE__ */ Mc(this.finishedTime ?? this.time);
		t.setWithVelocity(o.sample(s - Vd).value, o.sample(s).value, Vd), o.stop();
	}
}, Ud = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && (tu.test(e) || e === "0") && !e.startsWith("url("));
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/can-animate.mjs
function Wd(e) {
	let t = e[0];
	if (e.length === 1) return !0;
	for (let n = 0; n < e.length; n++) if (e[n] !== t) return !0;
}
function Gd(e, t, n, r) {
	let i = e[0];
	if (i === null) return !1;
	if (t === "display" || t === "visibility") return !0;
	let a = e[e.length - 1], o = Ud(i, t), s = Ud(a, t);
	return bc(o === s, `You are trying to animate ${t} from "${i}" to "${a}". "${o ? a : i}" is not an animatable value.`, "value-not-animatable"), !o || !s ? !1 : Wd(e) || (n === "spring" || Fd(n)) && r;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/make-animation-instant.mjs
function Kd(e) {
	e.duration = 0, e.type;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/waapi/supports/waapi.mjs
var qd = new Set([
	"opacity",
	"clipPath",
	"filter",
	"transform"
]), Jd = /* @__PURE__ */ Ec(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Yd(e) {
	let { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: a, type: o } = e;
	if (!(t?.owner?.current instanceof HTMLElement)) return !1;
	let { onUpdate: s, transformTemplate: c } = t.owner.getProps();
	return Jd() && n && qd.has(n) && (n !== "transform" || !c) && !s && !r && i !== "mirror" && a !== 0 && o !== "inertia";
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/AsyncMotionValueAnimation.mjs
var Xd = 40, Zd = class extends Ju {
	constructor({ autoplay: e = !0, delay: t = 0, type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a = "loop", keyframes: o, name: s, motionValue: c, element: l, ...u }) {
		super(), this.stop = () => {
			this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
		}, this.createdAt = ml.now();
		let d = {
			autoplay: e,
			delay: t,
			type: n,
			repeat: r,
			repeatDelay: i,
			repeatType: a,
			name: s,
			motionValue: c,
			element: l,
			...u
		}, f = l?.KeyframeResolver || wd;
		this.keyframeResolver = new f(o, (e, t, n) => this.onKeyframesResolved(e, t, d, !n), s, c, l), this.keyframeResolver?.scheduleResolve();
	}
	onKeyframesResolved(e, t, n, r) {
		this.keyframeResolver = void 0;
		let { name: i, type: a, velocity: o, delay: s, isHandoff: c, onUpdate: l } = n;
		this.resolvedAt = ml.now(), Gd(e, i, a, o) || ((Sc.instantAnimations || !s) && l?.(Gu(e, n, t)), e[0] = e[e.length - 1], Kd(n), n.repeat = 0);
		let u = {
			startTime: r ? this.resolvedAt && this.resolvedAt - this.createdAt > Xd ? this.resolvedAt : this.createdAt : void 0,
			finalKeyframe: t,
			...n,
			keyframes: e
		}, d = !c && Yd(u) ? new Hd({
			...u,
			element: u.motionValue.owner.current
		}) : new Xu(u);
		d.finished.then(() => this.notifyFinished()).catch(Dc), this.pendingTimeline &&= (this.stopTimeline = d.attachTimeline(this.pendingTimeline), void 0), this._animation = d;
	}
	get finished() {
		return this._animation ? this.animation.finished : this._finished;
	}
	then(e, t) {
		return this.finished.finally(e).then(() => {});
	}
	get animation() {
		return this._animation || (this.keyframeResolver?.resume(), Cd()), this._animation;
	}
	get duration() {
		return this.animation.duration;
	}
	get time() {
		return this.animation.time;
	}
	set time(e) {
		this.animation.time = e;
	}
	get speed() {
		return this.animation.speed;
	}
	get state() {
		return this.animation.state;
	}
	set speed(e) {
		this.animation.speed = e;
	}
	get startTime() {
		return this.animation.startTime;
	}
	attachTimeline(e) {
		return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
	}
	play() {
		this.animation.play();
	}
	pause() {
		this.animation.pause();
	}
	complete() {
		this.animation.complete();
	}
	cancel() {
		this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
	}
}, Qd = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $d(e) {
	let t = Qd.exec(e);
	if (!t) return [,];
	let [, n, r, i] = t;
	return [`--${n ?? r}`, i];
}
var ef = 4;
function tf(e, t, n = 1) {
	xc(n <= ef, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
	let [r, i] = $d(e);
	if (!r) return;
	let a = window.getComputedStyle(t).getPropertyValue(r);
	if (a) {
		let e = a.trim();
		return Cc(e) ? parseFloat(e) : e;
	}
	return yl(i) ? tf(i, t, n + 1) : i;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function nf(e, t) {
	return e?.[t] ?? e?.default ?? e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/render/utils/keys-position.mjs
var rf = new Set([
	"width",
	"height",
	"top",
	"left",
	"right",
	"bottom",
	...ud
]), af = {
	test: (e) => e === "auto",
	parse: (e) => e
}, of = (e) => (t) => t.test(e), sf = [
	xl,
	J,
	Ll,
	Il,
	zl,
	Rl,
	af
], cf = (e) => sf.find(of(e));
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/utils/is-none.mjs
function lf(e) {
	return typeof e == "number" ? e === 0 : e === null ? !0 : e === "none" || e === "0" || Tc(e);
}
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/complex/filter.mjs
var uf = new Set([
	"brightness",
	"contrast",
	"saturate",
	"opacity"
]);
function df(e) {
	let [t, n] = e.slice(0, -1).split("(");
	if (t === "drop-shadow") return e;
	let [r] = n.match(Tl) || [];
	if (!r) return e;
	let i = n.replace(r, ""), a = +!!uf.has(t);
	return r !== n && (a *= 100), t + "(" + a + i + ")";
}
var ff = /\b([a-z-]*)\(.*?\)/gu, pf = {
	...tu,
	getAnimatableNone: (e) => {
		let t = e.match(ff);
		return t ? t.map(df).join(" ") : e;
	}
}, mf = {
	...xl,
	transform: Math.round
}, hf = {
	borderWidth: J,
	borderTopWidth: J,
	borderRightWidth: J,
	borderBottomWidth: J,
	borderLeftWidth: J,
	borderRadius: J,
	radius: J,
	borderTopLeftRadius: J,
	borderTopRightRadius: J,
	borderBottomRightRadius: J,
	borderBottomLeftRadius: J,
	width: J,
	maxWidth: J,
	height: J,
	maxHeight: J,
	top: J,
	right: J,
	bottom: J,
	left: J,
	padding: J,
	paddingTop: J,
	paddingRight: J,
	paddingBottom: J,
	paddingLeft: J,
	margin: J,
	marginTop: J,
	marginRight: J,
	marginBottom: J,
	marginLeft: J,
	backgroundPositionX: J,
	backgroundPositionY: J,
	rotate: Il,
	rotateX: Il,
	rotateY: Il,
	rotateZ: Il,
	scale: Cl,
	scaleX: Cl,
	scaleY: Cl,
	scaleZ: Cl,
	skew: Il,
	skewX: Il,
	skewY: Il,
	distance: J,
	translateX: J,
	translateY: J,
	translateZ: J,
	x: J,
	y: J,
	z: J,
	perspective: J,
	transformPerspective: J,
	opacity: Sl,
	originX: Bl,
	originY: Bl,
	originZ: J,
	zIndex: mf,
	fillOpacity: Sl,
	strokeOpacity: Sl,
	numOctaves: mf
}, gf = {
	...hf,
	color: Y,
	backgroundColor: Y,
	outlineColor: Y,
	fill: Y,
	stroke: Y,
	borderColor: Y,
	borderTopColor: Y,
	borderRightColor: Y,
	borderBottomColor: Y,
	borderLeftColor: Y,
	filter: pf,
	WebkitFilter: pf
}, _f = (e) => gf[e];
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/utils/animatable-none.mjs
function vf(e, t) {
	let n = _f(e);
	return n !== pf && (n = tu), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/utils/make-none-animatable.mjs
var yf = new Set([
	"auto",
	"none",
	"0"
]);
function bf(e, t, n) {
	let r = 0, i;
	for (; r < e.length && !i;) {
		let t = e[r];
		typeof t == "string" && !yf.has(t) && Xl(t).values.length && (i = e[r]), r++;
	}
	if (i && n) for (let r of t) e[r] = vf(n, i);
}
//#endregion
//#region node_modules/motion-dom/dist/es/animation/keyframes/DOMKeyframesResolver.mjs
var xf = class extends wd {
	constructor(e, t, n, r, i) {
		super(e, t, n, r, i, !0);
	}
	readKeyframes() {
		let { unresolvedKeyframes: e, element: t, name: n } = this;
		if (!t || !t.current) return;
		super.readKeyframes();
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (typeof r == "string" && (r = r.trim(), yl(r))) {
				let i = tf(r, t.current);
				i !== void 0 && (e[n] = i), n === e.length - 1 && (this.finalKeyframe = r);
			}
		}
		if (this.resolveNoneKeyframes(), !rf.has(n) || e.length !== 2) return;
		let [r, i] = e, a = cf(r), o = cf(i);
		if (a !== o) if (fd(a) && fd(o)) for (let t = 0; t < e.length; t++) {
			let n = e[t];
			typeof n == "string" && (e[t] = parseFloat(n));
		}
		else gd[n] && (this.needsMeasurement = !0);
	}
	resolveNoneKeyframes() {
		let { unresolvedKeyframes: e, name: t } = this, n = [];
		for (let t = 0; t < e.length; t++) (e[t] === null || lf(e[t])) && n.push(t);
		n.length && bf(e, n, t);
	}
	measureInitialState() {
		let { element: e, unresolvedKeyframes: t, name: n } = this;
		if (!e || !e.current) return;
		n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = gd[n](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
		let r = t[t.length - 1];
		r !== void 0 && e.getValue(n, r).jump(r, !1);
	}
	measureEndState() {
		let { element: e, name: t, unresolvedKeyframes: n } = this;
		if (!e || !e.current) return;
		let r = e.getValue(t);
		r && r.jump(this.measuredOrigin, !1);
		let i = n.length - 1, a = n[i];
		n[i] = gd[t](e.measureViewportBox(), window.getComputedStyle(e.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), this.removedTransforms?.length && this.removedTransforms.forEach(([t, n]) => {
			e.getValue(t).set(n);
		}), this.resolveNoneKeyframes();
	}
};
//#endregion
//#region node_modules/motion-dom/dist/es/utils/resolve-elements.mjs
function Sf(e, t, n) {
	if (e instanceof EventTarget) return [e];
	if (typeof e == "string") {
		let r = document;
		t && (r = t.current);
		let i = n?.[e] ?? r.querySelectorAll(e);
		return i ? Array.from(i) : [];
	}
	return Array.from(e);
}
//#endregion
//#region node_modules/motion-dom/dist/es/value/types/utils/get-as-type.mjs
var Cf = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
//#endregion
//#region node_modules/motion-dom/dist/es/utils/is-html-element.mjs
function wf(e) {
	return wc(e) && "offsetHeight" in e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/value/index.mjs
It();
var Tf = 30, Ef = (e) => !isNaN(parseFloat(e)), Df = { current: void 0 }, Of = class {
	constructor(e, t = {}) {
		this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (e) => {
			let t = ml.now();
			if (this.updatedAt !== t && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(e), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents)) for (let e of this.dependents) e.dirty();
		}, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner;
	}
	setCurrent(e) {
		this.current = e, this.updatedAt = ml.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Ef(this.current));
	}
	setPrevFrameValue(e = this.current) {
		this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
	}
	onChange(e) {
		return z.env.NODE_ENV !== "production" && Ic(!1, "value.onChange(callback) is deprecated. Switch to value.on(\"change\", callback)."), this.on("change", e);
	}
	on(e, t) {
		this.events[e] || (this.events[e] = new jc());
		let n = this.events[e].add(t);
		return e === "change" ? () => {
			n(), K.read(() => {
				this.events.change.getSize() || this.stop();
			});
		} : n;
	}
	clearListeners() {
		for (let e in this.events) this.events[e].clear();
	}
	attach(e, t) {
		this.passiveEffect = e, this.stopPassiveEffect = t;
	}
	set(e) {
		this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
	}
	setWithVelocity(e, t, n) {
		this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - n;
	}
	jump(e, t = !0) {
		this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
	}
	dirty() {
		this.events.change?.notify(this.current);
	}
	addDependent(e) {
		this.dependents ||= /* @__PURE__ */ new Set(), this.dependents.add(e);
	}
	removeDependent(e) {
		this.dependents && this.dependents.delete(e);
	}
	get() {
		return Df.current && Df.current.push(this), this.current;
	}
	getPrevious() {
		return this.prev;
	}
	getVelocity() {
		let e = ml.now();
		if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Tf) return 0;
		let t = Math.min(this.updatedAt - this.prevUpdatedAt, Tf);
		return Pc(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
	}
	start(e) {
		return this.stop(), new Promise((t) => {
			this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
		}).then(() => {
			this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
		});
	}
	stop() {
		this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
	}
	isAnimating() {
		return !!this.animation;
	}
	clearAnimation() {
		delete this.animation;
	}
	destroy() {
		this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
	}
};
function kf(e, t) {
	return new Of(e, t);
}
//#endregion
//#region node_modules/motion-dom/dist/es/frameloop/microtask.mjs
var { schedule: Af, cancel: jf } = /* @__PURE__ */ ll(queueMicrotask, !1), Mf = {
	x: !1,
	y: !1
};
function Nf() {
	return Mf.x || Mf.y;
}
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/drag/state/set-active.mjs
function Pf(e) {
	return e === "x" || e === "y" ? Mf[e] ? null : (Mf[e] = !0, () => {
		Mf[e] = !1;
	}) : Mf.x || Mf.y ? null : (Mf.x = Mf.y = !0, () => {
		Mf.x = Mf.y = !1;
	});
}
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/utils/setup.mjs
function Ff(e, t) {
	let n = Sf(e), r = new AbortController();
	return [
		n,
		{
			passive: !0,
			...t,
			signal: r.signal
		},
		() => r.abort()
	];
}
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/hover.mjs
function If(e) {
	return !(e.pointerType === "touch" || Nf());
}
function Lf(e, t, n = {}) {
	let [r, i, a] = Ff(e, n), o = (e) => {
		if (!If(e)) return;
		let { target: n } = e, r = t(n, e);
		if (typeof r != "function" || !n) return;
		let a = (e) => {
			If(e) && (r(e), n.removeEventListener("pointerleave", a));
		};
		n.addEventListener("pointerleave", a, i);
	};
	return r.forEach((e) => {
		e.addEventListener("pointerenter", o, i);
	}), a;
}
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/utils/is-node-or-child.mjs
var Rf = (e, t) => t ? e === t ? !0 : Rf(e, t.parentElement) : !1, zf = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, Bf = new Set([
	"BUTTON",
	"INPUT",
	"SELECT",
	"TEXTAREA",
	"A"
]);
function Vf(e) {
	return Bf.has(e.tagName) || e.tabIndex !== -1;
}
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/press/utils/state.mjs
var Hf = /* @__PURE__ */ new WeakSet();
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/press/utils/keyboard.mjs
function Uf(e) {
	return (t) => {
		t.key === "Enter" && e(t);
	};
}
function Wf(e, t) {
	e.dispatchEvent(new PointerEvent("pointer" + t, {
		isPrimary: !0,
		bubbles: !0
	}));
}
var Gf = (e, t) => {
	let n = e.currentTarget;
	if (!n) return;
	let r = Uf(() => {
		if (Hf.has(n)) return;
		Wf(n, "down");
		let e = Uf(() => {
			Wf(n, "up");
		});
		n.addEventListener("keyup", e, t), n.addEventListener("blur", () => Wf(n, "cancel"), t);
	});
	n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
//#endregion
//#region node_modules/motion-dom/dist/es/gestures/press/index.mjs
function Kf(e) {
	return zf(e) && !Nf();
}
function qf(e, t, n = {}) {
	let [r, i, a] = Ff(e, n), o = (e) => {
		let r = e.currentTarget;
		if (!Kf(e)) return;
		Hf.add(r);
		let a = t(r, e), o = (e, t) => {
			window.removeEventListener("pointerup", s), window.removeEventListener("pointercancel", c), Hf.has(r) && Hf.delete(r), Kf(e) && typeof a == "function" && a(e, { success: t });
		}, s = (e) => {
			o(e, r === window || r === document || n.useGlobalTarget || Rf(r, e.target));
		}, c = (e) => {
			o(e, !1);
		};
		window.addEventListener("pointerup", s, i), window.addEventListener("pointercancel", c, i);
	};
	return r.forEach((e) => {
		(n.useGlobalTarget ? window : e).addEventListener("pointerdown", o, i), wf(e) && (e.addEventListener("focus", (e) => Gf(e, i)), !Vf(e) && !e.hasAttribute("tabindex") && (e.tabIndex = 0));
	}), a;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/is-svg-element.mjs
function Jf(e) {
	return wc(e) && "ownerSVGElement" in e;
}
//#endregion
//#region node_modules/motion-dom/dist/es/utils/is-svg-svg-element.mjs
function Yf(e) {
	return Jf(e) && e.tagName === "svg";
}
//#endregion
//#region node_modules/motion-dom/dist/es/value/utils/is-motion-value.mjs
var Xf = (e) => !!(e && e.getVelocity), Zf = [
	...sf,
	Y,
	tu
], Qf = (e) => Zf.find(of(e)), $f = a({
	transformPagePoint: (e) => e,
	isStatic: !1,
	reducedMotion: "never"
}), ep = class extends e.Component {
	getSnapshotBeforeUpdate(e) {
		let t = this.props.childRef.current;
		if (t && e.isPresent && !this.props.isPresent) {
			let e = t.offsetParent, n = wf(e) && e.offsetWidth || 0, r = this.props.sizeRef.current;
			r.height = t.offsetHeight || 0, r.width = t.offsetWidth || 0, r.top = t.offsetTop, r.left = t.offsetLeft, r.right = n - r.width - r.left;
		}
		return null;
	}
	componentDidUpdate() {}
	render() {
		return this.props.children;
	}
};
function tp({ children: t, isPresent: n, anchorX: r, root: i }) {
	let a = f(), o = _(null), s = _({
		width: 0,
		height: 0,
		top: 0,
		left: 0,
		right: 0
	}), { nonce: c } = u($f);
	return m(() => {
		let { width: e, height: t, top: l, left: u, right: d } = s.current;
		if (n || !o.current || !e || !t) return;
		let f = r === "left" ? `left: ${u}` : `right: ${d}`;
		o.current.dataset.motionPopId = a;
		let p = document.createElement("style");
		c && (p.nonce = c);
		let m = i ?? document.head;
		return m.appendChild(p), p.sheet && p.sheet.insertRule(`
          [data-motion-pop-id="${a}"] {
            position: absolute !important;
            width: ${e}px !important;
            height: ${t}px !important;
            ${f}px !important;
            top: ${l}px !important;
          }
        `), () => {
			m.contains(p) && m.removeChild(p);
		};
	}, [n]), b(ep, {
		isPresent: n,
		childRef: o,
		sizeRef: s,
		children: e.cloneElement(t, { ref: o })
	});
}
//#endregion
//#region node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs
var np = ({ children: t, initial: n, isPresent: r, onExitComplete: i, custom: a, presenceAffectsLayout: o, mode: s, anchorX: c, root: l }) => {
	let u = fc(rp), d = f(), p = !0, m = g(() => (p = !1, {
		id: d,
		initial: n,
		isPresent: r,
		custom: a,
		onExitComplete: (e) => {
			u.set(e, !0);
			for (let e of u.values()) if (!e) return;
			i && i();
		},
		register: (e) => (u.set(e, !1), () => u.delete(e))
	}), [
		r,
		u,
		i
	]);
	return o && p && (m = { ...m }), g(() => {
		u.forEach((e, t) => u.set(t, !1));
	}, [r]), e.useEffect(() => {
		!r && !u.size && i && i();
	}, [r]), s === "popLayout" && (t = b(tp, {
		isPresent: r,
		anchorX: c,
		root: l,
		children: t
	})), b(hc.Provider, {
		value: m,
		children: t
	});
};
function rp() {
	return /* @__PURE__ */ new Map();
}
//#endregion
//#region node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
function ip(e = !0) {
	let t = u(hc);
	if (t === null) return [!0, null];
	let { isPresent: n, onExitComplete: r, register: i } = t, a = f();
	d(() => {
		if (e) return i(a);
	}, [e]);
	let o = l(() => e && r && r(a), [
		a,
		r,
		e
	]);
	return !n && r ? [!1, o] : [!0];
}
//#endregion
//#region node_modules/framer-motion/dist/es/components/AnimatePresence/utils.mjs
var ap = (e) => e.key || "";
function op(e) {
	let t = [];
	return n.forEach(e, (e) => {
		c(e) && t.push(e);
	}), t;
}
//#endregion
//#region node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs
It();
var sp = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: a = "sync", propagate: o = !1, anchorX: s = "left", root: c }) => {
	let [l, d] = ip(o), f = g(() => op(e), [e]), p = o && !l ? [] : f.map(ap), m = _(!0), h = _(f), x = fc(() => /* @__PURE__ */ new Map()), [S, C] = v(f), [w, T] = v(f);
	mc(() => {
		m.current = !1, h.current = f;
		for (let e = 0; e < w.length; e++) {
			let t = ap(w[e]);
			p.includes(t) ? x.delete(t) : x.get(t) !== !0 && x.set(t, !1);
		}
	}, [
		w,
		p.length,
		p.join("-")
	]);
	let E = [];
	if (f !== S) {
		let e = [...f];
		for (let t = 0; t < w.length; t++) {
			let n = w[t], r = ap(n);
			p.includes(r) || (e.splice(t, 0, n), E.push(n));
		}
		return a === "wait" && E.length && (e = E), T(op(e)), C(f), null;
	}
	z.env.NODE_ENV !== "production" && a === "wait" && w.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its mode is set to \"wait\". This will lead to odd visual behaviour.");
	let { forceRender: D } = u(dc);
	return b(y, { children: w.map((e) => {
		let u = ap(e), g = o && !l ? !1 : f === w || p.includes(u);
		return b(np, {
			isPresent: g,
			initial: !m.current || n ? void 0 : !1,
			custom: t,
			presenceAffectsLayout: i,
			mode: a,
			root: c,
			onExitComplete: g ? void 0 : () => {
				if (x.has(u)) x.set(u, !0);
				else return;
				let e = !0;
				x.forEach((t) => {
					t || (e = !1);
				}), e && (D?.(), T(h.current), o && d?.(), r && r());
			},
			anchorX: s,
			children: e
		}, u);
	}) });
}, cp = a({ strict: !1 }), lp = {
	animation: [
		"animate",
		"variants",
		"whileHover",
		"whileTap",
		"exit",
		"whileInView",
		"whileFocus",
		"whileDrag"
	],
	exit: ["exit"],
	drag: ["drag", "dragControls"],
	focus: ["whileFocus"],
	hover: [
		"whileHover",
		"onHoverStart",
		"onHoverEnd"
	],
	tap: [
		"whileTap",
		"onTap",
		"onTapStart",
		"onTapCancel"
	],
	pan: [
		"onPan",
		"onPanStart",
		"onPanSessionStart",
		"onPanEnd"
	],
	inView: [
		"whileInView",
		"onViewportEnter",
		"onViewportLeave"
	],
	layout: ["layout", "layoutId"]
}, up = {};
for (let e in lp) up[e] = { isEnabled: (t) => lp[e].some((e) => !!t[e]) };
//#endregion
//#region node_modules/framer-motion/dist/es/motion/features/load-features.mjs
function dp(e) {
	for (let t in e) up[t] = {
		...up[t],
		...e[t]
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var fp = new Set(/* @__PURE__ */ "animate.exit.variants.initial.style.values.variants.transition.transformTemplate.custom.inherit.onBeforeLayoutMeasure.onAnimationStart.onAnimationComplete.onUpdate.onDragStart.onDrag.onDragEnd.onMeasureDragConstraints.onDirectionLock.onDragTransitionEnd._dragX._dragY.onHoverStart.onHoverEnd.onViewportEnter.onViewportLeave.globalTapTarget.ignoreStrict.viewport".split("."));
function pp(e) {
	return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || fp.has(e);
}
//#endregion
//#region ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function mp(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
var hp = ne((() => {})), gp = /* @__PURE__ */ O({ default: () => vp }), _p, vp, yp = ne((() => {
	hp(), _p = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, vp = /* @__PURE__ */ mp(function(e) {
		return _p.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
	});
})), bp = (e) => !pp(e);
function xp(e) {
	typeof e == "function" && (bp = (t) => t.startsWith("on") ? !pp(t) : e(t));
}
try {
	xp((yp(), ie(gp)).default);
} catch {}
function Sp(e, t, n) {
	let r = {};
	for (let i in e) i === "values" && typeof e.values == "object" || (bp(i) || n === !0 && pp(i) || !t && !pp(i) || e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
	return r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
var Cp = /* @__PURE__ */ a({});
//#endregion
//#region node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.mjs
function wp(e) {
	return typeof e == "object" && !!e && typeof e.start == "function";
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/is-variant-label.mjs
function Tp(e) {
	return typeof e == "string" || Array.isArray(e);
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/variant-props.mjs
var Ep = [
	"animate",
	"whileInView",
	"whileFocus",
	"whileHover",
	"whileTap",
	"whileDrag",
	"exit"
], Dp = ["initial", ...Ep];
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/is-controlling-variants.mjs
function Op(e) {
	return wp(e.animate) || Dp.some((t) => Tp(e[t]));
}
function kp(e) {
	return !!(Op(e) || e.variants);
}
//#endregion
//#region node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs
function Ap(e, t) {
	if (Op(e)) {
		let { initial: t, animate: n } = e;
		return {
			initial: t === !1 || Tp(t) ? t : void 0,
			animate: Tp(n) ? n : void 0
		};
	}
	return e.inherit === !1 ? {} : t;
}
//#endregion
//#region node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
function jp(e) {
	let { initial: t, animate: n } = Ap(e, u(Cp));
	return g(() => ({
		initial: t,
		animate: n
	}), [Mp(t), Mp(n)]);
}
function Mp(e) {
	return Array.isArray(e) ? e.join(" ") : e;
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
var Np = {};
function Pp(e) {
	for (let t in e) Np[t] = e[t], _l(t) && (Np[t].isCSSVariable = !0);
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.mjs
function Fp(e, { layout: t, layoutId: n }) {
	return dd.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Np[e] || e === "opacity");
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/utils/build-transform.mjs
var Ip = {
	x: "translateX",
	y: "translateY",
	z: "translateZ",
	transformPerspective: "perspective"
}, Lp = ud.length;
function Rp(e, t, n) {
	let r = "", i = !0;
	for (let a = 0; a < Lp; a++) {
		let o = ud[a], s = e[o];
		if (s === void 0) continue;
		let c = !0;
		if (c = typeof s == "number" ? s === +!!o.startsWith("scale") : parseFloat(s) === 0, !c || n) {
			let e = Cf(s, hf[o]);
			if (!c) {
				i = !1;
				let t = Ip[o] || o;
				r += `${t}(${e}) `;
			}
			n && (t[o] = e);
		}
	}
	return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/utils/build-styles.mjs
function zp(e, t, n) {
	let { style: r, vars: i, transformOrigin: a } = e, o = !1, s = !1;
	for (let e in t) {
		let n = t[e];
		if (dd.has(e)) {
			o = !0;
			continue;
		} else if (_l(e)) {
			i[e] = n;
			continue;
		} else {
			let t = Cf(n, hf[e]);
			e.startsWith("origin") ? (s = !0, a[e] = t) : r[e] = t;
		}
	}
	if (t.transform || (o || n ? r.transform = Rp(t, e.transform, n) : r.transform &&= "none"), s) {
		let { originX: e = "50%", originY: t = "50%", originZ: n = 0 } = a;
		r.transformOrigin = `${e} ${t} ${n}`;
	}
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
var Bp = () => ({
	style: {},
	transform: {},
	transformOrigin: {},
	vars: {}
});
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/use-props.mjs
function Vp(e, t, n) {
	for (let r in t) !Xf(t[r]) && !Fp(r, n) && (e[r] = t[r]);
}
function Hp({ transformTemplate: e }, t) {
	return g(() => {
		let n = Bp();
		return zp(n, t, e), Object.assign({}, n.vars, n.style);
	}, [t]);
}
function Up(e, t) {
	let n = e.style || {}, r = {};
	return Vp(r, n, e), Object.assign(r, Hp(e, t)), r;
}
function Wp(e, t) {
	let n = {}, r = Up(e, t);
	return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/utils/path.mjs
var Gp = {
	offset: "stroke-dashoffset",
	array: "stroke-dasharray"
}, Kp = {
	offset: "strokeDashoffset",
	array: "strokeDasharray"
};
function qp(e, t, n = 1, r = 0, i = !0) {
	e.pathLength = 1;
	let a = i ? Gp : Kp;
	e[a.offset] = J.transform(-r);
	let o = J.transform(t), s = J.transform(n);
	e[a.array] = `${o} ${s}`;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.mjs
function Jp(e, { attrX: t, attrY: n, attrScale: r, pathLength: i, pathSpacing: a = 1, pathOffset: o = 0, ...s }, c, l, u) {
	if (zp(e, s, l), c) {
		e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
		return;
	}
	e.attrs = e.style, e.style = {};
	let { attrs: d, style: f } = e;
	d.transform && (f.transform = d.transform, delete d.transform), (f.transform || d.transformOrigin) && (f.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), f.transform && (f.transformBox = u?.transformBox ?? "fill-box", delete d.transformBox), t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), i !== void 0 && qp(d, i, a, o, !1);
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs
var Yp = () => ({
	...Bp(),
	attrs: {}
}), Xp = (e) => typeof e == "string" && e.toLowerCase() === "svg";
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/use-props.mjs
function Zp(e, t, n, r) {
	let i = g(() => {
		let n = Yp();
		return Jp(n, t, Xp(r), e.transformTemplate, e.style), {
			...n.attrs,
			style: { ...n.style }
		};
	}, [t]);
	if (e.style) {
		let t = {};
		Vp(t, e.style, e), i.style = {
			...t,
			...i.style
		};
	}
	return i;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
var Qp = [
	"animate",
	"circle",
	"defs",
	"desc",
	"ellipse",
	"g",
	"image",
	"line",
	"filter",
	"marker",
	"mask",
	"metadata",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"rect",
	"stop",
	"switch",
	"symbol",
	"svg",
	"text",
	"tspan",
	"use",
	"view"
];
//#endregion
//#region node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs
function $p(e) {
	return typeof e != "string" || e.includes("-") ? !1 : !!(Qp.indexOf(e) > -1 || /[A-Z]/u.test(e));
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/dom/use-render.mjs
function em(e, t, n, { latestValues: r }, a, s = !1) {
	let c = ($p(e) ? Zp : Wp)(t, r, a, e), l = Sp(t, typeof e == "string", s), u = e === i ? {} : {
		...l,
		...c,
		ref: n
	}, { children: d } = t, f = g(() => Xf(d) ? d.get() : d, [d]);
	return o(e, {
		...u,
		children: f
	});
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/resolve-variants.mjs
function tm(e) {
	let t = [{}, {}];
	return e?.values.forEach((e, n) => {
		t[0][n] = e.get(), t[1][n] = e.getVelocity();
	}), t;
}
function nm(e, t, n, r) {
	if (typeof t == "function") {
		let [i, a] = tm(r);
		t = t(n === void 0 ? e.custom : n, i, a);
	}
	if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
		let [i, a] = tm(r);
		t = t(n === void 0 ? e.custom : n, i, a);
	}
	return t;
}
//#endregion
//#region node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.mjs
function rm(e) {
	return Xf(e) ? e.get() : e;
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
function im({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
	return {
		latestValues: am(n, r, i, e),
		renderState: t()
	};
}
function am(e, t, n, r) {
	let i = {}, a = r(e, {});
	for (let e in a) i[e] = rm(a[e]);
	let { initial: o, animate: s } = e, c = Op(e), l = kp(e);
	t && l && !c && e.inherit !== !1 && (o === void 0 && (o = t.initial), s === void 0 && (s = t.animate));
	let u = n ? n.initial === !1 : !1;
	u ||= o === !1;
	let d = u ? s : o;
	if (d && typeof d != "boolean" && !wp(d)) {
		let t = Array.isArray(d) ? d : [d];
		for (let n = 0; n < t.length; n++) {
			let r = nm(e, t[n]);
			if (r) {
				let { transitionEnd: e, transition: t, ...n } = r;
				for (let e in n) {
					let t = n[e];
					if (Array.isArray(t)) {
						let e = u ? t.length - 1 : 0;
						t = t[e];
					}
					t !== null && (i[e] = t);
				}
				for (let t in e) i[t] = e[t];
			}
		}
	}
	return i;
}
var om = (e) => (t, n) => {
	let r = u(Cp), i = u(hc), a = () => im(e, t, r, i);
	return n ? a() : fc(a);
};
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.mjs
function sm(e, t, n) {
	let { style: r } = e, i = {};
	for (let a in r) (Xf(r[a]) || t.style && Xf(t.style[a]) || Fp(a, e) || n?.getValue(a)?.liveStyle !== void 0) && (i[a] = r[a]);
	return i;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/use-html-visual-state.mjs
var cm = /* @__PURE__ */ om({
	scrapeMotionValuesFromProps: sm,
	createRenderState: Bp
});
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.mjs
function lm(e, t, n) {
	let r = sm(e, t, n);
	for (let n in e) if (Xf(e[n]) || Xf(t[n])) {
		let t = ud.indexOf(n) === -1 ? n : "attr" + n.charAt(0).toUpperCase() + n.substring(1);
		r[t] = e[n];
	}
	return r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/use-svg-visual-state.mjs
var um = /* @__PURE__ */ om({
	scrapeMotionValuesFromProps: lm,
	createRenderState: Yp
}), dm = Symbol.for("motionComponentSymbol");
//#endregion
//#region node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function fm(e) {
	return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
function pm(e, t, n) {
	return l((r) => {
		r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : fm(n) && (n.current = r));
	}, [t]);
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.mjs
var mm = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), hm = "data-" + mm("framerAppearId"), gm = a({});
//#endregion
//#region node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
function _m(e, t, n, r, i) {
	let { visualElement: a } = u(Cp), o = u(cp), s = u(hc), c = u($f).reducedMotion, l = _(null);
	r ||= o.renderer, !l.current && r && (l.current = r(e, {
		visualState: t,
		parent: a,
		props: n,
		presenceContext: s,
		blockInitialAnimation: s ? s.initial === !1 : !1,
		reducedMotionConfig: c
	}));
	let f = l.current, p = u(gm);
	f && !f.projection && i && (f.type === "html" || f.type === "svg") && vm(l.current, n, i, p);
	let h = _(!1);
	m(() => {
		f && h.current && f.update(n, s);
	});
	let g = n[hm], v = _(!!g && !window.MotionHandoffIsComplete?.(g) && window.MotionHasOptimisedAnimation?.(g));
	return mc(() => {
		f && (h.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), f.scheduleRenderMicrotask(), v.current && f.animationState && f.animationState.animateChanges());
	}), d(() => {
		f && (!v.current && f.animationState && f.animationState.animateChanges(), v.current &&= (queueMicrotask(() => {
			window.MotionHandoffMarkAsComplete?.(g);
		}), !1), f.enteringChildren = void 0);
	}), f;
}
function vm(e, t, n, r) {
	let { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: c, layoutRoot: l, layoutCrossfade: u } = t;
	e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : ym(e.parent)), e.projection.setOptions({
		layoutId: i,
		layout: a,
		alwaysMeasureLayout: !!o || s && fm(s),
		visualElement: e,
		animationType: typeof a == "string" ? a : "both",
		initialPromotionConfig: r,
		crossfade: u,
		layoutScroll: c,
		layoutRoot: l
	});
}
function ym(e) {
	if (e) return e.options.allowProjection === !1 ? ym(e.parent) : e.projection;
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/index.mjs
It();
function bm(e, { forwardMotionProps: t = !1 } = {}, n, r) {
	n && dp(n);
	let i = $p(e) ? um : cm;
	function a(a, o) {
		let s, c = {
			...u($f),
			...a,
			layoutId: xm(a)
		}, { isStatic: l } = c, d = jp(a), f = i(a, l);
		if (!l && pc) {
			Sm(c, n);
			let t = Cm(c);
			s = t.MeasureLayout, d.visualElement = _m(e, f, c, r, t.ProjectionNode);
		}
		return x(Cp.Provider, {
			value: d,
			children: [s && d.visualElement ? b(s, {
				visualElement: d.visualElement,
				...c
			}) : null, em(e, a, pm(f, d.visualElement, o), f, l, t)]
		});
	}
	a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
	let o = s(a);
	return o[dm] = e, o;
}
function xm({ layoutId: e }) {
	let t = u(dc).id;
	return t && e !== void 0 ? t + "-" + e : e;
}
function Sm(e, t) {
	let n = u(cp).strict;
	if (z.env.NODE_ENV !== "production" && t && n) {
		let t = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
		e.ignoreStrict ? bc(!1, t, "lazy-strict-mode") : xc(!1, t, "lazy-strict-mode");
	}
}
function Cm(e) {
	let { drag: t, layout: n } = up;
	if (!t && !n) return {};
	let r = {
		...t,
		...n
	};
	return {
		MeasureLayout: t?.isEnabled(e) || n?.isEnabled(e) ? r.MeasureLayout : void 0,
		ProjectionNode: r.ProjectionNode
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/components/create-proxy.mjs
It();
function wm(e, t) {
	if (typeof Proxy > "u") return bm;
	let n = /* @__PURE__ */ new Map(), r = (n, r) => bm(n, r, e, t);
	return new Proxy((e, t) => (z.env.NODE_ENV !== "production" && Ic(!1, "motion() is deprecated. Use motion.create() instead."), r(e, t)), { get: (i, a) => a === "create" ? r : (n.has(a) || n.set(a, bm(a, void 0, e, t)), n.get(a)) });
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/conversion.mjs
function Tm({ top: e, left: t, right: n, bottom: r }) {
	return {
		x: {
			min: t,
			max: n
		},
		y: {
			min: e,
			max: r
		}
	};
}
function Em({ x: e, y: t }) {
	return {
		top: t.min,
		right: e.max,
		bottom: t.max,
		left: e.min
	};
}
function Dm(e, t) {
	if (!t) return e;
	let n = t({
		x: e.left,
		y: e.top
	}), r = t({
		x: e.right,
		y: e.bottom
	});
	return {
		top: n.y,
		left: n.x,
		bottom: r.y,
		right: r.x
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/utils/has-transform.mjs
function Om(e) {
	return e === void 0 || e === 1;
}
function km({ scale: e, scaleX: t, scaleY: n }) {
	return !Om(e) || !Om(t) || !Om(n);
}
function Am(e) {
	return km(e) || jm(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function jm(e) {
	return Mm(e.x) || Mm(e.y);
}
function Mm(e) {
	return e && e !== "0%";
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/delta-apply.mjs
function Nm(e, t, n) {
	return n + t * (e - n);
}
function Pm(e, t, n, r, i) {
	return i !== void 0 && (e = Nm(e, i, r)), Nm(e, n, r) + t;
}
function Fm(e, t = 0, n = 1, r, i) {
	e.min = Pm(e.min, t, n, r, i), e.max = Pm(e.max, t, n, r, i);
}
function Im(e, { x: t, y: n }) {
	Fm(e.x, t.translate, t.scale, t.originPoint), Fm(e.y, n.translate, n.scale, n.originPoint);
}
var Lm = .999999999999, Rm = 1.0000000000001;
function zm(e, t, n, r = !1) {
	let i = n.length;
	if (!i) return;
	t.x = t.y = 1;
	let a, o;
	for (let s = 0; s < i; s++) {
		a = n[s], o = a.projectionDelta;
		let { visualElement: i } = a.options;
		i && i.props.style && i.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && Hm(e, {
			x: -a.scroll.offset.x,
			y: -a.scroll.offset.y
		}), o && (t.x *= o.x.scale, t.y *= o.y.scale, Im(e, o)), r && Am(a.latestValues) && Hm(e, a.latestValues));
	}
	t.x < Rm && t.x > Lm && (t.x = 1), t.y < Rm && t.y > Lm && (t.y = 1);
}
function Bm(e, t) {
	e.min += t, e.max += t;
}
function Vm(e, t, n, r, i = .5) {
	Fm(e, t, n, X(e.min, e.max, i), r);
}
function Hm(e, t) {
	Vm(e.x, t.x, t.scaleX, t.scale, t.originX), Vm(e.y, t.y, t.scaleY, t.scale, t.originY);
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/utils/measure.mjs
function Um(e, t) {
	return Tm(Dm(e.getBoundingClientRect(), t));
}
function Wm(e, t, n) {
	let r = Um(e, n), { scroll: i } = t;
	return i && (Bm(r.x, i.offset.x), Bm(r.y, i.offset.y)), r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/models.mjs
var Gm = () => ({
	translate: 0,
	scale: 1,
	origin: 0,
	originPoint: 0
}), Km = () => ({
	x: Gm(),
	y: Gm()
}), qm = () => ({
	min: 0,
	max: 0
}), Q = () => ({
	x: qm(),
	y: qm()
}), Jm = { current: null }, Ym = { current: !1 };
//#endregion
//#region node_modules/framer-motion/dist/es/utils/reduced-motion/index.mjs
function Xm() {
	if (Ym.current = !0, pc) if (window.matchMedia) {
		let e = window.matchMedia("(prefers-reduced-motion)"), t = () => Jm.current = e.matches;
		e.addEventListener("change", t), t();
	} else Jm.current = !1;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/store.mjs
var Zm = /* @__PURE__ */ new WeakMap();
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/motion-values.mjs
function Qm(e, t, n) {
	for (let r in t) {
		let i = t[r], a = n[r];
		if (Xf(i)) e.addValue(r, i);
		else if (Xf(a)) e.addValue(r, kf(i, { owner: e }));
		else if (a !== i) if (e.hasValue(r)) {
			let t = e.getValue(r);
			t.liveStyle === !0 ? t.jump(i) : t.hasAnimated || t.set(i);
		} else {
			let t = e.getStaticValue(r);
			e.addValue(r, kf(t === void 0 ? i : t, { owner: e }));
		}
	}
	for (let r in n) t[r] === void 0 && e.removeValue(r);
	return t;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/VisualElement.mjs
It();
var $m = [
	"AnimationStart",
	"AnimationComplete",
	"Update",
	"BeforeLayoutMeasure",
	"LayoutMeasure",
	"LayoutAnimationStart",
	"LayoutAnimationComplete"
], eh = class {
	scrapeMotionValuesFromProps(e, t, n) {
		return {};
	}
	constructor({ parent: e, props: t, presenceContext: n, reducedMotionConfig: r, blockInitialAnimation: i, visualState: a }, o = {}) {
		this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = wd, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
			this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
		}, this.renderScheduledAt = 0, this.scheduleRender = () => {
			let e = ml.now();
			this.renderScheduledAt < e && (this.renderScheduledAt = e, K.render(this.render, !1, !0));
		};
		let { latestValues: s, renderState: c } = a;
		this.latestValues = s, this.baseTarget = { ...s }, this.initialValues = t.initial ? { ...s } : {}, this.renderState = c, this.parent = e, this.props = t, this.presenceContext = n, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = r, this.options = o, this.blockInitialAnimation = !!i, this.isControllingVariants = Op(t), this.isVariantNode = kp(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
		let { willChange: l, ...u } = this.scrapeMotionValuesFromProps(t, {}, this);
		for (let e in u) {
			let t = u[e];
			s[e] !== void 0 && Xf(t) && t.set(s[e]);
		}
	}
	mount(e) {
		this.current = e, Zm.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, t) => this.bindToMotionValue(t, e)), Ym.current || Xm(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Jm.current, z.env.NODE_ENV !== "production" && Ic(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.parent?.addChild(this), this.update(this.props, this.presenceContext);
	}
	unmount() {
		this.projection && this.projection.unmount(), ul(this.notifyUpdate), ul(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
		for (let e in this.events) this.events[e].clear();
		for (let e in this.features) {
			let t = this.features[e];
			t && (t.unmount(), t.isMounted = !1);
		}
		this.current = null;
	}
	addChild(e) {
		this.children.add(e), this.enteringChildren ??= /* @__PURE__ */ new Set(), this.enteringChildren.add(e);
	}
	removeChild(e) {
		this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
	}
	bindToMotionValue(e, t) {
		this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
		let n = dd.has(e);
		n && this.onBindTransform && this.onBindTransform();
		let r = t.on("change", (t) => {
			this.latestValues[e] = t, this.props.onUpdate && K.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
		}), i;
		window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
			r(), i && i(), t.owner && t.stop();
		});
	}
	sortNodePosition(e) {
		return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
	}
	updateFeatures() {
		let e = "animation";
		for (e in up) {
			let t = up[e];
			if (!t) continue;
			let { isEnabled: n, Feature: r } = t;
			if (!this.features[e] && r && n(this.props) && (this.features[e] = new r(this)), this.features[e]) {
				let t = this.features[e];
				t.isMounted ? t.update() : (t.mount(), t.isMounted = !0);
			}
		}
	}
	triggerBuild() {
		this.build(this.renderState, this.latestValues, this.props);
	}
	measureViewportBox() {
		return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Q();
	}
	getStaticValue(e) {
		return this.latestValues[e];
	}
	setStaticValue(e, t) {
		this.latestValues[e] = t;
	}
	update(e, t) {
		(e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
		for (let t = 0; t < $m.length; t++) {
			let n = $m[t];
			this.propEventSubscriptions[n] && (this.propEventSubscriptions[n](), delete this.propEventSubscriptions[n]);
			let r = e["on" + n];
			r && (this.propEventSubscriptions[n] = this.on(n, r));
		}
		this.prevMotionValues = Qm(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
	}
	getProps() {
		return this.props;
	}
	getVariant(e) {
		return this.props.variants ? this.props.variants[e] : void 0;
	}
	getDefaultTransition() {
		return this.props.transition;
	}
	getTransformPagePoint() {
		return this.props.transformPagePoint;
	}
	getClosestVariantNode() {
		return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
	}
	addVariantChild(e) {
		let t = this.getClosestVariantNode();
		if (t) return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
	}
	addValue(e, t) {
		let n = this.values.get(e);
		t !== n && (n && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get());
	}
	removeValue(e) {
		this.values.delete(e);
		let t = this.valueSubscriptions.get(e);
		t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
	}
	hasValue(e) {
		return this.values.has(e);
	}
	getValue(e, t) {
		if (this.props.values && this.props.values[e]) return this.props.values[e];
		let n = this.values.get(e);
		return n === void 0 && t !== void 0 && (n = kf(t === null ? void 0 : t, { owner: this }), this.addValue(e, n)), n;
	}
	readValue(e, t) {
		let n = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
		return n != null && (typeof n == "string" && (Cc(n) || Tc(n)) ? n = parseFloat(n) : !Qf(n) && tu.test(t) && (n = vf(e, t)), this.setBaseTarget(e, Xf(n) ? n.get() : n)), Xf(n) ? n.get() : n;
	}
	setBaseTarget(e, t) {
		this.baseTarget[e] = t;
	}
	getBaseTarget(e) {
		let { initial: t } = this.props, n;
		if (typeof t == "string" || typeof t == "object") {
			let r = nm(this.props, t, this.presenceContext?.custom);
			r && (n = r[e]);
		}
		if (t && n !== void 0) return n;
		let r = this.getBaseTargetFromProps(this.props, e);
		return r !== void 0 && !Xf(r) ? r : this.initialValues[e] !== void 0 && n === void 0 ? void 0 : this.baseTarget[e];
	}
	on(e, t) {
		return this.events[e] || (this.events[e] = new jc()), this.events[e].add(t);
	}
	notify(e, ...t) {
		this.events[e] && this.events[e].notify(...t);
	}
	scheduleRenderMicrotask() {
		Af.render(this.render);
	}
}, th = class extends eh {
	constructor() {
		super(...arguments), this.KeyframeResolver = xf;
	}
	sortInstanceNodePosition(e, t) {
		return e.compareDocumentPosition(t) & 2 ? 1 : -1;
	}
	getBaseTargetFromProps(e, t) {
		return e.style ? e.style[t] : void 0;
	}
	removeValueFromRenderState(e, { vars: t, style: n }) {
		delete t[e], delete n[e];
	}
	handleChildMotionValue() {
		this.childSubscription && (this.childSubscription(), delete this.childSubscription);
		let { children: e } = this.props;
		Xf(e) && (this.childSubscription = e.on("change", (e) => {
			this.current && (this.current.textContent = `${e}`);
		}));
	}
};
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/utils/render.mjs
function nh(e, { style: t, vars: n }, r, i) {
	let a = e.style, o;
	for (o in t) a[o] = t[o];
	for (o in i?.applyProjectionStyles(a, r), n) a.setProperty(o, n[o]);
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/html/HTMLVisualElement.mjs
function rh(e) {
	return window.getComputedStyle(e);
}
var ih = class extends th {
	constructor() {
		super(...arguments), this.type = "html", this.renderInstance = nh;
	}
	readValueFromInstance(e, t) {
		if (dd.has(t)) return this.projection?.isProjecting ? od(t) : cd(e, t);
		{
			let n = rh(e), r = (_l(t) ? n.getPropertyValue(t) : n[t]) || 0;
			return typeof r == "string" ? r.trim() : r;
		}
	}
	measureInstanceViewportBox(e, { transformPagePoint: t }) {
		return Um(e, t);
	}
	build(e, t, n) {
		zp(e, t, n.transformTemplate);
	}
	scrapeMotionValuesFromProps(e, t, n) {
		return sm(e, t, n);
	}
}, ah = new Set([
	"baseFrequency",
	"diffuseConstant",
	"kernelMatrix",
	"kernelUnitLength",
	"keySplines",
	"keyTimes",
	"limitingConeAngle",
	"markerHeight",
	"markerWidth",
	"numOctaves",
	"targetX",
	"targetY",
	"surfaceScale",
	"specularConstant",
	"specularExponent",
	"stdDeviation",
	"tableValues",
	"viewBox",
	"gradientTransform",
	"pathLength",
	"startOffset",
	"textLength",
	"lengthAdjust"
]);
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/utils/render.mjs
function oh(e, t, n, r) {
	nh(e, t, void 0, r);
	for (let n in t.attrs) e.setAttribute(ah.has(n) ? n : mm(n), t.attrs[n]);
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/svg/SVGVisualElement.mjs
var sh = class extends th {
	constructor() {
		super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Q;
	}
	getBaseTargetFromProps(e, t) {
		return e[t];
	}
	readValueFromInstance(e, t) {
		if (dd.has(t)) {
			let e = _f(t);
			return e && e.default || 0;
		}
		return t = ah.has(t) ? t : mm(t), e.getAttribute(t);
	}
	scrapeMotionValuesFromProps(e, t, n) {
		return lm(e, t, n);
	}
	build(e, t, n) {
		Jp(e, t, this.isSVGTag, n.transformTemplate, n.style);
	}
	renderInstance(e, t, n, r) {
		oh(e, t, n, r);
	}
	mount(e) {
		this.isSVGTag = Xp(e.tagName), super.mount(e);
	}
}, ch = (e, t) => $p(e) ? new sh(t) : new ih(t, { allowProjection: e !== i });
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/resolve-dynamic-variants.mjs
function lh(e, t, n) {
	let r = e.getProps();
	return nm(r, t, n === void 0 ? r.custom : n, e);
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.mjs
var uh = (e) => Array.isArray(e);
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/setters.mjs
function dh(e, t, n) {
	e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, kf(n));
}
function fh(e) {
	return uh(e) ? e[e.length - 1] || 0 : e;
}
function ph(e, t) {
	let { transitionEnd: n = {}, transition: r = {}, ...i } = lh(e, t) || {};
	i = {
		...i,
		...n
	};
	for (let t in i) dh(e, t, fh(i[t]));
}
//#endregion
//#region node_modules/framer-motion/dist/es/value/use-will-change/is.mjs
function mh(e) {
	return !!(Xf(e) && e.add);
}
//#endregion
//#region node_modules/framer-motion/dist/es/value/use-will-change/add-will-change.mjs
function hh(e, t) {
	let n = e.getValue("willChange");
	if (mh(n)) return n.add(t);
	if (!n && Sc.WillChange) {
		let n = new Sc.WillChange("auto");
		e.addValue("willChange", n), n.add(t);
	}
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/optimized-appear/get-appear-id.mjs
function gh(e) {
	return e.props[hm];
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/animators/waapi/utils/get-final-keyframe.mjs
var _h = (e) => e !== null;
function vh(e, { repeat: t, repeatType: n = "loop" }, r) {
	let i = e.filter(_h), a = t && n !== "loop" && t % 2 == 1 ? 0 : i.length - 1;
	return !a || r === void 0 ? i[a] : r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/utils/default-transitions.mjs
var yh = {
	type: "spring",
	stiffness: 500,
	damping: 25,
	restSpeed: 10
}, bh = (e) => ({
	type: "spring",
	stiffness: 550,
	damping: e === 0 ? 2 * Math.sqrt(550) : 30,
	restSpeed: 10
}), xh = {
	type: "keyframes",
	duration: .8
}, Sh = {
	type: "keyframes",
	ease: [
		.25,
		.1,
		.35,
		1
	],
	duration: .3
}, Ch = (e, { keyframes: t }) => t.length > 2 ? xh : dd.has(e) ? e.startsWith("scale") ? bh(t[1]) : yh : Sh;
//#endregion
//#region node_modules/framer-motion/dist/es/animation/utils/is-transition-defined.mjs
function wh({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: c, elapsed: l, ...u }) {
	return !!Object.keys(u).length;
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/interfaces/motion-value.mjs
var Th = (e, t, n, r = {}, i, a) => (o) => {
	let s = nf(r, e) || {}, c = s.delay || r.delay || 0, { elapsed: l = 0 } = r;
	l -= /* @__PURE__ */ Mc(c);
	let u = {
		keyframes: Array.isArray(n) ? n : [null, n],
		ease: "easeOut",
		velocity: t.getVelocity(),
		...s,
		delay: -l,
		onUpdate: (e) => {
			t.set(e), s.onUpdate && s.onUpdate(e);
		},
		onComplete: () => {
			o(), s.onComplete && s.onComplete();
		},
		name: e,
		motionValue: t,
		element: a ? void 0 : i
	};
	wh(s) || Object.assign(u, Ch(e, u)), u.duration &&= /* @__PURE__ */ Mc(u.duration), u.repeatDelay &&= /* @__PURE__ */ Mc(u.repeatDelay), u.from !== void 0 && (u.keyframes[0] = u.from);
	let d = !1;
	if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Kd(u), u.delay === 0 && (d = !0)), (Sc.instantAnimations || Sc.skipAnimations) && (d = !0, Kd(u), u.delay = 0), u.allowFlatten = !s.type && !s.ease, d && !a && t.get() !== void 0) {
		let e = vh(u.keyframes, s);
		if (e !== void 0) {
			K.update(() => {
				u.onUpdate(e), u.onComplete();
			});
			return;
		}
	}
	return s.isSync ? new Xu(u) : new Zd(u);
};
//#endregion
//#region node_modules/framer-motion/dist/es/animation/interfaces/visual-element-target.mjs
function Eh({ protectedKeys: e, needsAnimating: t }, n) {
	let r = e.hasOwnProperty(n) && t[n] !== !0;
	return t[n] = !1, r;
}
function Dh(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
	let { transition: a = e.getDefaultTransition(), transitionEnd: o, ...s } = t;
	r && (a = r);
	let c = [], l = i && e.animationState && e.animationState.getState()[i];
	for (let t in s) {
		let r = e.getValue(t, e.latestValues[t] ?? null), i = s[t];
		if (i === void 0 || l && Eh(l, t)) continue;
		let o = {
			delay: n,
			...nf(a || {}, t)
		}, u = r.get();
		if (u !== void 0 && !r.isAnimating && !Array.isArray(i) && i === u && !o.velocity) continue;
		let d = !1;
		if (window.MotionHandoffAnimation) {
			let n = gh(e);
			if (n) {
				let e = window.MotionHandoffAnimation(n, t, K);
				e !== null && (o.startTime = e, d = !0);
			}
		}
		hh(e, t), r.start(Th(t, r, i, e.shouldReduceMotion && rf.has(t) ? { type: !1 } : o, e, d));
		let f = r.animation;
		f && c.push(f);
	}
	return o && Promise.all(c).then(() => {
		K.update(() => {
			o && ph(e, o);
		});
	}), c;
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/utils/calc-child-stagger.mjs
function Oh(e, t, n, r = 0, i = 1) {
	let a = Array.from(e).sort((e, t) => e.sortNodePosition(t)).indexOf(t), o = e.size, s = (o - 1) * r;
	return typeof n == "function" ? n(a, o) : i === 1 ? a * r : s - a * r;
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/interfaces/visual-element-variant.mjs
function kh(e, t, n = {}) {
	let r = lh(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0), { transition: i = e.getDefaultTransition() || {} } = r || {};
	n.transitionOverride && (i = n.transitionOverride);
	let a = r ? () => Promise.all(Dh(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (r = 0) => {
		let { delayChildren: a = 0, staggerChildren: o, staggerDirection: s } = i;
		return Ah(e, t, r, a, o, s, n);
	} : () => Promise.resolve(), { when: s } = i;
	if (s) {
		let [e, t] = s === "beforeChildren" ? [a, o] : [o, a];
		return e().then(() => t());
	} else return Promise.all([a(), o(n.delay)]);
}
function Ah(e, t, n = 0, r = 0, i = 0, a = 1, o) {
	let s = [];
	for (let c of e.variantChildren) c.notify("AnimationStart", t), s.push(kh(c, t, {
		...o,
		delay: n + (typeof r == "function" ? 0 : r) + Oh(e.variantChildren, c, r, i, a)
	}).then(() => c.notify("AnimationComplete", t)));
	return Promise.all(s);
}
//#endregion
//#region node_modules/framer-motion/dist/es/animation/interfaces/visual-element.mjs
function jh(e, t, n = {}) {
	e.notify("AnimationStart", t);
	let r;
	if (Array.isArray(t)) {
		let i = t.map((t) => kh(e, t, n));
		r = Promise.all(i);
	} else if (typeof t == "string") r = kh(e, t, n);
	else {
		let i = typeof t == "function" ? lh(e, t, n.custom) : t;
		r = Promise.all(Dh(e, i, n));
	}
	return r.then(() => {
		e.notify("AnimationComplete", t);
	});
}
//#endregion
//#region node_modules/framer-motion/dist/es/utils/shallow-compare.mjs
function Mh(e, t) {
	if (!Array.isArray(t)) return !1;
	let n = t.length;
	if (n !== e.length) return !1;
	for (let r = 0; r < n; r++) if (t[r] !== e[r]) return !1;
	return !0;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/get-variant-context.mjs
var Nh = Dp.length;
function Ph(e) {
	if (!e) return;
	if (!e.isControllingVariants) {
		let t = e.parent && Ph(e.parent) || {};
		return e.props.initial !== void 0 && (t.initial = e.props.initial), t;
	}
	let t = {};
	for (let n = 0; n < Nh; n++) {
		let r = Dp[n], i = e.props[r];
		(Tp(i) || i === !1) && (t[r] = i);
	}
	return t;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/animation-state.mjs
var Fh = [...Ep].reverse(), Ih = Ep.length;
function Lh(e) {
	return (t) => Promise.all(t.map(({ animation: t, options: n }) => jh(e, t, n)));
}
function Rh(e) {
	let t = Lh(e), n = Vh(), r = !0, i = (t) => (n, r) => {
		let i = lh(e, r, t === "exit" ? e.presenceContext?.custom : void 0);
		if (i) {
			let { transition: e, transitionEnd: t, ...r } = i;
			n = {
				...n,
				...r,
				...t
			};
		}
		return n;
	};
	function a(n) {
		t = n(e);
	}
	function o(a) {
		let { props: o } = e, s = Ph(e.parent) || {}, c = [], l = /* @__PURE__ */ new Set(), u = {}, d = Infinity;
		for (let t = 0; t < Ih; t++) {
			let f = Fh[t], p = n[f], m = o[f] === void 0 ? s[f] : o[f], h = Tp(m), g = f === a ? p.isActive : null;
			g === !1 && (d = t);
			let _ = m === s[f] && m !== o[f] && h;
			if (_ && r && e.manuallyAnimateOnMount && (_ = !1), p.protectedKeys = { ...u }, !p.isActive && g === null || !m && !p.prevProp || wp(m) || typeof m == "boolean") continue;
			let v = zh(p.prevProp, m), y = v || f === a && p.isActive && !_ && h || t > d && h, b = !1, x = Array.isArray(m) ? m : [m], S = x.reduce(i(f), {});
			g === !1 && (S = {});
			let { prevResolvedValues: C = {} } = p, w = {
				...C,
				...S
			}, T = (t) => {
				y = !0, l.has(t) && (b = !0, l.delete(t)), p.needsAnimating[t] = !0;
				let n = e.getValue(t);
				n && (n.liveStyle = !1);
			};
			for (let e in w) {
				let t = S[e], n = C[e];
				if (u.hasOwnProperty(e)) continue;
				let r = !1;
				r = uh(t) && uh(n) ? !Mh(t, n) : t !== n, r ? t == null ? l.add(e) : T(e) : t !== void 0 && l.has(e) ? T(e) : p.protectedKeys[e] = !0;
			}
			p.prevProp = m, p.prevResolvedValues = S, p.isActive && (u = {
				...u,
				...S
			}), r && e.blockInitialAnimation && (y = !1);
			let E = _ && v;
			y && (!E || b) && c.push(...x.map((t) => {
				let n = { type: f };
				if (typeof t == "string" && r && !E && e.manuallyAnimateOnMount && e.parent) {
					let { parent: r } = e, i = lh(r, t);
					if (r.enteringChildren && i) {
						let { delayChildren: t } = i.transition || {};
						n.delay = Oh(r.enteringChildren, e, t);
					}
				}
				return {
					animation: t,
					options: n
				};
			}));
		}
		if (l.size) {
			let t = {};
			if (typeof o.initial != "boolean") {
				let n = lh(e, Array.isArray(o.initial) ? o.initial[0] : o.initial);
				n && n.transition && (t.transition = n.transition);
			}
			l.forEach((n) => {
				let r = e.getBaseTarget(n), i = e.getValue(n);
				i && (i.liveStyle = !0), t[n] = r ?? null;
			}), c.push({ animation: t });
		}
		let f = !!c.length;
		return r && (o.initial === !1 || o.initial === o.animate) && !e.manuallyAnimateOnMount && (f = !1), r = !1, f ? t(c) : Promise.resolve();
	}
	function s(t, r) {
		if (n[t].isActive === r) return Promise.resolve();
		e.variantChildren?.forEach((e) => e.animationState?.setActive(t, r)), n[t].isActive = r;
		let i = o(t);
		for (let e in n) n[e].protectedKeys = {};
		return i;
	}
	return {
		animateChanges: o,
		setActive: s,
		setAnimateFunction: a,
		getState: () => n,
		reset: () => {
			n = Vh(), r = !0;
		}
	};
}
function zh(e, t) {
	return typeof t == "string" ? t !== e : Array.isArray(t) ? !Mh(t, e) : !1;
}
function Bh(e = !1) {
	return {
		isActive: e,
		protectedKeys: {},
		needsAnimating: {},
		prevResolvedValues: {}
	};
}
function Vh() {
	return {
		animate: Bh(!0),
		whileInView: Bh(),
		whileHover: Bh(),
		whileTap: Bh(),
		whileDrag: Bh(),
		whileFocus: Bh(),
		exit: Bh()
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/features/Feature.mjs
var Hh = class {
	constructor(e) {
		this.isMounted = !1, this.node = e;
	}
	update() {}
}, Uh = class extends Hh {
	constructor(e) {
		super(e), e.animationState ||= Rh(e);
	}
	updateAnimationControlsSubscription() {
		let { animate: e } = this.node.getProps();
		wp(e) && (this.unmountControls = e.subscribe(this.node));
	}
	mount() {
		this.updateAnimationControlsSubscription();
	}
	update() {
		let { animate: e } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
		e !== t && this.updateAnimationControlsSubscription();
	}
	unmount() {
		this.node.animationState.reset(), this.unmountControls?.();
	}
}, Wh = 0, Gh = {
	animation: { Feature: Uh },
	exit: { Feature: class extends Hh {
		constructor() {
			super(...arguments), this.id = Wh++;
		}
		update() {
			if (!this.node.presenceContext) return;
			let { isPresent: e, onExitComplete: t } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
			if (!this.node.animationState || e === n) return;
			let r = this.node.animationState.setActive("exit", !e);
			t && !e && r.then(() => {
				t(this.id);
			});
		}
		mount() {
			let { register: e, onExitComplete: t } = this.node.presenceContext || {};
			t && t(this.id), e && (this.unmount = e(this.id));
		}
		unmount() {}
	} }
};
//#endregion
//#region node_modules/framer-motion/dist/es/events/add-dom-event.mjs
function Kh(e, t, n, r = { passive: !0 }) {
	return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
//#endregion
//#region node_modules/framer-motion/dist/es/events/event-info.mjs
function qh(e) {
	return { point: {
		x: e.pageX,
		y: e.pageY
	} };
}
var Jh = (e) => (t) => zf(t) && e(t, qh(t));
//#endregion
//#region node_modules/framer-motion/dist/es/events/add-pointer-event.mjs
function Yh(e, t, n, r) {
	return Kh(e, t, Jh(n), r);
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/delta-calc.mjs
var Xh = 1e-4, Zh = 1 - Xh, Qh = 1 + Xh, $h = .01, eg = 0 - $h, tg = 0 + $h;
function ng(e) {
	return e.max - e.min;
}
function rg(e, t, n) {
	return Math.abs(e - t) <= n;
}
function ig(e, t, n, r = .5) {
	e.origin = r, e.originPoint = X(t.min, t.max, e.origin), e.scale = ng(n) / ng(t), e.translate = X(n.min, n.max, e.origin) - e.originPoint, (e.scale >= Zh && e.scale <= Qh || isNaN(e.scale)) && (e.scale = 1), (e.translate >= eg && e.translate <= tg || isNaN(e.translate)) && (e.translate = 0);
}
function ag(e, t, n, r) {
	ig(e.x, t.x, n.x, r ? r.originX : void 0), ig(e.y, t.y, n.y, r ? r.originY : void 0);
}
function og(e, t, n) {
	e.min = n.min + t.min, e.max = e.min + ng(t);
}
function sg(e, t, n) {
	og(e.x, t.x, n.x), og(e.y, t.y, n.y);
}
function cg(e, t, n) {
	e.min = t.min - n.min, e.max = e.min + ng(t);
}
function lg(e, t, n) {
	cg(e.x, t.x, n.x), cg(e.y, t.y, n.y);
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
function ug(e) {
	return [e("x"), e("y")];
}
//#endregion
//#region node_modules/framer-motion/dist/es/utils/get-context-window.mjs
var dg = ({ current: e }) => e ? e.ownerDocument.defaultView : null, fg = (e, t) => Math.abs(e - t);
function pg(e, t) {
	let n = fg(e.x, t.x), r = fg(e.y, t.y);
	return Math.sqrt(n ** 2 + r ** 2);
}
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/pan/PanSession.mjs
var mg = class {
	constructor(e, t, { transformPagePoint: n, contextWindow: r = window, dragSnapToOrigin: i = !1, distanceThreshold: a = 3 } = {}) {
		if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
			if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
			let e = _g(this.lastMoveEventInfo, this.history), t = this.startEvent !== null, n = pg(e.offset, {
				x: 0,
				y: 0
			}) >= this.distanceThreshold;
			if (!t && !n) return;
			let { point: r } = e, { timestamp: i } = q;
			this.history.push({
				...r,
				timestamp: i
			});
			let { onStart: a, onMove: o } = this.handlers;
			t || (a && a(this.lastMoveEvent, e), this.startEvent = this.lastMoveEvent), o && o(this.lastMoveEvent, e);
		}, this.handlePointerMove = (e, t) => {
			this.lastMoveEvent = e, this.lastMoveEventInfo = hg(t, this.transformPagePoint), K.update(this.updatePoint, !0);
		}, this.handlePointerUp = (e, t) => {
			this.end();
			let { onEnd: n, onSessionEnd: r, resumeAnimation: i } = this.handlers;
			if (this.dragSnapToOrigin && i && i(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
			let a = _g(e.type === "pointercancel" ? this.lastMoveEventInfo : hg(t, this.transformPagePoint), this.history);
			this.startEvent && n && n(e, a), r && r(e, a);
		}, !zf(e)) return;
		this.dragSnapToOrigin = i, this.handlers = t, this.transformPagePoint = n, this.distanceThreshold = a, this.contextWindow = r || window;
		let o = hg(qh(e), this.transformPagePoint), { point: s } = o, { timestamp: c } = q;
		this.history = [{
			...s,
			timestamp: c
		}];
		let { onSessionStart: l } = t;
		l && l(e, _g(o, this.history)), this.removeListeners = kc(Yh(this.contextWindow, "pointermove", this.handlePointerMove), Yh(this.contextWindow, "pointerup", this.handlePointerUp), Yh(this.contextWindow, "pointercancel", this.handlePointerUp));
	}
	updateHandlers(e) {
		this.handlers = e;
	}
	end() {
		this.removeListeners && this.removeListeners(), ul(this.updatePoint);
	}
};
function hg(e, t) {
	return t ? { point: t(e.point) } : e;
}
function gg(e, t) {
	return {
		x: e.x - t.x,
		y: e.y - t.y
	};
}
function _g({ point: e }, t) {
	return {
		point: e,
		delta: gg(e, yg(t)),
		offset: gg(e, vg(t)),
		velocity: bg(t, .1)
	};
}
function vg(e) {
	return e[0];
}
function yg(e) {
	return e[e.length - 1];
}
function bg(e, t) {
	if (e.length < 2) return {
		x: 0,
		y: 0
	};
	let n = e.length - 1, r = null, i = yg(e);
	for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Mc(t)));) n--;
	if (!r) return {
		x: 0,
		y: 0
	};
	let a = /* @__PURE__ */ Nc(i.timestamp - r.timestamp);
	if (a === 0) return {
		x: 0,
		y: 0
	};
	let o = {
		x: (i.x - r.x) / a,
		y: (i.y - r.y) / a
	};
	return o.x === Infinity && (o.x = 0), o.y === Infinity && (o.y = 0), o;
}
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs
function xg(e, { min: t, max: n }, r) {
	return t !== void 0 && e < t ? e = r ? X(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? X(n, e, r.max) : Math.min(e, n)), e;
}
function Sg(e, t, n) {
	return {
		min: t === void 0 ? void 0 : e.min + t,
		max: n === void 0 ? void 0 : e.max + n - (e.max - e.min)
	};
}
function Cg(e, { top: t, left: n, bottom: r, right: i }) {
	return {
		x: Sg(e.x, n, i),
		y: Sg(e.y, t, r)
	};
}
function wg(e, t) {
	let n = t.min - e.min, r = t.max - e.max;
	return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), {
		min: n,
		max: r
	};
}
function Tg(e, t) {
	return {
		x: wg(e.x, t.x),
		y: wg(e.y, t.y)
	};
}
function Eg(e, t) {
	let n = .5, r = ng(e), i = ng(t);
	return i > r ? n = /* @__PURE__ */ Ac(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ Ac(e.min, e.max - i, t.min)), vc(0, 1, n);
}
function Dg(e, t) {
	let n = {};
	return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var Og = .35;
function kg(e = Og) {
	return e === !1 ? e = 0 : e === !0 && (e = Og), {
		x: Ag(e, "left", "right"),
		y: Ag(e, "top", "bottom")
	};
}
function Ag(e, t, n) {
	return {
		min: jg(e, t),
		max: jg(e, n)
	};
}
function jg(e, t) {
	return typeof e == "number" ? e : e[t] || 0;
}
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs
var Mg = /* @__PURE__ */ new WeakMap(), Ng = class {
	constructor(e) {
		this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
			x: 0,
			y: 0
		}, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Q(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
	}
	start(e, { snapToCursor: t = !1, distanceThreshold: n } = {}) {
		let { presenceContext: r } = this.visualElement;
		if (r && r.isPresent === !1) return;
		let i = (e) => {
			let { dragSnapToOrigin: n } = this.getProps();
			n ? this.pauseAnimation() : this.stopAnimation(), t && this.snapToCursor(qh(e).point);
		}, a = (e, t) => {
			let { drag: n, dragPropagation: r, onDragStart: i } = this.getProps();
			if (n && !r && (this.openDragLock && this.openDragLock(), this.openDragLock = Pf(n), !this.openDragLock)) return;
			this.latestPointerEvent = e, this.latestPanInfo = t, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ug((e) => {
				let t = this.getAxisMotionValue(e).get() || 0;
				if (Ll.test(t)) {
					let { projection: n } = this.visualElement;
					if (n && n.layout) {
						let r = n.layout.layoutBox[e];
						r && (t = ng(r) * (parseFloat(t) / 100));
					}
				}
				this.originPoint[e] = t;
			}), i && K.postRender(() => i(e, t)), hh(this.visualElement, "transform");
			let { animationState: a } = this.visualElement;
			a && a.setActive("whileDrag", !0);
		}, o = (e, t) => {
			this.latestPointerEvent = e, this.latestPanInfo = t;
			let { dragPropagation: n, dragDirectionLock: r, onDirectionLock: i, onDrag: a } = this.getProps();
			if (!n && !this.openDragLock) return;
			let { offset: o } = t;
			if (r && this.currentDirection === null) {
				this.currentDirection = Fg(o), this.currentDirection !== null && i && i(this.currentDirection);
				return;
			}
			this.updateAxis("x", t.point, o), this.updateAxis("y", t.point, o), this.visualElement.render(), a && a(e, t);
		}, s = (e, t) => {
			this.latestPointerEvent = e, this.latestPanInfo = t, this.stop(e, t), this.latestPointerEvent = null, this.latestPanInfo = null;
		}, c = () => ug((e) => this.getAnimationState(e) === "paused" && this.getAxisMotionValue(e).animation?.play()), { dragSnapToOrigin: l } = this.getProps();
		this.panSession = new mg(e, {
			onSessionStart: i,
			onStart: a,
			onMove: o,
			onSessionEnd: s,
			resumeAnimation: c
		}, {
			transformPagePoint: this.visualElement.getTransformPagePoint(),
			dragSnapToOrigin: l,
			distanceThreshold: n,
			contextWindow: dg(this.visualElement)
		});
	}
	stop(e, t) {
		let n = e || this.latestPointerEvent, r = t || this.latestPanInfo, i = this.isDragging;
		if (this.cancel(), !i || !r || !n) return;
		let { velocity: a } = r;
		this.startAnimation(a);
		let { onDragEnd: o } = this.getProps();
		o && K.postRender(() => o(n, r));
	}
	cancel() {
		this.isDragging = !1;
		let { projection: e, animationState: t } = this.visualElement;
		e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
		let { dragPropagation: n } = this.getProps();
		!n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), t && t.setActive("whileDrag", !1);
	}
	updateAxis(e, t, n) {
		let { drag: r } = this.getProps();
		if (!n || !Pg(e, r, this.currentDirection)) return;
		let i = this.getAxisMotionValue(e), a = this.originPoint[e] + n[e];
		this.constraints && this.constraints[e] && (a = xg(a, this.constraints[e], this.elastic[e])), i.set(a);
	}
	resolveConstraints() {
		let { dragConstraints: e, dragElastic: t } = this.getProps(), n = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, r = this.constraints;
		e && fm(e) ? this.constraints ||= this.resolveRefConstraints() : e && n ? this.constraints = Cg(n.layoutBox, e) : this.constraints = !1, this.elastic = kg(t), r !== this.constraints && n && this.constraints && !this.hasMutatedConstraints && ug((e) => {
			this.constraints !== !1 && this.getAxisMotionValue(e) && (this.constraints[e] = Dg(n.layoutBox[e], this.constraints[e]));
		});
	}
	resolveRefConstraints() {
		let { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps();
		if (!e || !fm(e)) return !1;
		let n = e.current;
		xc(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
		let { projection: r } = this.visualElement;
		if (!r || !r.layout) return !1;
		let i = Wm(n, r.root, this.visualElement.getTransformPagePoint()), a = Tg(r.layout.layoutBox, i);
		if (t) {
			let e = t(Em(a));
			this.hasMutatedConstraints = !!e, e && (a = Tm(e));
		}
		return a;
	}
	startAnimation(e) {
		let { drag: t, dragMomentum: n, dragElastic: r, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: o } = this.getProps(), s = this.constraints || {}, c = ug((o) => {
			if (!Pg(o, t, this.currentDirection)) return;
			let c = s && s[o] || {};
			a && (c = {
				min: 0,
				max: 0
			});
			let l = r ? 200 : 1e6, u = r ? 40 : 1e7, d = {
				type: "inertia",
				velocity: n ? e[o] : 0,
				bounceStiffness: l,
				bounceDamping: u,
				timeConstant: 750,
				restDelta: 1,
				restSpeed: 10,
				...i,
				...c
			};
			return this.startAxisValueAnimation(o, d);
		});
		return Promise.all(c).then(o);
	}
	startAxisValueAnimation(e, t) {
		let n = this.getAxisMotionValue(e);
		return hh(this.visualElement, e), n.start(Th(e, n, 0, t, this.visualElement, !1));
	}
	stopAnimation() {
		ug((e) => this.getAxisMotionValue(e).stop());
	}
	pauseAnimation() {
		ug((e) => this.getAxisMotionValue(e).animation?.pause());
	}
	getAnimationState(e) {
		return this.getAxisMotionValue(e).animation?.state;
	}
	getAxisMotionValue(e) {
		let t = `_drag${e.toUpperCase()}`, n = this.visualElement.getProps();
		return n[t] || this.visualElement.getValue(e, (n.initial ? n.initial[e] : void 0) || 0);
	}
	snapToCursor(e) {
		ug((t) => {
			let { drag: n } = this.getProps();
			if (!Pg(t, n, this.currentDirection)) return;
			let { projection: r } = this.visualElement, i = this.getAxisMotionValue(t);
			if (r && r.layout) {
				let { min: n, max: a } = r.layout.layoutBox[t];
				i.set(e[t] - X(n, a, .5));
			}
		});
	}
	scalePositionWithinConstraints() {
		if (!this.visualElement.current) return;
		let { drag: e, dragConstraints: t } = this.getProps(), { projection: n } = this.visualElement;
		if (!fm(t) || !n || !this.constraints) return;
		this.stopAnimation();
		let r = {
			x: 0,
			y: 0
		};
		ug((e) => {
			let t = this.getAxisMotionValue(e);
			if (t && this.constraints !== !1) {
				let n = t.get();
				r[e] = Eg({
					min: n,
					max: n
				}, this.constraints[e]);
			}
		});
		let { transformTemplate: i } = this.visualElement.getProps();
		this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), ug((t) => {
			if (!Pg(t, e, null)) return;
			let n = this.getAxisMotionValue(t), { min: i, max: a } = this.constraints[t];
			n.set(X(i, a, r[t]));
		});
	}
	addListeners() {
		if (!this.visualElement.current) return;
		Mg.set(this.visualElement, this);
		let e = this.visualElement.current, t = Yh(e, "pointerdown", (e) => {
			let { drag: t, dragListener: n = !0 } = this.getProps();
			t && n && this.start(e);
		}), n = () => {
			let { dragConstraints: e } = this.getProps();
			fm(e) && e.current && (this.constraints = this.resolveRefConstraints());
		}, { projection: r } = this.visualElement, i = r.addEventListener("measure", n);
		r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), K.read(n);
		let a = Kh(window, "resize", () => this.scalePositionWithinConstraints()), o = r.addEventListener("didUpdate", (({ delta: e, hasLayoutChanged: t }) => {
			this.isDragging && t && (ug((t) => {
				let n = this.getAxisMotionValue(t);
				n && (this.originPoint[t] += e[t].translate, n.set(n.get() + e[t].translate));
			}), this.visualElement.render());
		}));
		return () => {
			a(), t(), i(), o && o();
		};
	}
	getProps() {
		let e = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: n = !1, dragPropagation: r = !1, dragConstraints: i = !1, dragElastic: a = Og, dragMomentum: o = !0 } = e;
		return {
			...e,
			drag: t,
			dragDirectionLock: n,
			dragPropagation: r,
			dragConstraints: i,
			dragElastic: a,
			dragMomentum: o
		};
	}
};
function Pg(e, t, n) {
	return (t === !0 || t === e) && (n === null || n === e);
}
function Fg(e, t = 10) {
	let n = null;
	return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/drag/index.mjs
var Ig = class extends Hh {
	constructor(e) {
		super(e), this.removeGroupControls = Dc, this.removeListeners = Dc, this.controls = new Ng(e);
	}
	mount() {
		let { dragControls: e } = this.node.getProps();
		e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Dc;
	}
	unmount() {
		this.removeGroupControls(), this.removeListeners();
	}
}, Lg = (e) => (t, n) => {
	e && K.postRender(() => e(t, n));
}, Rg = class extends Hh {
	constructor() {
		super(...arguments), this.removePointerDownListener = Dc;
	}
	onPointerDown(e) {
		this.session = new mg(e, this.createPanHandlers(), {
			transformPagePoint: this.node.getTransformPagePoint(),
			contextWindow: dg(this.node)
		});
	}
	createPanHandlers() {
		let { onPanSessionStart: e, onPanStart: t, onPan: n, onPanEnd: r } = this.node.getProps();
		return {
			onSessionStart: Lg(e),
			onStart: Lg(t),
			onMove: n,
			onEnd: (e, t) => {
				delete this.session, r && K.postRender(() => r(e, t));
			}
		};
	}
	mount() {
		this.removePointerDownListener = Yh(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
	}
	update() {
		this.session && this.session.updateHandlers(this.createPanHandlers());
	}
	unmount() {
		this.removePointerDownListener(), this.session && this.session.end();
	}
}, zg = {
	hasAnimatedSinceResize: !0,
	hasEverUpdated: !1
};
//#endregion
//#region node_modules/framer-motion/dist/es/projection/styles/scale-border-radius.mjs
function Bg(e, t) {
	return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var Vg = { correct: (e, t) => {
	if (!t.target) return e;
	if (typeof e == "string") if (J.test(e)) e = parseFloat(e);
	else return e;
	return `${Bg(e, t.target.x)}% ${Bg(e, t.target.y)}%`;
} }, Hg = { correct: (e, { treeScale: t, projectionDelta: n }) => {
	let r = e, i = tu.parse(e);
	if (i.length > 5) return r;
	let a = tu.createTransformer(e), o = typeof i[0] == "number" ? 0 : 1, s = n.x.scale * t.x, c = n.y.scale * t.y;
	i[0 + o] /= s, i[1 + o] /= c;
	let l = X(s, c, .5);
	return typeof i[2 + o] == "number" && (i[2 + o] /= l), typeof i[3 + o] == "number" && (i[3 + o] /= l), a(i);
} }, Ug = !1, Wg = class extends r {
	componentDidMount() {
		let { visualElement: e, layoutGroup: t, switchLayoutGroup: n, layoutId: r } = this.props, { projection: i } = e;
		Pp(Kg), i && (t.group && t.group.add(i), n && n.register && r && n.register(i), Ug && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
			this.safeToRemove();
		}), i.setOptions({
			...i.options,
			onExitComplete: () => this.safeToRemove()
		})), zg.hasEverUpdated = !0;
	}
	getSnapshotBeforeUpdate(e) {
		let { layoutDependency: t, visualElement: n, drag: r, isPresent: i } = this.props, { projection: a } = n;
		return a ? (a.isPresent = i, Ug = !0, r || e.layoutDependency !== t || t === void 0 || e.isPresent !== i ? a.willUpdate() : this.safeToRemove(), e.isPresent !== i && (i ? a.promote() : a.relegate() || K.postRender(() => {
			let e = a.getStack();
			(!e || !e.members.length) && this.safeToRemove();
		})), null) : null;
	}
	componentDidUpdate() {
		let { projection: e } = this.props.visualElement;
		e && (e.root.didUpdate(), Af.postRender(() => {
			!e.currentAnimation && e.isLead() && this.safeToRemove();
		}));
	}
	componentWillUnmount() {
		let { visualElement: e, layoutGroup: t, switchLayoutGroup: n } = this.props, { projection: r } = e;
		Ug = !0, r && (r.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(r), n && n.deregister && n.deregister(r));
	}
	safeToRemove() {
		let { safeToRemove: e } = this.props;
		e && e();
	}
	render() {
		return null;
	}
};
function Gg(e) {
	let [t, n] = ip(), r = u(dc);
	return b(Wg, {
		...e,
		layoutGroup: r,
		switchLayoutGroup: u(gm),
		isPresent: t,
		safeToRemove: n
	});
}
var Kg = {
	borderRadius: {
		...Vg,
		applyTo: [
			"borderTopLeftRadius",
			"borderTopRightRadius",
			"borderBottomLeftRadius",
			"borderBottomRightRadius"
		]
	},
	borderTopLeftRadius: Vg,
	borderTopRightRadius: Vg,
	borderBottomLeftRadius: Vg,
	borderBottomRightRadius: Vg,
	boxShadow: Hg
};
//#endregion
//#region node_modules/framer-motion/dist/es/animation/animate/single-value.mjs
function qg(e, t, n) {
	let r = Xf(e) ? e : kf(e);
	return r.start(Th("", r, t, n)), r.animation;
}
//#endregion
//#region node_modules/framer-motion/dist/es/render/utils/compare-by-depth.mjs
var Jg = (e, t) => e.depth - t.depth, Yg = class {
	constructor() {
		this.children = [], this.isDirty = !1;
	}
	add(e) {
		gc(this.children, e), this.isDirty = !0;
	}
	remove(e) {
		_c(this.children, e), this.isDirty = !0;
	}
	forEach(e) {
		this.isDirty && this.children.sort(Jg), this.isDirty = !1, this.children.forEach(e);
	}
};
//#endregion
//#region node_modules/framer-motion/dist/es/utils/delay.mjs
function Xg(e, t) {
	let n = ml.now(), r = ({ timestamp: i }) => {
		let a = i - n;
		a >= t && (ul(r), e(a - t));
	};
	return K.setup(r, !0), () => ul(r);
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/animation/mix-values.mjs
var Zg = [
	"TopLeft",
	"TopRight",
	"BottomLeft",
	"BottomRight"
], Qg = Zg.length, $g = (e) => typeof e == "string" ? parseFloat(e) : e, e_ = (e) => typeof e == "number" || J.test(e);
function t_(e, t, n, r, i, a) {
	i ? (e.opacity = X(0, n.opacity ?? 1, r_(r)), e.opacityExit = X(t.opacity ?? 1, 0, i_(r))) : a && (e.opacity = X(t.opacity ?? 1, n.opacity ?? 1, r));
	for (let i = 0; i < Qg; i++) {
		let a = `border${Zg[i]}Radius`, o = n_(t, a), s = n_(n, a);
		o === void 0 && s === void 0 || (o ||= 0, s ||= 0, o === 0 || s === 0 || e_(o) === e_(s) ? (e[a] = Math.max(X($g(o), $g(s), r), 0), (Ll.test(s) || Ll.test(o)) && (e[a] += "%")) : e[a] = s);
	}
	(t.rotate || n.rotate) && (e.rotate = X(t.rotate || 0, n.rotate || 0, r));
}
function n_(e, t) {
	return e[t] === void 0 ? e.borderRadius : e[t];
}
var r_ = /* @__PURE__ */ a_(0, .5, Yc), i_ = /* @__PURE__ */ a_(.5, .95, Dc);
function a_(e, t, n) {
	return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Ac(e, t, r));
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/copy.mjs
function o_(e, t) {
	e.min = t.min, e.max = t.max;
}
function s_(e, t) {
	o_(e.x, t.x), o_(e.y, t.y);
}
function c_(e, t) {
	e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/delta-remove.mjs
function l_(e, t, n, r, i) {
	return e -= t, e = Nm(e, 1 / n, r), i !== void 0 && (e = Nm(e, 1 / i, r)), e;
}
function u_(e, t = 0, n = 1, r = .5, i, a = e, o = e) {
	if (Ll.test(t) && (t = parseFloat(t), t = X(o.min, o.max, t / 100) - o.min), typeof t != "number") return;
	let s = X(a.min, a.max, r);
	e === a && (s -= t), e.min = l_(e.min, t, n, s, i), e.max = l_(e.max, t, n, s, i);
}
function d_(e, t, [n, r, i], a, o) {
	u_(e, t[n], t[r], t[i], t.scale, a, o);
}
var f_ = [
	"x",
	"scaleX",
	"originX"
], p_ = [
	"y",
	"scaleY",
	"originY"
];
function m_(e, t, n, r) {
	d_(e.x, t, f_, n ? n.x : void 0, r ? r.x : void 0), d_(e.y, t, p_, n ? n.y : void 0, r ? r.y : void 0);
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/geometry/utils.mjs
function h_(e) {
	return e.translate === 0 && e.scale === 1;
}
function g_(e) {
	return h_(e.x) && h_(e.y);
}
function __(e, t) {
	return e.min === t.min && e.max === t.max;
}
function v_(e, t) {
	return __(e.x, t.x) && __(e.y, t.y);
}
function y_(e, t) {
	return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function b_(e, t) {
	return y_(e.x, t.x) && y_(e.y, t.y);
}
function x_(e) {
	return ng(e.x) / ng(e.y);
}
function S_(e, t) {
	return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/shared/stack.mjs
var C_ = class {
	constructor() {
		this.members = [];
	}
	add(e) {
		gc(this.members, e), e.scheduleRender();
	}
	remove(e) {
		if (_c(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
			let e = this.members[this.members.length - 1];
			e && this.promote(e);
		}
	}
	relegate(e) {
		let t = this.members.findIndex((t) => e === t);
		if (t === 0) return !1;
		let n;
		for (let e = t; e >= 0; e--) {
			let t = this.members[e];
			if (t.isPresent !== !1) {
				n = t;
				break;
			}
		}
		return n ? (this.promote(n), !0) : !1;
	}
	promote(e, t) {
		let n = this.lead;
		if (e !== n && (this.prevLead = n, this.lead = e, e.show(), n)) {
			n.instance && n.scheduleRender(), e.scheduleRender(), e.resumeFrom = n, t && (e.resumeFrom.preserveOpacity = !0), n.snapshot && (e.snapshot = n.snapshot, e.snapshot.latestValues = n.animationValues || n.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
			let { crossfade: r } = e.options;
			r === !1 && n.hide();
		}
	}
	exitAnimationComplete() {
		this.members.forEach((e) => {
			let { options: t, resumingFrom: n } = e;
			t.onExitComplete && t.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
		});
	}
	scheduleRender() {
		this.members.forEach((e) => {
			e.instance && e.scheduleRender(!1);
		});
	}
	removeLeadSnapshot() {
		this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
	}
};
//#endregion
//#region node_modules/framer-motion/dist/es/projection/styles/transform.mjs
function w_(e, t, n) {
	let r = "", i = e.x.translate / t.x, a = e.y.translate / t.y, o = n?.z || 0;
	if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
		let { transformPerspective: e, rotate: t, rotateX: i, rotateY: a, skewX: o, skewY: s } = n;
		e && (r = `perspective(${e}px) ${r}`), t && (r += `rotate(${t}deg) `), i && (r += `rotateX(${i}deg) `), a && (r += `rotateY(${a}deg) `), o && (r += `skewX(${o}deg) `), s && (r += `skewY(${s}deg) `);
	}
	let s = e.x.scale * t.x, c = e.y.scale * t.y;
	return (s !== 1 || c !== 1) && (r += `scale(${s}, ${c})`), r || "none";
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/node/create-projection-node.mjs
var T_ = {
	nodes: 0,
	calculatedTargetDeltas: 0,
	calculatedProjections: 0
}, E_ = [
	"",
	"X",
	"Y",
	"Z"
], D_ = 1e3, O_ = 0;
function k_(e, t, n, r) {
	let { latestValues: i } = t;
	i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function A_(e) {
	if (e.hasCheckedOptimisedAppear = !0, e.root === e) return;
	let { visualElement: t } = e.options;
	if (!t) return;
	let n = gh(t);
	if (window.MotionHasOptimisedAnimation(n, "transform")) {
		let { layout: t, layoutId: r } = e.options;
		window.MotionCancelOptimisedAnimation(n, "transform", K, !(t || r));
	}
	let { parent: r } = e;
	r && !r.hasCheckedOptimisedAppear && A_(r);
}
function j_({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
	return class {
		constructor(e = {}, n = t?.()) {
			this.id = O_++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
				x: 1,
				y: 1
			}, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
				this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
			}, this.updateProjection = () => {
				this.projectionUpdateScheduled = !1, ol.value && (T_.nodes = T_.calculatedTargetDeltas = T_.calculatedProjections = 0), this.nodes.forEach(P_), this.nodes.forEach(V_), this.nodes.forEach(H_), this.nodes.forEach(F_), ol.addProjectionMetrics && ol.addProjectionMetrics(T_);
			}, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = e, this.root = n ? n.root || n : this, this.path = n ? [...n.path, n] : [], this.parent = n, this.depth = n ? n.depth + 1 : 0;
			for (let e = 0; e < this.path.length; e++) this.path[e].shouldResetTransform = !0;
			this.root === this && (this.nodes = new Yg());
		}
		addEventListener(e, t) {
			return this.eventHandlers.has(e) || this.eventHandlers.set(e, new jc()), this.eventHandlers.get(e).add(t);
		}
		notifyListeners(e, ...t) {
			let n = this.eventHandlers.get(e);
			n && n.notify(...t);
		}
		hasListeners(e) {
			return this.eventHandlers.has(e);
		}
		mount(t) {
			if (this.instance) return;
			this.isSVG = Jf(t) && !Yf(t), this.instance = t;
			let { layoutId: n, layout: r, visualElement: i } = this.options;
			if (i && !i.current && i.mount(t), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (r || n) && (this.isLayoutDirty = !0), e) {
				let n, r = 0, i = () => this.root.updateBlockedByResize = !1;
				K.read(() => {
					r = window.innerWidth;
				}), e(t, () => {
					let e = window.innerWidth;
					e !== r && (r = e, this.root.updateBlockedByResize = !0, n && n(), n = Xg(i, 250), zg.hasAnimatedSinceResize && (zg.hasAnimatedSinceResize = !1, this.nodes.forEach(B_)));
				});
			}
			n && this.root.registerSharedNode(n, this), this.options.animate !== !1 && i && (n || r) && this.addEventListener("didUpdate", ({ delta: e, hasLayoutChanged: t, hasRelativeLayoutChanged: n, layout: r }) => {
				if (this.isTreeAnimationBlocked()) {
					this.target = void 0, this.relativeTarget = void 0;
					return;
				}
				let a = this.options.transition || i.getDefaultTransition() || Y_, { onLayoutAnimationStart: o, onLayoutAnimationComplete: s } = i.getProps(), c = !this.targetLayout || !b_(this.targetLayout, r), l = !t && n;
				if (this.options.layoutRoot || this.resumeFrom || l || t && (c || !this.currentAnimation)) {
					this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
					let t = {
						...nf(a, "layout"),
						onPlay: o,
						onComplete: s
					};
					(i.shouldReduceMotion || this.options.layoutRoot) && (t.delay = 0, t.type = !1), this.startAnimation(t), this.setAnimationOrigin(e, l);
				} else t || B_(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
				this.targetLayout = r;
			});
		}
		unmount() {
			this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
			let e = this.getStack();
			e && e.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), ul(this.updateProjection);
		}
		blockUpdate() {
			this.updateManuallyBlocked = !0;
		}
		unblockUpdate() {
			this.updateManuallyBlocked = !1;
		}
		isUpdateBlocked() {
			return this.updateManuallyBlocked || this.updateBlockedByResize;
		}
		isTreeAnimationBlocked() {
			return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
		}
		startUpdate() {
			this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(U_), this.animationId++);
		}
		getTransformTemplate() {
			let { visualElement: e } = this.options;
			return e && e.getProps().transformTemplate;
		}
		willUpdate(e = !0) {
			if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
				this.options.onExitComplete && this.options.onExitComplete();
				return;
			}
			if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && A_(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
			this.isLayoutDirty = !0;
			for (let e = 0; e < this.path.length; e++) {
				let t = this.path[e];
				t.shouldResetTransform = !0, t.updateScroll("snapshot"), t.options.layoutRoot && t.willUpdate(!1);
			}
			let { layoutId: t, layout: n } = this.options;
			if (t === void 0 && !n) return;
			let r = this.getTransformTemplate();
			this.prevTransformTemplateValue = r ? r(this.latestValues, "") : void 0, this.updateSnapshot(), e && this.notifyListeners("willUpdate");
		}
		update() {
			if (this.updateScheduled = !1, this.isUpdateBlocked()) {
				this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(L_);
				return;
			}
			if (this.animationId <= this.animationCommitId) {
				this.nodes.forEach(R_);
				return;
			}
			this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(z_), this.nodes.forEach(M_), this.nodes.forEach(N_)) : this.nodes.forEach(R_), this.clearAllSnapshots();
			let e = ml.now();
			q.delta = vc(0, 1e3 / 60, e - q.timestamp), q.timestamp = e, q.isProcessing = !0, dl.update.process(q), dl.preRender.process(q), dl.render.process(q), q.isProcessing = !1;
		}
		didUpdate() {
			this.updateScheduled || (this.updateScheduled = !0, Af.read(this.scheduleUpdate));
		}
		clearAllSnapshots() {
			this.nodes.forEach(I_), this.sharedNodes.forEach(W_);
		}
		scheduleUpdateProjection() {
			this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, K.preRender(this.updateProjection, !1, !0));
		}
		scheduleCheckAfterUnmount() {
			K.postRender(() => {
				this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
			});
		}
		updateSnapshot() {
			this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !ng(this.snapshot.measuredBox.x) && !ng(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
		}
		updateLayout() {
			if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
			if (this.resumeFrom && !this.resumeFrom.instance) for (let e = 0; e < this.path.length; e++) this.path[e].updateScroll();
			let e = this.layout;
			this.layout = this.measure(!1), this.layoutCorrected = Q(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
			let { visualElement: t } = this.options;
			t && t.notify("LayoutMeasure", this.layout.layoutBox, e ? e.layoutBox : void 0);
		}
		updateScroll(e = "measure") {
			let t = !!(this.options.layoutScroll && this.instance);
			if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === e && (t = !1), t && this.instance) {
				let t = r(this.instance);
				this.scroll = {
					animationId: this.root.animationId,
					phase: e,
					isRoot: t,
					offset: n(this.instance),
					wasRoot: this.scroll ? this.scroll.isRoot : t
				};
			}
		}
		resetTransform() {
			if (!i) return;
			let e = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, t = this.projectionDelta && !g_(this.projectionDelta), n = this.getTransformTemplate(), r = n ? n(this.latestValues, "") : void 0, a = r !== this.prevTransformTemplateValue;
			e && this.instance && (t || Am(this.latestValues) || a) && (i(this.instance, r), this.shouldResetTransform = !1, this.scheduleRender());
		}
		measure(e = !0) {
			let t = this.measurePageBox(), n = this.removeElementScroll(t);
			return e && (n = this.removeTransform(n)), $_(n), {
				animationId: this.root.animationId,
				measuredBox: t,
				layoutBox: n,
				latestValues: {},
				source: this.id
			};
		}
		measurePageBox() {
			let { visualElement: e } = this.options;
			if (!e) return Q();
			let t = e.measureViewportBox();
			if (!(this.scroll?.wasRoot || this.path.some(tv))) {
				let { scroll: e } = this.root;
				e && (Bm(t.x, e.offset.x), Bm(t.y, e.offset.y));
			}
			return t;
		}
		removeElementScroll(e) {
			let t = Q();
			if (s_(t, e), this.scroll?.wasRoot) return t;
			for (let n = 0; n < this.path.length; n++) {
				let r = this.path[n], { scroll: i, options: a } = r;
				r !== this.root && i && a.layoutScroll && (i.wasRoot && s_(t, e), Bm(t.x, i.offset.x), Bm(t.y, i.offset.y));
			}
			return t;
		}
		applyTransform(e, t = !1) {
			let n = Q();
			s_(n, e);
			for (let e = 0; e < this.path.length; e++) {
				let r = this.path[e];
				!t && r.options.layoutScroll && r.scroll && r !== r.root && Hm(n, {
					x: -r.scroll.offset.x,
					y: -r.scroll.offset.y
				}), Am(r.latestValues) && Hm(n, r.latestValues);
			}
			return Am(this.latestValues) && Hm(n, this.latestValues), n;
		}
		removeTransform(e) {
			let t = Q();
			s_(t, e);
			for (let e = 0; e < this.path.length; e++) {
				let n = this.path[e];
				if (!n.instance || !Am(n.latestValues)) continue;
				km(n.latestValues) && n.updateSnapshot();
				let r = Q();
				s_(r, n.measurePageBox()), m_(t, n.latestValues, n.snapshot ? n.snapshot.layoutBox : void 0, r);
			}
			return Am(this.latestValues) && m_(t, this.latestValues), t;
		}
		setTargetDelta(e) {
			this.targetDelta = e, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
		}
		setOptions(e) {
			this.options = {
				...this.options,
				...e,
				crossfade: e.crossfade === void 0 ? !0 : e.crossfade
			};
		}
		clearMeasurements() {
			this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
		}
		forceRelativeParentToResolveTarget() {
			this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== q.timestamp && this.relativeParent.resolveTargetDelta(!0);
		}
		resolveTargetDelta(e = !1) {
			let t = this.getLead();
			this.isProjectionDirty ||= t.isProjectionDirty, this.isTransformDirty ||= t.isTransformDirty, this.isSharedProjectionDirty ||= t.isSharedProjectionDirty;
			let n = !!this.resumingFrom || this !== t;
			if (!(e || n && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
			let { layout: r, layoutId: i } = this.options;
			if (!(!this.layout || !(r || i))) {
				if (this.resolvedRelativeTargetAt = q.timestamp, !this.targetDelta && !this.relativeTarget) {
					let e = this.getClosestProjectingParent();
					e && e.layout && this.animationProgress !== 1 ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Q(), this.relativeTargetOrigin = Q(), lg(this.relativeTargetOrigin, this.layout.layoutBox, e.layout.layoutBox), s_(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
				}
				if (!(!this.relativeTarget && !this.targetDelta)) {
					if (this.target || (this.target = Q(), this.targetWithTransforms = Q()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), sg(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : s_(this.target, this.layout.layoutBox), Im(this.target, this.targetDelta)) : s_(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
						this.attemptToResolveRelativeTarget = !1;
						let e = this.getClosestProjectingParent();
						e && !!e.resumingFrom == !!this.resumingFrom && !e.options.layoutScroll && e.target && this.animationProgress !== 1 ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Q(), this.relativeTargetOrigin = Q(), lg(this.relativeTargetOrigin, this.target, e.target), s_(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
					}
					ol.value && T_.calculatedTargetDeltas++;
				}
			}
		}
		getClosestProjectingParent() {
			if (!(!this.parent || km(this.parent.latestValues) || jm(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
		}
		isProjecting() {
			return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
		}
		calcProjection() {
			let e = this.getLead(), t = !!this.resumingFrom || this !== e, n = !0;
			if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (n = !1), t && (this.isSharedProjectionDirty || this.isTransformDirty) && (n = !1), this.resolvedRelativeTargetAt === q.timestamp && (n = !1), n) return;
			let { layout: r, layoutId: i } = this.options;
			if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(r || i)) return;
			s_(this.layoutCorrected, this.layout.layoutBox);
			let a = this.treeScale.x, o = this.treeScale.y;
			zm(this.layoutCorrected, this.treeScale, this.path, t), e.layout && !e.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (e.target = e.layout.layoutBox, e.targetWithTransforms = Q());
			let { target: s } = e;
			if (!s) {
				this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
				return;
			}
			!this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (c_(this.prevProjectionDelta.x, this.projectionDelta.x), c_(this.prevProjectionDelta.y, this.projectionDelta.y)), ag(this.projectionDelta, this.layoutCorrected, s, this.latestValues), (this.treeScale.x !== a || this.treeScale.y !== o || !S_(this.projectionDelta.x, this.prevProjectionDelta.x) || !S_(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", s)), ol.value && T_.calculatedProjections++;
		}
		hide() {
			this.isVisible = !1;
		}
		show() {
			this.isVisible = !0;
		}
		scheduleRender(e = !0) {
			if (this.options.visualElement?.scheduleRender(), e) {
				let e = this.getStack();
				e && e.scheduleRender();
			}
			this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
		}
		createProjectionDeltas() {
			this.prevProjectionDelta = Km(), this.projectionDelta = Km(), this.projectionDeltaWithTransform = Km();
		}
		setAnimationOrigin(e, t = !1) {
			let n = this.snapshot, r = n ? n.latestValues : {}, i = { ...this.latestValues }, a = Km();
			(!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !t;
			let o = Q(), s = (n ? n.source : void 0) !== (this.layout ? this.layout.source : void 0), c = this.getStack(), l = !c || c.members.length <= 1, u = !!(s && !l && this.options.crossfade === !0 && !this.path.some(J_));
			this.animationProgress = 0;
			let d;
			this.mixTargetDelta = (t) => {
				let n = t / 1e3;
				G_(a.x, e.x, n), G_(a.y, e.y, n), this.setTargetDelta(a), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (lg(o, this.layout.layoutBox, this.relativeParent.layout.layoutBox), q_(this.relativeTarget, this.relativeTargetOrigin, o, n), d && v_(this.relativeTarget, d) && (this.isProjectionDirty = !1), d ||= Q(), s_(d, this.relativeTarget)), s && (this.animationValues = i, t_(i, r, this.latestValues, n, u, l)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = n;
			}, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
		}
		startAnimation(e) {
			this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation &&= (ul(this.pendingAnimation), void 0), this.pendingAnimation = K.update(() => {
				zg.hasAnimatedSinceResize = !0, hl.layout++, this.motionValue ||= kf(0), this.currentAnimation = qg(this.motionValue, [0, 1e3], {
					...e,
					velocity: 0,
					isSync: !0,
					onUpdate: (t) => {
						this.mixTargetDelta(t), e.onUpdate && e.onUpdate(t);
					},
					onStop: () => {
						hl.layout--;
					},
					onComplete: () => {
						hl.layout--, e.onComplete && e.onComplete(), this.completeAnimation();
					}
				}), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
			});
		}
		completeAnimation() {
			this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
			let e = this.getStack();
			e && e.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
		}
		finishAnimation() {
			this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(D_), this.currentAnimation.stop()), this.completeAnimation();
		}
		applyTransformsToTarget() {
			let e = this.getLead(), { targetWithTransforms: t, target: n, layout: r, latestValues: i } = e;
			if (!(!t || !n || !r)) {
				if (this !== e && this.layout && r && ev(this.options.animationType, this.layout.layoutBox, r.layoutBox)) {
					n = this.target || Q();
					let t = ng(this.layout.layoutBox.x);
					n.x.min = e.target.x.min, n.x.max = n.x.min + t;
					let r = ng(this.layout.layoutBox.y);
					n.y.min = e.target.y.min, n.y.max = n.y.min + r;
				}
				s_(t, n), Hm(t, i), ag(this.projectionDeltaWithTransform, this.layoutCorrected, t, i);
			}
		}
		registerSharedNode(e, t) {
			this.sharedNodes.has(e) || this.sharedNodes.set(e, new C_()), this.sharedNodes.get(e).add(t);
			let n = t.options.initialPromotionConfig;
			t.promote({
				transition: n ? n.transition : void 0,
				preserveFollowOpacity: n && n.shouldPreserveFollowOpacity ? n.shouldPreserveFollowOpacity(t) : void 0
			});
		}
		isLead() {
			let e = this.getStack();
			return e ? e.lead === this : !0;
		}
		getLead() {
			let { layoutId: e } = this.options;
			return e && this.getStack()?.lead || this;
		}
		getPrevLead() {
			let { layoutId: e } = this.options;
			return e ? this.getStack()?.prevLead : void 0;
		}
		getStack() {
			let { layoutId: e } = this.options;
			if (e) return this.root.sharedNodes.get(e);
		}
		promote({ needsReset: e, transition: t, preserveFollowOpacity: n } = {}) {
			let r = this.getStack();
			r && r.promote(this, n), e && (this.projectionDelta = void 0, this.needsReset = !0), t && this.setOptions({ transition: t });
		}
		relegate() {
			let e = this.getStack();
			return e ? e.relegate(this) : !1;
		}
		resetSkewAndRotation() {
			let { visualElement: e } = this.options;
			if (!e) return;
			let t = !1, { latestValues: n } = e;
			if ((n.z || n.rotate || n.rotateX || n.rotateY || n.rotateZ || n.skewX || n.skewY) && (t = !0), !t) return;
			let r = {};
			n.z && k_("z", e, r, this.animationValues);
			for (let t = 0; t < E_.length; t++) k_(`rotate${E_[t]}`, e, r, this.animationValues), k_(`skew${E_[t]}`, e, r, this.animationValues);
			e.render();
			for (let t in r) e.setStaticValue(t, r[t]), this.animationValues && (this.animationValues[t] = r[t]);
			e.scheduleRender();
		}
		applyProjectionStyles(e, t) {
			if (!this.instance || this.isSVG) return;
			if (!this.isVisible) {
				e.visibility = "hidden";
				return;
			}
			let n = this.getTransformTemplate();
			if (this.needsReset) {
				this.needsReset = !1, e.visibility = "", e.opacity = "", e.pointerEvents = rm(t?.pointerEvents) || "", e.transform = n ? n(this.latestValues, "") : "none";
				return;
			}
			let r = this.getLead();
			if (!this.projectionDelta || !this.layout || !r.target) {
				this.options.layoutId && (e.opacity = this.latestValues.opacity === void 0 ? 1 : this.latestValues.opacity, e.pointerEvents = rm(t?.pointerEvents) || ""), this.hasProjected && !Am(this.latestValues) && (e.transform = n ? n({}, "") : "none", this.hasProjected = !1);
				return;
			}
			e.visibility = "";
			let i = r.animationValues || r.latestValues;
			this.applyTransformsToTarget();
			let a = w_(this.projectionDeltaWithTransform, this.treeScale, i);
			n && (a = n(i, a)), e.transform = a;
			let { x: o, y: s } = this.projectionDelta;
			e.transformOrigin = `${o.origin * 100}% ${s.origin * 100}% 0`, r.animationValues ? e.opacity = r === this ? i.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : i.opacityExit : e.opacity = r === this ? i.opacity === void 0 ? "" : i.opacity : i.opacityExit === void 0 ? 0 : i.opacityExit;
			for (let t in Np) {
				if (i[t] === void 0) continue;
				let { correct: n, applyTo: o, isCSSVariable: s } = Np[t], c = a === "none" ? i[t] : n(i[t], r);
				if (o) {
					let t = o.length;
					for (let n = 0; n < t; n++) e[o[n]] = c;
				} else s ? this.options.visualElement.renderState.vars[t] = c : e[t] = c;
			}
			this.options.layoutId && (e.pointerEvents = r === this ? rm(t?.pointerEvents) || "" : "none");
		}
		clearSnapshot() {
			this.resumeFrom = this.snapshot = void 0;
		}
		resetTree() {
			this.root.nodes.forEach((e) => e.currentAnimation?.stop()), this.root.nodes.forEach(L_), this.root.sharedNodes.clear();
		}
	};
}
function M_(e) {
	e.updateLayout();
}
function N_(e) {
	let t = e.resumeFrom?.snapshot || e.snapshot;
	if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
		let { layoutBox: n, measuredBox: r } = e.layout, { animationType: i } = e.options, a = t.source !== e.layout.source;
		i === "size" ? ug((e) => {
			let r = a ? t.measuredBox[e] : t.layoutBox[e], i = ng(r);
			r.min = n[e].min, r.max = r.min + i;
		}) : ev(i, t.layoutBox, n) && ug((r) => {
			let i = a ? t.measuredBox[r] : t.layoutBox[r], o = ng(n[r]);
			i.max = i.min + o, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[r].max = e.relativeTarget[r].min + o);
		});
		let o = Km();
		ag(o, n, t.layoutBox);
		let s = Km();
		a ? ag(s, e.applyTransform(r, !0), t.measuredBox) : ag(s, n, t.layoutBox);
		let c = !g_(o), l = !1;
		if (!e.resumeFrom) {
			let r = e.getClosestProjectingParent();
			if (r && !r.resumeFrom) {
				let { snapshot: i, layout: a } = r;
				if (i && a) {
					let o = Q();
					lg(o, t.layoutBox, i.layoutBox);
					let s = Q();
					lg(s, n, a.layoutBox), b_(o, s) || (l = !0), r.options.layoutRoot && (e.relativeTarget = s, e.relativeTargetOrigin = o, e.relativeParent = r);
				}
			}
		}
		e.notifyListeners("didUpdate", {
			layout: n,
			snapshot: t,
			delta: s,
			layoutDelta: o,
			hasLayoutChanged: c,
			hasRelativeLayoutChanged: l
		});
	} else if (e.isLead()) {
		let { onExitComplete: t } = e.options;
		t && t();
	}
	e.options.transition = void 0;
}
function P_(e) {
	ol.value && T_.nodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty ||= !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty), e.isTransformDirty ||= e.parent.isTransformDirty);
}
function F_(e) {
	e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function I_(e) {
	e.clearSnapshot();
}
function L_(e) {
	e.clearMeasurements();
}
function R_(e) {
	e.isLayoutDirty = !1;
}
function z_(e) {
	let { visualElement: t } = e.options;
	t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function B_(e) {
	e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function V_(e) {
	e.resolveTargetDelta();
}
function H_(e) {
	e.calcProjection();
}
function U_(e) {
	e.resetSkewAndRotation();
}
function W_(e) {
	e.removeLeadSnapshot();
}
function G_(e, t, n) {
	e.translate = X(t.translate, 0, n), e.scale = X(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function K_(e, t, n, r) {
	e.min = X(t.min, n.min, r), e.max = X(t.max, n.max, r);
}
function q_(e, t, n, r) {
	K_(e.x, t.x, n.x, r), K_(e.y, t.y, n.y, r);
}
function J_(e) {
	return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var Y_ = {
	duration: .45,
	ease: [
		.4,
		0,
		.1,
		1
	]
}, X_ = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Z_ = X_("applewebkit/") && !X_("chrome/") ? Math.round : Dc;
function Q_(e) {
	e.min = Z_(e.min), e.max = Z_(e.max);
}
function $_(e) {
	Q_(e.x), Q_(e.y);
}
function ev(e, t, n) {
	return e === "position" || e === "preserve-aspect" && !rg(x_(t), x_(n), .2);
}
function tv(e) {
	return e !== e.root && e.scroll?.wasRoot;
}
//#endregion
//#region node_modules/framer-motion/dist/es/projection/node/DocumentProjectionNode.mjs
var nv = j_({
	attachResizeListener: (e, t) => Kh(e, "resize", t),
	measureScroll: () => ({
		x: document.documentElement.scrollLeft || document.body.scrollLeft,
		y: document.documentElement.scrollTop || document.body.scrollTop
	}),
	checkIsScrollRoot: () => !0
}), rv = { current: void 0 }, iv = j_({
	measureScroll: (e) => ({
		x: e.scrollLeft,
		y: e.scrollTop
	}),
	defaultParent: () => {
		if (!rv.current) {
			let e = new nv({});
			e.mount(window), e.setOptions({ layoutScroll: !0 }), rv.current = e;
		}
		return rv.current;
	},
	resetTransform: (e, t) => {
		e.style.transform = t === void 0 ? "none" : t;
	},
	checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), av = {
	pan: { Feature: Rg },
	drag: {
		Feature: Ig,
		ProjectionNode: iv,
		MeasureLayout: Gg
	}
};
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/hover.mjs
function ov(e, t, n) {
	let { props: r } = e;
	e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
	let i = r["onHover" + n];
	i && K.postRender(() => i(t, qh(t)));
}
var sv = class extends Hh {
	mount() {
		let { current: e } = this.node;
		e && (this.unmount = Lf(e, (e, t) => (ov(this.node, t, "Start"), (e) => ov(this.node, e, "End"))));
	}
	unmount() {}
}, cv = class extends Hh {
	constructor() {
		super(...arguments), this.isActive = !1;
	}
	onFocus() {
		let e = !1;
		try {
			e = this.node.current.matches(":focus-visible");
		} catch {
			e = !0;
		}
		!e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
	}
	onBlur() {
		!this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
	}
	mount() {
		this.unmount = kc(Kh(this.node.current, "focus", () => this.onFocus()), Kh(this.node.current, "blur", () => this.onBlur()));
	}
	unmount() {}
};
//#endregion
//#region node_modules/framer-motion/dist/es/gestures/press.mjs
function lv(e, t, n) {
	let { props: r } = e;
	if (e.current instanceof HTMLButtonElement && e.current.disabled) return;
	e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
	let i = r["onTap" + (n === "End" ? "" : n)];
	i && K.postRender(() => i(t, qh(t)));
}
var uv = class extends Hh {
	mount() {
		let { current: e } = this.node;
		e && (this.unmount = qf(e, (e, t) => (lv(this.node, t, "Start"), (e, { success: t }) => lv(this.node, e, t ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
	}
	unmount() {}
}, dv = /* @__PURE__ */ new WeakMap(), fv = /* @__PURE__ */ new WeakMap(), pv = (e) => {
	let t = dv.get(e.target);
	t && t(e);
}, mv = (e) => {
	e.forEach(pv);
};
function hv({ root: e, ...t }) {
	let n = e || document;
	fv.has(n) || fv.set(n, {});
	let r = fv.get(n), i = JSON.stringify(t);
	return r[i] || (r[i] = new IntersectionObserver(mv, {
		root: e,
		...t
	})), r[i];
}
function gv(e, t, n) {
	let r = hv(t);
	return dv.set(e, n), r.observe(e), () => {
		dv.delete(e), r.unobserve(e);
	};
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/features/viewport/index.mjs
var _v = {
	some: 0,
	all: 1
}, vv = class extends Hh {
	constructor() {
		super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
	}
	startObserver() {
		this.unmount();
		let { viewport: e = {} } = this.node.getProps(), { root: t, margin: n, amount: r = "some", once: i } = e, a = {
			root: t ? t.current : void 0,
			rootMargin: n,
			threshold: typeof r == "number" ? r : _v[r]
		};
		return gv(this.node.current, a, (e) => {
			let { isIntersecting: t } = e;
			if (this.isInView === t || (this.isInView = t, i && !t && this.hasEnteredView)) return;
			t && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", t);
			let { onViewportEnter: n, onViewportLeave: r } = this.node.getProps(), a = t ? n : r;
			a && a(e);
		});
	}
	mount() {
		this.startObserver();
	}
	update() {
		if (typeof IntersectionObserver > "u") return;
		let { props: e, prevProps: t } = this.node;
		[
			"amount",
			"margin",
			"root"
		].some(yv(e, t)) && this.startObserver();
	}
	unmount() {}
};
function yv({ viewport: e = {} }, { viewport: t = {} } = {}) {
	return (n) => e[n] !== t[n];
}
//#endregion
//#region node_modules/framer-motion/dist/es/motion/features/gestures.mjs
var bv = {
	inView: { Feature: vv },
	tap: { Feature: uv },
	focus: { Feature: cv },
	hover: { Feature: sv }
}, xv = { layout: {
	ProjectionNode: iv,
	MeasureLayout: Gg
} }, Sv = /* @__PURE__ */ wm({
	...Gh,
	...bv,
	...av,
	...xv
}, ch), Cv = "flex flex-col relative cursor-text min-w-0", wv = "\n  peer transition-all\n  px-4 pt-4 pb-2 border border-solid rounded outline-none\n  border-gray-200 bg-white text-base-black text-base\n  placeholder:text-transparent\n\n  focus:border-primary-100\n  hover:bg-gray-25\n  disabled:text-gray-200\n\n  data-[has-error=true]:border-feedback-danger-200\n  data-[is-loading=true]:animate-pulse\n  data-[has-prefix-icon=true]:pl-10\n", Tv = "\n  text-xs text-gray-400 px-4 ml-1 w-[125%]\n  absolute top-3 origin-top-left text-ellipsis overflow-hidden\n  scale-75 duration-300 text-nowrap\n  transform -translate-y-1\n  \n  peer-placeholder-shown:text-base\n  peer-placeholder-shown:scale-100\n  peer-placeholder-shown:w-full\n  peer-placeholder-shown:-translate-y-0\n\n  peer-focus:scale-75\n  peer-focus:text-xs\n  peer-focus:w-[125%]\n  peer-focus:ml-1\n  peer-focus:-translate-y-1\n\n  peer-placeholder-shown:peer-data-[has-prefix-icon=true]:ml-6\n  peer-placeholder-shown:peer-data-[has-prefix-icon=true]:w-[calc(100%-24px)]\n\n  peer-data-[has-prefix-icon=true]:ml-7\n  peer-data-[has-prefix-icon=true]:w-[calc(125%-24px)]\n\n  peer-focus:peer-data-[has-prefix-icon=true]:ml-7\n  peer-focus:peer-data-[has-prefix-icon=true]:w-[calc(125%-24px)]\n", Ev = "h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2", Dv = "h-4 w-4 absolute right-4 top-1/2 -translate-y-1/2";
//#endregion
//#region src/components/Form/Root/Input/index.tsx
function Ov({ name: e, label: t, type: n = "text", isDisabled: r, maxLength: i = 255, prefixIcon: a, suffixIcon: o, className: s, fieldClassName: c, onChange: l, onFocus: u, onBlur: d }) {
	let { isLoading: f } = sc(), { isSubmitting: p } = ws(), [m, h] = Js(e), g = (e) => {
		l !== void 0 && l(e), m.onChange(e);
	}, _ = (e) => {
		u !== void 0 && u(e);
	}, v = (e) => {
		d !== void 0 && d(e), m.onBlur(e);
	};
	return /* @__PURE__ */ x("div", {
		className: lt(Cv, s || ""),
		children: [
			/* @__PURE__ */ b(Ys, {
				className: lt(wv, c || ""),
				type: n,
				id: e,
				name: e,
				placeholder: t,
				...n === "text" ? { maxLength: i } : { max: i },
				disabled: f || r || p,
				"data-testid": `input-${e}`,
				"data-is-loading": f,
				"data-has-error": !!h.error && h.touched,
				"data-has-prefix-icon": !!a,
				"data-1p-ignore": !0,
				onChange: g,
				onFocus: _,
				onBlur: v
			}),
			/* @__PURE__ */ b(Sv.label, {
				htmlFor: e,
				className: Tv,
				children: t
			}),
			a !== void 0 && /* @__PURE__ */ b(a, { className: Ev }),
			o !== void 0 && /* @__PURE__ */ b(o, { className: Dv }),
			/* @__PURE__ */ b(ac, {
				"data-testid": `error-${e}`,
				name: e,
				component: "span",
				className: lc
			}, `error-${e}`)
		]
	});
}
//#endregion
//#region src/components/Form/Root/Textarea/styles.ts
var kv = "flex flex-col relative w-full cursor-text", Av = "\n  flex transition-all grow resize-none\n  px-4 pt-6 pb-1.5 border border-solid rounded outline-none\n  border-gray-200 bg-white text-black\n\n  focus-within:border-primary-100\n  hover:bg-gray-25\n  disabled:text-gray-200\n\n  data-[has-error=true]:border-feedback-danger-200\n  data-[is-loading=true]:animate-pulse\n  data-[has-prefix-icon=true]:pl-10\n  data-[has-max-length=true]:pb-10\n", jv = "\n  p-0 relative peer text-sm placeholder:text-transparent bg-transparent\n  max-h-56 min-h-14 w-full border-0 appearance-none\n  focus:outline-none resize-none\n", Mv = "\n  text-sm	text-gray-400\n  absolute top-4 origin-top-left\n  scale-75 duration-300\n\n  transform\n  -translate-y-2\n\n  peer-placeholder-shown:text-base\n  peer-placeholder-shown:scale-100\n  peer-placeholder-shown:translate-y-0\n  peer-focus:text-sm\n  peer-focus:scale-75\n  peer-focus:-translate-y-2\n  peer-data-[has-prefix-icon=true]:mx-10\n", Nv = "\n  h-4 w-4\n  absolute left-4 top-1/2 -translate-y-1/2\n", Pv = "\n  text-sm text-gray-400\n  absolute bottom-3.5 right-8 origin-bottom-right\n";
//#endregion
//#region src/components/Form/Root/Textarea/index.tsx
function Fv({ name: e, label: t, isDisabled: n, maxLength: r, rows: i = 1, grow: a = !0, prefixIcon: o, className: s, onChange: c }) {
	let { isLoading: l } = sc(), { isSubmitting: u } = ws(), f = _(null), [p, m, h] = Js(e);
	return d(() => {
		!a || !f || f.current && (f.current.style.height = "0px", f.current.style.height = `${f.current.scrollHeight}px`);
	}, [
		a,
		f,
		p.value
	]), /* @__PURE__ */ x("div", {
		className: `${kv} ${s || ""}`,
		children: [/* @__PURE__ */ x("div", {
			className: Av,
			"data-is-loading": l,
			"data-has-prefix-icon": !!o,
			"data-has-max-length": !!r,
			onClick: () => {
				f.current?.focus();
			},
			children: [
				/* @__PURE__ */ b(Ys, {
					innerRef: f,
					component: "textarea",
					rows: i,
					className: jv,
					id: e,
					name: e,
					placeholder: t,
					maxLength: r,
					disabled: l || n || u,
					onChange: (e) => {
						c !== void 0 && c(e), p.onChange(e);
					},
					"data-1p-ignore": !0
				}),
				/* @__PURE__ */ b(Sv.label, {
					htmlFor: e,
					className: Mv,
					children: t
				}),
				o !== void 0 && /* @__PURE__ */ b(o, { className: Nv }),
				!!r && /* @__PURE__ */ b("div", {
					className: Pv,
					children: `${m.value.length} / ${r}`
				})
			]
		}), /* @__PURE__ */ b(ac, {
			name: e,
			component: "span",
			className: lc
		}, `error-${e}`)]
	});
}
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/defs/CaretLeft.es.js
var Iv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M160,48V208L80,128Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }))]
]), Lv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M176,128,96,208V48Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))]
]), Rv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))]
]), zv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M68,102.06V40a12,12,0,0,0-24,0v62.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V169.94a36,36,0,0,0,0-67.88ZM56,148a12,12,0,1,1,12-12A12,12,0,0,1,56,148ZM164,88a36.07,36.07,0,0,0-24-33.94V40a12,12,0,0,0-24,0V54.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V121.94A36.07,36.07,0,0,0,164,88Zm-36,12a12,12,0,1,1,12-12A12,12,0,0,1,128,100Zm108,68a36.07,36.07,0,0,0-24-33.94V40a12,12,0,0,0-24,0v94.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V201.94A36.07,36.07,0,0,0,236,168Zm-36,12a12,12,0,1,1,12-12A12,12,0,0,1,200,180Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M80,136a24,24,0,1,1-24-24A24,24,0,0,1,80,136Zm48-72a24,24,0,1,0,24,24A24,24,0,0,0,128,64Zm72,80a24,24,0,1,0,24,24A24,24,0,0,0,200,144Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M64,105V40a8,8,0,0,0-16,0v65a32,32,0,0,0,0,62v49a8,8,0,0,0,16,0V167a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,56,152Zm80-95V40a8,8,0,0,0-16,0V57a32,32,0,0,0,0,62v97a8,8,0,0,0,16,0V119a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,128,104Zm104,64a32.06,32.06,0,0,0-24-31V40a8,8,0,0,0-16,0v97a32,32,0,0,0,0,62v17a8,8,0,0,0,16,0V199A32.06,32.06,0,0,0,232,168Zm-32,16a16,16,0,1,1,16-16A16,16,0,0,1,200,184Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M84,136a28,28,0,0,1-20,26.83V216a8,8,0,0,1-16,0V162.83a28,28,0,0,1,0-53.66V40a8,8,0,0,1,16,0v69.17A28,28,0,0,1,84,136Zm52-74.83V40a8,8,0,0,0-16,0V61.17a28,28,0,0,0,0,53.66V216a8,8,0,0,0,16,0V114.83a28,28,0,0,0,0-53.66Zm72,80V40a8,8,0,0,0-16,0V141.17a28,28,0,0,0,0,53.66V216a8,8,0,0,0,16,0V194.83a28,28,0,0,0,0-53.66Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M62,106.6V40a6,6,0,0,0-12,0v66.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V165.4a30,30,0,0,0,0-58.8ZM56,154a18,18,0,1,1,18-18A18,18,0,0,1,56,154Zm78-95.4V40a6,6,0,0,0-12,0V58.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V117.4a30,30,0,0,0,0-58.8ZM128,106a18,18,0,1,1,18-18A18,18,0,0,1,128,106Zm102,62a30.05,30.05,0,0,0-24-29.4V40a6,6,0,0,0-12,0v98.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V197.4A30.05,30.05,0,0,0,230,168Zm-30,18a18,18,0,1,1,18-18A18,18,0,0,1,200,186Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M64,105V40a8,8,0,0,0-16,0v65a32,32,0,0,0,0,62v49a8,8,0,0,0,16,0V167a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,56,152Zm80-95V40a8,8,0,0,0-16,0V57a32,32,0,0,0,0,62v97a8,8,0,0,0,16,0V119a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,128,104Zm104,64a32.06,32.06,0,0,0-24-31V40a8,8,0,0,0-16,0v97a32,32,0,0,0,0,62v17a8,8,0,0,0,16,0V199A32.06,32.06,0,0,0,232,168Zm-32,16a16,16,0,1,1,16-16A16,16,0,0,1,200,184Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M60,108.29V40a4,4,0,0,0-8,0v68.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V163.71a28,28,0,0,0,0-55.42ZM56,156a20,20,0,1,1,20-20A20,20,0,0,1,56,156Zm76-95.71V40a4,4,0,0,0-8,0V60.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V115.71a28,28,0,0,0,0-55.42ZM128,108a20,20,0,1,1,20-20A20,20,0,0,1,128,108Zm100,60a28,28,0,0,0-24-27.71V40a4,4,0,0,0-8,0V140.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V195.71A28,28,0,0,0,228,168Zm-28,20a20,20,0,1,1,20-20A20,20,0,0,1,200,188Z" }))]
]), Bv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M140,32V64a12,12,0,0,1-24,0V32a12,12,0,0,1,24,0Zm33.25,62.75a12,12,0,0,0,8.49-3.52L204.37,68.6a12,12,0,0,0-17-17L164.77,74.26a12,12,0,0,0,8.48,20.49ZM224,116H192a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24Zm-42.26,48.77a12,12,0,1,0-17,17l22.63,22.63a12,12,0,0,0,17-17ZM128,180a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V192A12,12,0,0,0,128,180ZM74.26,164.77,51.63,187.4a12,12,0,0,0,17,17l22.63-22.63a12,12,0,1,0-17-17ZM76,128a12,12,0,0,0-12-12H32a12,12,0,0,0,0,24H64A12,12,0,0,0,76,128ZM68.6,51.63a12,12,0,1,0-17,17L74.26,91.23a12,12,0,0,0,17-17Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm33.94,58.75,17-17a8,8,0,0,1,11.32,11.32l-17,17a8,8,0,0,1-11.31-11.31ZM48,136a8,8,0,0,1,0-16H72a8,8,0,0,1,0,16Zm46.06,37.25-17,17a8,8,0,0,1-11.32-11.32l17-17a8,8,0,0,1,11.31,11.31Zm0-79.19a8,8,0,0,1-11.31,0l-17-17A8,8,0,0,1,77.09,65.77l17,17A8,8,0,0,1,94.06,94.06ZM136,208a8,8,0,0,1-16,0V184a8,8,0,0,1,16,0Zm0-136a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Zm54.23,118.23a8,8,0,0,1-11.32,0l-17-17a8,8,0,0,1,11.31-11.31l17,17A8,8,0,0,1,190.23,190.23ZM208,136H184a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M134,32V64a6,6,0,0,1-12,0V32a6,6,0,0,1,12,0Zm39.25,56.75A6,6,0,0,0,177.5,87l22.62-22.63a6,6,0,0,0-8.48-8.48L169,78.5a6,6,0,0,0,4.24,10.25ZM224,122H192a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12Zm-46.5,47A6,6,0,0,0,169,177.5l22.63,22.62a6,6,0,0,0,8.48-8.48ZM128,186a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V192A6,6,0,0,0,128,186ZM78.5,169,55.88,191.64a6,6,0,1,0,8.48,8.48L87,177.5A6,6,0,1,0,78.5,169ZM70,128a6,6,0,0,0-6-6H32a6,6,0,0,0,0,12H64A6,6,0,0,0,70,128ZM64.36,55.88a6,6,0,0,0-8.48,8.48L78.5,87A6,6,0,1,0,87,78.5Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z" }))]
]), Vv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))]
]), Hv = /* @__PURE__ */ new Map([
	["bold", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))],
	["duotone", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", {
		d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
		opacity: "0.2"
	}), /* @__PURE__ */ e.createElement("path", { d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))],
	["fill", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,130.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))],
	["light", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.24,100.24,136.48,128l27.76,27.76a6,6,0,1,1-8.48,8.48L128,136.48l-27.76,27.76a6,6,0,0,1-8.48-8.48L119.52,128,91.76,100.24a6,6,0,0,1,8.48-8.48L128,119.52l27.76-27.76a6,6,0,0,1,8.48,8.48ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))],
	["regular", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))],
	["thin", /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.83,98.83,133.66,128l29.17,29.17a4,4,0,0,1-5.66,5.66L128,133.66,98.83,162.83a4,4,0,0,1-5.66-5.66L122.34,128,93.17,98.83a4,4,0,0,1,5.66-5.66L128,122.34l29.17-29.17a4,4,0,1,1,5.66,5.66ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))]
]), Uv = a({
	color: "currentColor",
	size: "1em",
	weight: "regular",
	mirrored: !1
}), Wv = e.forwardRef((t, n) => {
	let { alt: r, color: i, size: a, weight: o, mirrored: s, children: c, weights: l, ...u } = t, { color: d = "currentColor", size: f, weight: p = "regular", mirrored: m = !1, ...h } = e.useContext(Uv);
	return /* @__PURE__ */ e.createElement("svg", {
		ref: n,
		xmlns: "http://www.w3.org/2000/svg",
		width: a ?? f,
		height: a ?? f,
		fill: i ?? d,
		viewBox: "0 0 256 256",
		transform: s || m ? "scale(-1, 1)" : void 0,
		...h,
		...u
	}, !!r && /* @__PURE__ */ e.createElement("title", null, r), c, l.get(o ?? p));
});
Wv.displayName = "IconBase";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/CaretLeft.es.js
var Gv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Iv
}));
Gv.displayName = "CaretLeftIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/CaretRight.es.js
var Kv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Lv
}));
Kv.displayName = "CaretRightIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/Check.es.js
var qv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Rv
}));
qv.displayName = "CheckIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/Sliders.es.js
var Jv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: zv
}));
Jv.displayName = "SlidersIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/Spinner.es.js
var Yv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Bv
}));
Yv.displayName = "SpinnerIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/X.es.js
var Xv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Vv
}));
Xv.displayName = "XIcon";
//#endregion
//#region ../../node_modules/@phosphor-icons/react/dist/csr/XCircle.es.js
var Zv = e.forwardRef((t, n) => /* @__PURE__ */ e.createElement(Wv, {
	ref: n,
	...t,
	weights: Hv
}));
Zv.displayName = "XCircleIcon";
//#endregion
//#region src/components/Form/Root/Search/styles.ts
var Qv = "pr-10 truncate", $v = "\n  border-0 p-0 cursor-pointer\n  absolute top-1/2 -translate-y-1/2\n  right-4 bg-transparent\n", ey = "\n  h-4 w-4 \n", ty = "\n  animate-spin h-4 w-4\n  absolute top-4 right-9 \n";
//#endregion
//#region src/components/Form/Root/Search/index.tsx
function ny({ name: e, label: t, isLoading: n, isDisabled: r, maxLength: i = 255, prefixIcon: a, suffixIcon: o, className: s, onChange: c, onClear: l, onFocus: u, onBlur: d }) {
	let [, f, p] = Js(e);
	return /* @__PURE__ */ x(y, { children: [
		/* @__PURE__ */ b(Ov, {
			name: e,
			label: t,
			isDisabled: r,
			maxLength: i,
			prefixIcon: a,
			suffixIcon: o,
			className: s,
			fieldClassName: Qv,
			onChange: (e) => {
				c !== void 0 && c(e);
			},
			onFocus: u,
			onBlur: d
		}),
		n && /* @__PURE__ */ b(Yv, { className: ty }),
		!!f.value && /* @__PURE__ */ b("button", {
			type: "button",
			className: $v,
			onClick: () => {
				p.setValue(""), c !== void 0 && c({ target: { value: "" } }), l !== void 0 && l();
			},
			children: /* @__PURE__ */ b(Xv, { className: ey })
		})
	] });
}
//#endregion
//#region src/components/Form/Root/Checkbox/styles.ts
var ry = "\n  group/checkbox\n  \n  data-[is-disabled=true]:pointer-events-none\n  data-[is-disabled=true]:cursor-default\n", iy = "\n  w-5 h-5 rounded-md bg-white\n  peer relative  shrink-0\n  appearance-none transition-colors\n  border border-neutral-400\n\n  group-hover/checkbox:border-base-black\n  \n  checked:bg-primary-100\n  checked:border-0\n  checked:hover:bg-primary-200\n\n  disabled:border-neutral-300\n  disabled:checked:bg-neutral-300\n  data-[has-error=true]:border-feedback-danger-200\n", ay = "\n  text-sm text-neutral-400 font-normal\n  transition-colors\n  group-hover/checkbox:text-base-black\n\n  peer-checked:hover:text-base-black\n  group-data-[is-disabled=true]/checkbox:text-neutral-300\n\n  flex gap-2 cursor-pointer\n", oy = "absolute w-4 h-4 ml-0.5 mt-0.5 hidden peer-checked:block fill-white";
//#endregion
//#region src/components/Form/Root/Checkbox/index.tsx
function sy({ name: e, label: t, className: n, fieldClassName: r, isDisabled: i, onChange: a, onFocus: o }) {
	let { isLoading: s } = sc(), { isSubmitting: c, validateField: l } = ws(), [u, d] = Js(e);
	return /* @__PURE__ */ x("div", {
		className: lt(ry, n || ""),
		"data-is-disabled": i,
		children: [/* @__PURE__ */ x("label", {
			className: ay,
			children: [
				/* @__PURE__ */ b(Ys, {
					type: "checkbox",
					name: e,
					className: lt(iy, r || ""),
					onChange: (t) => {
						a !== void 0 && a(t), u.onChange(t), setTimeout(() => {
							u.onBlur(t), l(e);
						}, 0);
					},
					onFocus: (e) => {
						o !== void 0 && o(e);
					},
					"data-has-error": !!d.error && d.touched,
					disabled: s || i || c,
					"data-testid": `checkbox-${e}`
				}),
				t && /* @__PURE__ */ b(y, { children: t }),
				/* @__PURE__ */ b(qv, {
					className: oy,
					size: 20
				})
			]
		}), /* @__PURE__ */ b(ac, {
			"data-testid": `error-${e}`,
			name: e,
			component: "span",
			className: lc
		}, `error-${e}`)]
	});
}
//#endregion
//#region src/components/Form/Root/SearchAndSelect/Options/styles.ts
var cy = "relative", ly = "\n  absolute left-0 right-0\n  list-none px-0 py-1 \n  rounded-lg overflow-hidden\n  bg-white shadow-multi-2sm rounded-lg \n\n  group-data-[direction=\"topToBottom\"]/search-and-select:top-0\n  group-data-[direction=\"topToBottom\"]/search-and-select:mt-1\n\n  group-data-[direction=\"bottomToTop\"]/search-and-select:bottom-0\n  group-data-[direction=\"bottomToTop\"]/search-and-select:mb-1\n", uy = "\n  py-2.5 px-4 cursor-pointer transition-all\n  bg-white hover:bg-primary-10 hover:font-medium hover:text-black\n";
//#endregion
//#region src/components/Form/Root/SearchAndSelect/Options/index.tsx
function dy({ isOpen: e, options: t, onSelect: n }) {
	return e ? /* @__PURE__ */ b("div", {
		className: cy,
		children: /* @__PURE__ */ b("ul", {
			className: ly,
			children: t.map((e, t) => /* @__PURE__ */ b("li", {
				className: uy,
				onClick: () => n(e.value),
				"data-testid": `search-select-option-${t}`,
				children: e.label
			}, e.key))
		})
	}) : null;
}
//#endregion
//#region src/components/Form/Root/SearchAndSelect/styles.ts
var fy = "relative group/search-and-select min-w-0 w-full";
//#endregion
//#region src/components/Form/Root/SearchAndSelect/index.tsx
function py({ name: e, label: t, direction: n = "topToBottom", options: r = [], selectedLabel: i, isLoading: a, isDisabled: o, clearOnSelect: s = !0, maxLength: c = 255, prefixIcon: l, suffixIcon: u, className: f, onChange: p, onClear: m, onFocus: h, onBlur: g, onSelect: _ }) {
	let [y, S] = v(!1), [, , C] = Js(e), w = () => {
		let e = r.length > 0;
		y !== e && S(e);
	};
	d(() => {
		w();
	}, [r, w]), d(() => {
		C.setValue(i || "");
	}, [i, C]);
	let T = (e) => {
		w(), h !== void 0 && h(e);
	}, E = (e) => {
		setTimeout(() => {
			S(!1), i === void 0 && s && C.setValue(""), p !== void 0 && p({ target: { value: "" } }), g !== void 0 && g(e);
		}, 250);
	}, D = (e) => {
		_ !== void 0 && _(e), S(!1), s && C.setValue("");
	};
	return /* @__PURE__ */ x("div", {
		className: fy,
		tabIndex: 0,
		"data-direction": n,
		children: [
			/* @__PURE__ */ b(dy, {
				isOpen: y && n === "bottomToTop",
				options: r,
				onSelect: D
			}),
			/* @__PURE__ */ b(ny, {
				name: e,
				label: t,
				isLoading: a,
				isDisabled: o,
				maxLength: c,
				prefixIcon: l,
				suffixIcon: y ? void 0 : u,
				className: f,
				onChange: p,
				onClear: m,
				onBlur: E,
				onFocus: T
			}),
			/* @__PURE__ */ b(dy, {
				isOpen: y && n === "topToBottom",
				options: r,
				onSelect: D
			})
		]
	});
}
//#endregion
//#region src/components/Form/Root/index.tsx
var my = /* @__PURE__ */ O({
	Button: () => uc,
	Checkbox: () => sy,
	Input: () => Ov,
	Root: () => hy,
	Search: () => ny,
	SearchAndSelect: () => py,
	Textarea: () => Fv
});
function hy({ isLoading: e = !1, enableReinitialize: t = !0, initialValues: n, validationSchema: r, validateOnMount: i = !1, isForcedDirty: a, onSubmit: o, className: s, children: c }) {
	let [l, u] = v(null);
	return /* @__PURE__ */ b(oc.Provider, {
		value: {
			isLoading: e,
			isForcedDirty: a,
			onNavigationEvent: (e) => {
				u(e);
			}
		},
		children: /* @__PURE__ */ b(Rs, {
			enableReinitialize: t,
			initialValues: n,
			validationSchema: r,
			validateOnMount: i,
			onSubmit: (e, t) => {
				o === void 0 ? t.setSubmitting(!1) : o(e).finally(() => {
					t.setSubmitting(!1);
				});
			},
			children: (e) => /* @__PURE__ */ b("form", {
				onSubmit: e.handleSubmit,
				className: lt(cc, s),
				children: c
			})
		})
	});
}
//#endregion
//#region src/components/HorizontalScrollFilters/Root/context.tsx
var gy = t.createContext({}), _y = () => u(gy);
function vy({ activeFilter: e, children: t }) {
	let [n, r] = v(!1);
	return /* @__PURE__ */ b(gy.Provider, {
		value: {
			activeFilter: e,
			isFiltersDialogOpen: n,
			setIsFiltersDialogOpen: r
		},
		children: t
	});
}
//#endregion
//#region src/components/HorizontalScrollFilters/Root/DialogTrigger/styles.ts
var yy = "\n  flex flex-col\n  items-center justify-center\n  rounded-full\n  bg-white\n  text-gray-400\n  border border-gray-150\n  w-10 h-10\n  p-2\n  flex-none\n  transition-colors\n\n  hover:bg-primary-100\n  hover:text-base-white\n  hover:border-transparent\n", by = "\n  h-4 w-4\n  text-inherit\n  inline-block\n", xy = ({ label: e }) => {
	let { setIsFiltersDialogOpen: t } = _y();
	return /* @__PURE__ */ b("button", {
		"data-testid": "dialog-trigger",
		className: yy,
		"aria-label": e || "All filters",
		onClick: () => t(!0),
		children: /* @__PURE__ */ b(Jv, { className: by })
	});
}, Sy = "relative overflow-hidden", Cy = "h-full flex gap-x-2 items-center overflow-auto no-scrollbar outline-px focus:outline-primary-100 -outline-offset-2", wy = "h-full hidden md:flex items-center w-16 absolute from-base-white via-base-white to-transparent", Ty = `${wy} justify-start left-0 bg-gradient-to-r pl-1`, Ey = `${wy} justify-end right-0 bg-gradient-to-l pr-1`, Dy = "flex justify-center items-center border-2 border-gray-400 text-gray-400 rounded-full w-8 h-8 bg-base-white cursor-pointer hover:scale-110 transition-all", Oy = 50, ky = 128;
function Ay(e, t, n, r, i) {
	if (e || t === n || !i?.current || !t || !r) return;
	let a = i.current.querySelector("li[data-active='true']");
	a && i.current?.scroll({
		left: a.offsetLeft - ky,
		behavior: "smooth"
	});
}
var jy = ({ activeFilter: e, leftArrowAriaLabel: t, rightArrowAriaLabel: n, children: r }) => {
	let { isFiltersDialogOpen: i } = _y(), [a, o] = v(e), [s, c] = v(i), [l, u] = v(!1), [f, p] = v(!0), m = _(null);
	return d(() => {
		c(i);
	}, [i]), d(() => {
		o(e);
	}, [e]), d(() => {
		Ay(i, e, a, s, m);
	}, [
		e,
		a,
		i,
		s
	]), /* @__PURE__ */ b("div", {
		className: Sy,
		"data-testid": "scroll-list-container",
		children: /* @__PURE__ */ x("ul", {
			"data-testid": "scroll-list",
			className: Cy,
			ref: m,
			onScroll: (e) => {
				let t = Oy, n = e.currentTarget.scrollWidth - e.currentTarget.offsetWidth - Oy;
				e.currentTarget.scrollLeft > t && !l ? u(!0) : e.currentTarget.scrollLeft < t && l && u(!1), e.currentTarget.scrollLeft < n && !f ? p(!0) : e.currentTarget.scrollLeft > n && f && p(!1);
			},
			tabIndex: 0,
			children: [
				l && /* @__PURE__ */ b("li", {
					className: Ty,
					children: /* @__PURE__ */ b("button", {
						"data-testid": "left-arrow-button",
						className: Dy,
						"aria-label": t || "Scroll left",
						onClick: () => {
							m.current?.scroll({
								left: m.current.scrollLeft - m.current.clientWidth + ky,
								behavior: "smooth"
							});
						},
						children: /* @__PURE__ */ b(Gv, { weight: "bold" })
					})
				}),
				r,
				f && /* @__PURE__ */ b("li", {
					className: Ey,
					children: /* @__PURE__ */ b("button", {
						"data-testid": "right-arrow-button",
						className: Dy,
						"aria-label": n || "Scroll right",
						onClick: () => {
							m.current?.scroll({
								left: m.current.scrollLeft + m.current.clientWidth - ky,
								behavior: "smooth"
							});
						},
						children: /* @__PURE__ */ b(Kv, { weight: "bold" })
					})
				})
			]
		})
	});
}, My = "group list-none", Ny = "\n  text-gray-400 flex items-center gap-x-2 border border-gray-150\n  h-10 px-5 rounded-full cursor-pointer transition-colors -outline-offset-2\n\n  hover:bg-[color:var(--background,_theme(colors.primary.100))]\n  hover:text-base-white\n  hover:border-transparent\n\n  group-data-[active=true]:bg-[color:var(--background,_theme(colors.primary.100))]\n  group-data-[active=true]:text-base-white\n  group-data-[active=true]:border-transparent\n", Py = "w-5 h-5", Fy = "text-sm font-medium leading-5 text-nowrap";
//#endregion
//#region src/components/HorizontalScrollFilters/Root/Filter/index.tsx
function Iy({ filter: e, label: t, icon: n, iconBackgroundColor: r, iconFillColor: i, isActive: a, onSelectFilter: o }) {
	return /* @__PURE__ */ b("li", {
		className: My,
		"data-active": a,
		"data-testid": "filter-item",
		"data-filter": e,
		children: /* @__PURE__ */ x("button", {
			onClick: () => {
				o && o(e);
			},
			className: Ny,
			"data-testid": "filter-item-button",
			style: i ? { "--background": i } : void 0,
			children: [r && i ? /* @__PURE__ */ b(vt, {
				element: /* @__PURE__ */ b(n, {}),
				backgroundColor: r,
				fillColor: i
			}) : /* @__PURE__ */ b(n, {
				className: Py,
				"data-testid": "filter-item-icon"
			}), /* @__PURE__ */ b("p", {
				className: Fy,
				"data-testid": "filter-item-label",
				children: t
			})]
		})
	});
}
//#endregion
//#region ../../node_modules/@radix-ui/primitive/dist/index.mjs
function Ly(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return function(r) {
		if (e?.(r), n === !1 || !r.defaultPrevented) return t?.(r);
	};
}
//#endregion
//#region ../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
function Ry(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
function zy(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Ry(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Ry(e[t], null);
			}
		};
	};
}
function By(...t) {
	return e.useCallback(zy(...t), t);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-context/dist/index.mjs
function Vy(t, n) {
	let r = e.createContext(n), i = (t) => {
		let { children: n, ...i } = t, a = e.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ b(r.Provider, {
			value: a,
			children: n
		});
	};
	i.displayName = t + "Provider";
	function a(i) {
		let a = e.useContext(r);
		if (a) return a;
		if (n !== void 0) return n;
		throw Error(`\`${i}\` must be used within \`${t}\``);
	}
	return [i, a];
}
function Hy(t, n = []) {
	let r = [];
	function i(n, i) {
		let a = e.createContext(i), o = r.length;
		r = [...r, i];
		let s = (n) => {
			let { scope: r, children: i, ...s } = n, c = r?.[t]?.[o] || a, l = e.useMemo(() => s, Object.values(s));
			return /* @__PURE__ */ b(c.Provider, {
				value: l,
				children: i
			});
		};
		s.displayName = n + "Provider";
		function c(r, s) {
			let c = s?.[t]?.[o] || a, l = e.useContext(c);
			if (l) return l;
			if (i !== void 0) return i;
			throw Error(`\`${r}\` must be used within \`${n}\``);
		}
		return [s, c];
	}
	let a = () => {
		let n = r.map((t) => e.createContext(t));
		return function(r) {
			let i = r?.[t] || n;
			return e.useMemo(() => ({ [`__scope${t}`]: {
				...r,
				[t]: i
			} }), [r, i]);
		};
	};
	return a.scopeName = t, [i, Uy(a, ...n)];
}
function Uy(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = () => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		};
	};
	return r.scopeName = n.scopeName, r;
}
//#endregion
//#region ../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var Wy = globalThis?.document ? e.useLayoutEffect : () => {}, Gy = e.useId || (() => void 0), Ky = 0;
function qy(t) {
	let [n, r] = e.useState(Gy());
	return Wy(() => {
		t || r((e) => e ?? String(Ky++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
//#endregion
//#region ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Jy = e.useInsertionEffect || Wy;
function Yy({ prop: t, defaultProp: n, onChange: r = () => {}, caller: i }) {
	let [a, o, s] = Xy({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0, l = c ? t : a;
	{
		let n = e.useRef(t !== void 0);
		e.useEffect(() => {
			let e = n.current;
			e !== c && console.warn(`${i} is changing from ${e ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`), n.current = c;
		}, [c, i]);
	}
	return [l, e.useCallback((e) => {
		if (c) {
			let n = Zy(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
function Xy({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return Jy(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
function Zy(e) {
	return typeof e == "function";
}
//#endregion
//#region ../../node_modules/@radix-ui/react-slot/dist/index.mjs
/* @__NO_SIDE_EFFECTS__ */
function Qy(t) {
	let n = /* @__PURE__ */ $y(t), r = e.forwardRef((t, r) => {
		let { children: i, ...a } = t, o = e.Children.toArray(i), s = o.find(tb);
		if (s) {
			let t = s.props.children, i = o.map((n) => n === s ? e.Children.count(t) > 1 ? e.Children.only(null) : e.isValidElement(t) ? t.props.children : null : n);
			return /* @__PURE__ */ b(n, {
				...a,
				ref: r,
				children: e.isValidElement(t) ? e.cloneElement(t, void 0, i) : null
			});
		}
		return /* @__PURE__ */ b(n, {
			...a,
			ref: r,
			children: i
		});
	});
	return r.displayName = `${t}.Slot`, r;
}
/* @__NO_SIDE_EFFECTS__ */
function $y(t) {
	let n = e.forwardRef((t, n) => {
		let { children: r, ...i } = t;
		if (e.isValidElement(r)) {
			let t = rb(r), a = nb(i, r.props);
			return r.type !== e.Fragment && (a.ref = n ? zy(n, t) : t), e.cloneElement(r, a);
		}
		return e.Children.count(r) > 1 ? e.Children.only(null) : null;
	});
	return n.displayName = `${t}.SlotClone`, n;
}
var eb = Symbol("radix.slottable");
function tb(t) {
	return e.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === eb;
}
function nb(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
function rb(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
var $ = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((t, n) => {
	let r = /* @__PURE__ */ Qy(`Primitive.${n}`), i = e.forwardRef((e, t) => {
		let { asChild: i, ...a } = e, o = i ? r : n;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(o, {
			...a,
			ref: t
		});
	});
	return i.displayName = `Primitive.${n}`, {
		...t,
		[n]: i
	};
}, {});
function ib(e, t) {
	e && S.flushSync(() => e.dispatchEvent(t));
}
//#endregion
//#region ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function ab(t) {
	let n = e.useRef(t);
	return e.useEffect(() => {
		n.current = t;
	}), e.useMemo(() => (...e) => n.current?.(...e), []);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs
function ob(t, n = globalThis?.document) {
	let r = ab(t);
	e.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && r(e);
		};
		return n.addEventListener("keydown", e, { capture: !0 }), () => n.removeEventListener("keydown", e, { capture: !0 });
	}, [r, n]);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var sb = "DismissableLayer", cb = "dismissableLayer.update", lb = "dismissableLayer.pointerDownOutside", ub = "dismissableLayer.focusOutside", db, fb = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set()
}), pb = e.forwardRef((t, n) => {
	let { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = t, u = e.useContext(fb), [d, f] = e.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, m] = e.useState({}), h = By(n, (e) => f(e)), g = Array.from(u.layers), [_] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = g.indexOf(_), y = d ? g.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= v, C = gb((e) => {
		let t = e.target, n = [...u.branches].some((e) => e.contains(t));
		!S || n || (a?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), w = _b((e) => {
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p);
	return ob((e) => {
		y === u.layers.size - 1 && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	}, p), e.useEffect(() => {
		if (d) return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (db = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), vb(), () => {
			r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = db);
		};
	}, [
		d,
		p,
		r,
		u
	]), e.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), vb());
	}, [d, u]), e.useEffect(() => {
		let e = () => m({});
		return document.addEventListener(cb, e), () => document.removeEventListener(cb, e);
	}, []), /* @__PURE__ */ b($.div, {
		...l,
		ref: h,
		style: {
			pointerEvents: x ? S ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: Ly(t.onFocusCapture, w.onFocusCapture),
		onBlurCapture: Ly(t.onBlurCapture, w.onBlurCapture),
		onPointerDownCapture: Ly(t.onPointerDownCapture, C.onPointerDownCapture)
	});
});
pb.displayName = sb;
var mb = "DismissableLayerBranch", hb = e.forwardRef((t, n) => {
	let r = e.useContext(fb), i = e.useRef(null), a = By(n, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return r.branches.add(e), () => {
			r.branches.delete(e);
		};
	}, [r.branches]), /* @__PURE__ */ b($.div, {
		...t,
		ref: a
	});
});
hb.displayName = mb;
function gb(t, n = globalThis?.document) {
	let r = ab(t), i = e.useRef(!1), a = e.useRef(() => {});
	return e.useEffect(() => {
		let e = (e) => {
			if (e.target && !i.current) {
				let t = function() {
					yb(lb, r, i, { discrete: !0 });
				}, i = { originalEvent: e };
				e.pointerType === "touch" ? (n.removeEventListener("click", a.current), a.current = t, n.addEventListener("click", a.current, { once: !0 })) : t();
			} else n.removeEventListener("click", a.current);
			i.current = !1;
		}, t = window.setTimeout(() => {
			n.addEventListener("pointerdown", e);
		}, 0);
		return () => {
			window.clearTimeout(t), n.removeEventListener("pointerdown", e), n.removeEventListener("click", a.current);
		};
	}, [n, r]), { onPointerDownCapture: () => i.current = !0 };
}
function _b(t, n = globalThis?.document) {
	let r = ab(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = (e) => {
			e.target && !i.current && yb(ub, r, { originalEvent: e }, { discrete: !1 });
		};
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: () => i.current = !0,
		onBlurCapture: () => i.current = !1
	};
}
function vb() {
	let e = new CustomEvent(cb);
	document.dispatchEvent(e);
}
function yb(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? ib(i, a) : i.dispatchEvent(a);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var bb = "focusScope.autoFocusOnMount", xb = "focusScope.autoFocusOnUnmount", Sb = {
	bubbles: !1,
	cancelable: !0
}, Cb = "FocusScope", wb = e.forwardRef((t, n) => {
	let { loop: r = !1, trapped: i = !1, onMountAutoFocus: a, onUnmountAutoFocus: o, ...s } = t, [c, l] = e.useState(null), u = ab(a), d = ab(o), f = e.useRef(null), p = By(n, (e) => l(e)), m = e.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	e.useEffect(() => {
		if (i) {
			let e = function(e) {
				if (m.paused || !c) return;
				let t = e.target;
				c.contains(t) ? f.current = t : jb(f.current, { select: !0 });
			}, t = function(e) {
				if (m.paused || !c) return;
				let t = e.relatedTarget;
				t !== null && (c.contains(t) || jb(f.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && jb(c);
			};
			document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return c && r.observe(c, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		i,
		c,
		m.paused
	]), e.useEffect(() => {
		if (c) {
			Mb.add(m);
			let e = document.activeElement;
			if (!c.contains(e)) {
				let t = new CustomEvent(bb, Sb);
				c.addEventListener(bb, u), c.dispatchEvent(t), t.defaultPrevented || (Tb(Fb(Db(c)), { select: !0 }), document.activeElement === e && jb(c));
			}
			return () => {
				c.removeEventListener(bb, u), setTimeout(() => {
					let t = new CustomEvent(xb, Sb);
					c.addEventListener(xb, d), c.dispatchEvent(t), t.defaultPrevented || jb(e ?? document.body, { select: !0 }), c.removeEventListener(xb, d), Mb.remove(m);
				}, 0);
			};
		}
	}, [
		c,
		u,
		d,
		m
	]);
	let h = e.useCallback((e) => {
		if (!r && !i || m.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = Eb(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && jb(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && jb(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		i,
		m.paused
	]);
	return /* @__PURE__ */ b($.div, {
		tabIndex: -1,
		...s,
		ref: p,
		onKeyDown: h
	});
});
wb.displayName = Cb;
function Tb(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (jb(r, { select: t }), document.activeElement !== n) return;
}
function Eb(e) {
	let t = Db(e);
	return [Ob(t, e), Ob(t.reverse(), e)];
}
function Db(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
function Ob(e, t) {
	for (let n of e) if (!kb(n, { upTo: t })) return n;
}
function kb(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
function Ab(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
function jb(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && Ab(e) && t && e.select();
	}
}
var Mb = Nb();
function Nb() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = Pb(e, t), e.unshift(t);
		},
		remove(t) {
			e = Pb(e, t), e[0]?.resume();
		}
	};
}
function Pb(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
function Fb(e) {
	return e.filter((e) => e.tagName !== "A");
}
//#endregion
//#region ../../node_modules/@radix-ui/react-portal/dist/index.mjs
var Ib = "Portal", Lb = e.forwardRef((t, n) => {
	let { container: r, ...i } = t, [a, o] = e.useState(!1);
	Wy(() => o(!0), []);
	let s = r || a && globalThis?.document?.body;
	return s ? C.createPortal(/* @__PURE__ */ b($.div, {
		...i,
		ref: n
	}), s) : null;
});
Lb.displayName = Ib;
//#endregion
//#region ../../node_modules/@radix-ui/react-presence/dist/index.mjs
function Rb(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
var zb = (t) => {
	let { present: n, children: r } = t, i = Bb(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = By(i.ref, Hb(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
};
zb.displayName = "Presence";
function Bb(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), [s, c] = Rb(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		let e = Vb(i.current);
		o.current = s === "mounted" ? e : "none";
	}, [s]), Wy(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = Vb(e);
			t ? c("MOUNT") : i === "none" || e?.display === "none" ? c("UNMOUNT") : c(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, c]), Wy(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = (r) => {
				let o = Vb(i.current).includes(r.animationName);
				if (r.target === n && o && (c("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, s = (e) => {
				e.target === n && (o.current = Vb(i.current));
			};
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		} else c("ANIMATION_END");
	}, [n, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: e.useCallback((e) => {
			i.current = e ? getComputedStyle(e) : null, r(e);
		}, [])
	};
}
function Vb(e) {
	return e?.animationName || "none";
}
function Hb(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Ub = 0;
function Wb() {
	e.useEffect(() => {
		let e = document.querySelectorAll("[data-radix-focus-guard]");
		return document.body.insertAdjacentElement("afterbegin", e[0] ?? Gb()), document.body.insertAdjacentElement("beforeend", e[1] ?? Gb()), Ub++, () => {
			Ub === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Ub--;
		};
	}, []);
}
function Gb() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
//#endregion
//#region ../../node_modules/tslib/tslib.es6.mjs
var Kb = function() {
	return Kb = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, Kb.apply(this, arguments);
};
function qb(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Jb(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Yb = "right-scroll-bar-position", Xb = "width-before-scroll-bar", Zb = "with-scroll-bars-hidden", Qb = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function $b(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/useRef.js
function ex(e, t) {
	var n = v(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var tx = typeof window < "u" ? e.useLayoutEffect : e.useEffect, nx = /* @__PURE__ */ new WeakMap();
function rx(e, t) {
	var n = ex(t || null, function(t) {
		return e.forEach(function(e) {
			return $b(e, t);
		});
	});
	return tx(function() {
		var t = nx.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || $b(e, null);
			}), i.forEach(function(e) {
				r.has(e) || $b(e, a);
			});
		}
		nx.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/use-sidecar/dist/es2015/medium.js
function ix(e) {
	return e;
}
function ax(e, t) {
	t === void 0 && (t = ix);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function ox(e) {
	e === void 0 && (e = {});
	var t = ax(null);
	return t.options = Kb({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/use-sidecar/dist/es2015/exports.js
var sx = function(t) {
	var n = t.sideCar, r = qb(t, ["sideCar"]);
	if (!n) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = n.read();
	if (!i) throw Error("Sidecar medium not found");
	return e.createElement(i, Kb({}, r));
};
sx.isSideCarExport = !0;
function cx(e, t) {
	return e.useMedium(t), sx;
}
//#endregion
//#region ../../node_modules/react-remove-scroll/dist/es2015/medium.js
var lx = ox(), ux = function() {}, dx = e.forwardRef(function(t, n) {
	var r = e.useRef(null), i = e.useState({
		onScrollCapture: ux,
		onWheelCapture: ux,
		onTouchMoveCapture: ux
	}), a = i[0], o = i[1], s = t.forwardProps, c = t.children, l = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, p = t.sideCar, m = t.noIsolation, h = t.inert, g = t.allowPinchZoom, _ = t.as, v = _ === void 0 ? "div" : _, y = t.gapMode, b = qb(t, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), x = p, S = rx([r, n]), C = Kb(Kb({}, b), a);
	return e.createElement(e.Fragment, null, d && e.createElement(x, {
		sideCar: lx,
		removeScrollBar: u,
		shards: f,
		noIsolation: m,
		inert: h,
		setCallbacks: o,
		allowPinchZoom: !!g,
		lockRef: r,
		gapMode: y
	}), s ? e.cloneElement(e.Children.only(c), Kb(Kb({}, C), { ref: S })) : e.createElement(v, Kb({}, C, {
		className: l,
		ref: S
	}), c));
});
dx.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, dx.classNames = {
	fullWidth: Xb,
	zeroRight: Yb
};
//#endregion
//#region ../../node_modules/get-nonce/dist/es2015/index.js
var fx, px = function() {
	if (fx) return fx;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/react-style-singleton/dist/es2015/singleton.js
function mx() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = px();
	return t && e.setAttribute("nonce", t), e;
}
function hx(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function gx(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var _x = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = mx()) && (hx(t, n), gx(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, vx = function() {
	var t = _x();
	return function(n, r) {
		e.useEffect(function() {
			return t.add(n), function() {
				t.remove();
			};
		}, [n && r]);
	};
}, yx = function() {
	var e = vx();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, bx = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, xx = function(e) {
	return parseInt(e || "", 10) || 0;
}, Sx = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		xx(n),
		xx(r),
		xx(i)
	];
}, Cx = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return bx;
	var t = Sx(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, wx = yx(), Tx = "data-scroll-locked", Ex = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Zb} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${Tx}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Yb} {
    right: ${s}px ${r};
  }
  
  .${Xb} {
    margin-right: ${s}px ${r};
  }
  
  .${Yb} .${Yb} {
    right: 0 ${r};
  }
  
  .${Xb} .${Xb} {
    margin-right: 0 ${r};
  }
  
  body[${Tx}] {
    ${Qb}: ${s}px;
  }
`;
}, Dx = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, Ox = function() {
	e.useEffect(function() {
		return document.body.setAttribute(Tx, (Dx() + 1).toString()), function() {
			var e = Dx() - 1;
			e <= 0 ? document.body.removeAttribute(Tx) : document.body.setAttribute(Tx, e.toString());
		};
	}, []);
}, kx = function(t) {
	var n = t.noRelative, r = t.noImportant, i = t.gapMode, a = i === void 0 ? "margin" : i;
	Ox();
	var o = e.useMemo(function() {
		return Cx(a);
	}, [a]);
	return e.createElement(wx, { styles: Ex(o, !n, a, r ? "" : "!important") });
}, Ax = !1;
if (typeof window < "u") try {
	var jx = Object.defineProperty({}, "passive", { get: function() {
		return Ax = !0, !0;
	} });
	window.addEventListener("test", jx, jx), window.removeEventListener("test", jx, jx);
} catch {
	Ax = !1;
}
var Mx = Ax ? { passive: !1 } : !1, Nx = function(e) {
	return e.tagName === "TEXTAREA";
}, Px = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !Nx(e) && n[t] === "visible");
}, Fx = function(e) {
	return Px(e, "overflowY");
}, Ix = function(e) {
	return Px(e, "overflowX");
}, Lx = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Bx(e, r)) {
			var i = Vx(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Rx = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, zx = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Bx = function(e, t) {
	return e === "v" ? Fx(t) : Ix(t);
}, Vx = function(e, t) {
	return e === "v" ? Rx(t) : zx(t);
}, Hx = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Ux = function(e, t, n, r, i) {
	var a = Hx(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		var p = Vx(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Bx(e, s) && (d += h, f += m), s = s instanceof ShadowRoot ? s.host : s.parentNode;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Wx = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Gx = function(e) {
	return [e.deltaX, e.deltaY];
}, Kx = function(e) {
	return e && "current" in e ? e.current : e;
}, qx = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, Jx = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, Yx = 0, Xx = [];
function Zx(t) {
	var n = e.useRef([]), r = e.useRef([0, 0]), i = e.useRef(), a = e.useState(Yx++)[0], o = e.useState(yx)[0], s = e.useRef(t);
	e.useEffect(function() {
		s.current = t;
	}, [t]), e.useEffect(function() {
		if (t.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var e = Jb([t.lockRef.current], (t.shards || []).map(Kx), !0).filter(Boolean);
			return e.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), e.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		t.inert,
		t.lockRef.current,
		t.shards
	]);
	var c = e.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var n = Wx(e), a = r.current, o = "deltaX" in e ? e.deltaX : a[0] - n[0], c = "deltaY" in e ? e.deltaY : a[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = Lx(d, u);
		if (!f) return !0;
		if (f ? l = d : (l = d === "v" ? "h" : "v", f = Lx(d, u)), !f) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var p = i.current || l;
		return Ux(p, t, e, p === "h" ? o : c, !0);
	}, []), l = e.useCallback(function(e) {
		var t = e;
		if (!(!Xx.length || Xx[Xx.length - 1] !== o)) {
			var r = "deltaY" in t ? Gx(t) : Wx(t), i = n.current.filter(function(e) {
				return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && qx(e.delta, r);
			})[0];
			if (i && i.should) {
				t.cancelable && t.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(Kx).filter(Boolean).filter(function(e) {
					return e.contains(t.target);
				});
				(a.length > 0 ? c(t, a[0]) : !s.current.noIsolation) && t.cancelable && t.preventDefault();
			}
		}
	}, []), u = e.useCallback(function(e, t, r, i) {
		var a = {
			name: e,
			delta: t,
			target: r,
			should: i,
			shadowParent: Qx(r)
		};
		n.current.push(a), setTimeout(function() {
			n.current = n.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = e.useCallback(function(e) {
		r.current = Wx(e), i.current = void 0;
	}, []), f = e.useCallback(function(e) {
		u(e.type, Gx(e), e.target, c(e, t.lockRef.current));
	}, []), p = e.useCallback(function(e) {
		u(e.type, Wx(e), e.target, c(e, t.lockRef.current));
	}, []);
	e.useEffect(function() {
		return Xx.push(o), t.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, Mx), document.addEventListener("touchmove", l, Mx), document.addEventListener("touchstart", d, Mx), function() {
			Xx = Xx.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, Mx), document.removeEventListener("touchmove", l, Mx), document.removeEventListener("touchstart", d, Mx);
		};
	}, []);
	var m = t.removeScrollBar, h = t.inert;
	return e.createElement(e.Fragment, null, h ? e.createElement(o, { styles: Jx(a) }) : null, m ? e.createElement(kx, { gapMode: t.gapMode }) : null);
}
function Qx(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var $x = cx(lx, Zx), eS = e.forwardRef(function(t, n) {
	return e.createElement(dx, Kb({}, t, {
		ref: n,
		sideCar: $x
	}));
});
eS.classNames = dx.classNames;
//#endregion
//#region ../../node_modules/aria-hidden/dist/es2015/index.js
var tS = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, nS = /* @__PURE__ */ new WeakMap(), rS = /* @__PURE__ */ new WeakMap(), iS = {}, aS = 0, oS = function(e) {
	return e && (e.host || oS(e.parentNode));
}, sS = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = oS(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, cS = function(e, t, n, r) {
	var i = sS(t, Array.isArray(e) ? e : [e]);
	iS[n] || (iS[n] = /* @__PURE__ */ new WeakMap());
	var a = iS[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (nS.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				nS.set(e, c), a.set(e, l), o.push(e), c === 1 && i && rS.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), aS++, function() {
		o.forEach(function(e) {
			var t = nS.get(e) - 1, i = a.get(e) - 1;
			nS.set(e, t), a.set(e, i), t || (rS.has(e) || e.removeAttribute(r), rS.delete(e)), i || e.removeAttribute(n);
		}), aS--, aS || (nS = /* @__PURE__ */ new WeakMap(), nS = /* @__PURE__ */ new WeakMap(), rS = /* @__PURE__ */ new WeakMap(), iS = {});
	};
}, lS = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || tS(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), cS(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, uS = "Dialog", [dS, fS] = Hy(uS), [pS, mS] = dS(uS), hS = (t) => {
	let { __scopeDialog: n, children: r, open: i, defaultOpen: a, onOpenChange: o, modal: s = !0 } = t, c = e.useRef(null), l = e.useRef(null), [u, d] = Yy({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: uS
	});
	return /* @__PURE__ */ b(pS, {
		scope: n,
		triggerRef: c,
		contentRef: l,
		contentId: qy(),
		titleId: qy(),
		descriptionId: qy(),
		open: u,
		onOpenChange: d,
		onOpenToggle: e.useCallback(() => d((e) => !e), [d]),
		modal: s,
		children: r
	});
};
hS.displayName = uS;
var gS = "DialogTrigger", _S = e.forwardRef((e, t) => {
	let { __scopeDialog: n, ...r } = e, i = mS(gS, n), a = By(t, i.triggerRef);
	return /* @__PURE__ */ b($.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.contentId,
		"data-state": LS(i.open),
		...r,
		ref: a,
		onClick: Ly(e.onClick, i.onOpenToggle)
	});
});
_S.displayName = gS;
var vS = "DialogPortal", [yS, bS] = dS(vS, { forceMount: void 0 }), xS = (t) => {
	let { __scopeDialog: n, forceMount: r, children: i, container: a } = t, o = mS(vS, n);
	return /* @__PURE__ */ b(yS, {
		scope: n,
		forceMount: r,
		children: e.Children.map(i, (e) => /* @__PURE__ */ b(zb, {
			present: r || o.open,
			children: /* @__PURE__ */ b(Lb, {
				asChild: !0,
				container: a,
				children: e
			})
		}))
	});
};
xS.displayName = vS;
var SS = "DialogOverlay", CS = e.forwardRef((e, t) => {
	let n = bS(SS, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = mS(SS, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ b(zb, {
		present: r || a.open,
		children: /* @__PURE__ */ b(TS, {
			...i,
			ref: t
		})
	}) : null;
});
CS.displayName = SS;
var wS = /* @__PURE__ */ Qy("DialogOverlay.RemoveScroll"), TS = e.forwardRef((e, t) => {
	let { __scopeDialog: n, ...r } = e, i = mS(SS, n);
	return /* @__PURE__ */ b(eS, {
		as: wS,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ b($.div, {
			"data-state": LS(i.open),
			...r,
			ref: t,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}), ES = "DialogContent", DS = e.forwardRef((e, t) => {
	let n = bS(ES, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = mS(ES, e.__scopeDialog);
	return /* @__PURE__ */ b(zb, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ b(OS, {
			...i,
			ref: t
		}) : /* @__PURE__ */ b(kS, {
			...i,
			ref: t
		})
	});
});
DS.displayName = ES;
var OS = e.forwardRef((t, n) => {
	let r = mS(ES, t.__scopeDialog), i = e.useRef(null), a = By(n, r.contentRef, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return lS(e);
	}, []), /* @__PURE__ */ b(AS, {
		...t,
		ref: a,
		trapFocus: r.open,
		disableOutsidePointerEvents: !0,
		onCloseAutoFocus: Ly(t.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: Ly(t.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: Ly(t.onFocusOutside, (e) => e.preventDefault())
	});
}), kS = e.forwardRef((t, n) => {
	let r = mS(ES, t.__scopeDialog), i = e.useRef(!1), a = e.useRef(!1);
	return /* @__PURE__ */ b(AS, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, a.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (a.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && a.current && e.preventDefault();
		}
	});
}), AS = e.forwardRef((t, n) => {
	let { __scopeDialog: r, trapFocus: i, onOpenAutoFocus: a, onCloseAutoFocus: o, ...s } = t, c = mS(ES, r), l = e.useRef(null), u = By(n, l);
	return Wb(), /* @__PURE__ */ x(y, { children: [/* @__PURE__ */ b(wb, {
		asChild: !0,
		loop: !0,
		trapped: i,
		onMountAutoFocus: a,
		onUnmountAutoFocus: o,
		children: /* @__PURE__ */ b(pb, {
			role: "dialog",
			id: c.contentId,
			"aria-describedby": c.descriptionId,
			"aria-labelledby": c.titleId,
			"data-state": LS(c.open),
			...s,
			ref: u,
			onDismiss: () => c.onOpenChange(!1)
		})
	}), /* @__PURE__ */ x(y, { children: [/* @__PURE__ */ b(VS, { titleId: c.titleId }), /* @__PURE__ */ b(US, {
		contentRef: l,
		descriptionId: c.descriptionId
	})] })] });
}), jS = "DialogTitle", MS = e.forwardRef((e, t) => {
	let { __scopeDialog: n, ...r } = e, i = mS(jS, n);
	return /* @__PURE__ */ b($.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
});
MS.displayName = jS;
var NS = "DialogDescription", PS = e.forwardRef((e, t) => {
	let { __scopeDialog: n, ...r } = e, i = mS(NS, n);
	return /* @__PURE__ */ b($.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
});
PS.displayName = NS;
var FS = "DialogClose", IS = e.forwardRef((e, t) => {
	let { __scopeDialog: n, ...r } = e, i = mS(FS, n);
	return /* @__PURE__ */ b($.button, {
		type: "button",
		...r,
		ref: t,
		onClick: Ly(e.onClick, () => i.onOpenChange(!1))
	});
});
IS.displayName = FS;
function LS(e) {
	return e ? "open" : "closed";
}
var RS = "DialogTitleWarning", [zS, BS] = Vy(RS, {
	contentName: ES,
	titleName: jS,
	docsSlug: "dialog"
}), VS = ({ titleId: t }) => {
	let n = BS(RS), r = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
	return e.useEffect(() => {
		t && (document.getElementById(t) || console.error(r));
	}, [r, t]), null;
}, HS = "DialogDescriptionWarning", US = ({ contentRef: t, descriptionId: n }) => {
	let r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${BS(HS).contentName}}.`;
	return e.useEffect(() => {
		let e = t.current?.getAttribute("aria-describedby");
		n && e && (document.getElementById(n) || console.warn(r));
	}, [
		r,
		t,
		n
	]), null;
}, WS = hS, GS = xS, KS = CS, qS = DS, JS = MS, YS = PS, XS = IS, ZS = "fixed top-0 left-0 right-0 bottom-0 z-20 opacity-40 bg-gray-400 rounded inset-0", QS = "\n  fixed top-0 left-0 h-full w-full\n\n  md:top-1/2 md:max-h-[475px] md:-translate-y-1/2\n  md:left-1/2 md:max-w-[600px] md:-translate-x-1/2\n  \n  bg-base-white\n  py-6\n  z-30\n", $S = "text-center font-semibold text-gray-800", eC = "font-medium leading-6 text-gray-400 mt-8 mb-6 px-4", tC = "absolute top-5 right-5", nC = "h-8 w-8 text-gray-250 hover:text-gray-400 transition-colors", rC = "h-full flex flex-col justify-between", iC = "px-4 pb-4 flex flex-wrap gap-2 overflow-y-auto", aC = "p-6 border-t border-gray-200 flex justify-between items-center", oC = "md:w-52", sC = ({ title: e, description: t, applyLabel: n, resetLabel: r, onReset: i, onApply: a, onClose: o, children: s }) => {
	let { isFiltersDialogOpen: c, setIsFiltersDialogOpen: l } = _y();
	return /* @__PURE__ */ b(WS, {
		open: c,
		children: /* @__PURE__ */ x(GS, { children: [/* @__PURE__ */ b(KS, {
			className: ZS,
			"data-testid": "dialog-overlay"
		}), /* @__PURE__ */ x(qS, {
			className: QS,
			"data-testid": "dialog-content",
			children: [
				/* @__PURE__ */ b(JS, {
					className: $S,
					"data-testid": "dialog-title",
					children: e
				}),
				/* @__PURE__ */ b(XS, {
					className: tC,
					onClick: () => {
						l(!1), typeof o == "function" && o();
					},
					"data-testid": "dialog-close",
					children: /* @__PURE__ */ b(Zv, { className: nC })
				}),
				/* @__PURE__ */ x("div", {
					className: rC,
					"data-testid": "dialog-filters",
					children: [
						/* @__PURE__ */ b(YS, {
							className: eC,
							"data-testid": "dialog-description",
							children: t
						}),
						/* @__PURE__ */ b("div", {
							className: iC,
							"data-testid": "dialog-filter-children",
							children: s
						}),
						/* @__PURE__ */ x("div", {
							className: aC,
							"data-testid": "dialog-footer",
							children: [/* @__PURE__ */ b(ft, {
								variant: "ghost",
								onClick: () => {
									i(), l(!1);
								},
								"data-testid": "dialog-reset-button",
								children: r
							}), /* @__PURE__ */ b(ft, {
								className: oC,
								onClick: () => {
									a(), l(!1);
								},
								"data-testid": "dialog-apply-button",
								children: n
							})]
						})
					]
				})
			]
		})] })
	});
}, cC = /* @__PURE__ */ O({
	Dialog: () => sC,
	DialogTrigger: () => xy,
	Filter: () => Iy,
	Root: () => lC,
	ScrollList: () => jy
});
function lC(e) {
	return /* @__PURE__ */ b(vy, { children: e.children });
}
//#endregion
//#region src/components/Modal/styles.ts
var uC = "fixed inset-0 bg-black/50 data-[state=open]:animate-overlayShow z-10", dC = "\n  fixed left-1/2 top-1/2 z-10\n  -translate-x-1/2 -translate-y-1/2\n  shadow-lg focus:outline-none\n\n  data-[state=open]:animate-contentShow\n", fC = "flex flex-col gap-y-6 whitespace-pre-line", pC = "flex items-center justify-between m-0 text-2xl text-gray-800", mC = "m-0", hC = "h-8 w-8 cursor-pointer transition-colors hover:bg-gray-200 rounded-full flex items-center justify-center", gC = "flex justify-end gap-2", _C = ({ title: e, description: t, isOpen: n, children: r, onClose: i }) => /* @__PURE__ */ b(WS, {
	open: n,
	children: /* @__PURE__ */ x(GS, { children: [/* @__PURE__ */ b(KS, { className: uC }), /* @__PURE__ */ b(qS, {
		className: dC,
		children: /* @__PURE__ */ b(ht, { children: /* @__PURE__ */ x("div", {
			className: fC,
			children: [
				/* @__PURE__ */ x(JS, {
					className: pC,
					children: [/* @__PURE__ */ b("span", { children: e }), /* @__PURE__ */ b(Xv, {
						size: 32,
						className: hC,
						onClick: i
					})]
				}),
				/* @__PURE__ */ b(YS, {
					className: mC,
					children: t
				}),
				/* @__PURE__ */ b("div", {
					className: gC,
					children: r
				})
			]
		}) })
	})] })
});
typeof window < "u" && window.document && window.document.createElement;
function vC(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return function(r) {
		if (e?.(r), n === !1 || !r.defaultPrevented) return t?.(r);
	};
}
//#endregion
//#region ../../node_modules/@radix-ui/react-collection/dist/index.mjs
function yC(e) {
	let n = e + "CollectionProvider", [r, i] = Hy(n), [a, o] = r(n, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), s = (e) => {
		let { scope: n, children: r } = e, i = t.useRef(null), o = t.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ b(a, {
			scope: n,
			itemMap: o,
			collectionRef: i,
			children: r
		});
	};
	s.displayName = n;
	let c = e + "CollectionSlot", l = /* @__PURE__ */ Qy(c), u = t.forwardRef((e, t) => {
		let { scope: n, children: r } = e;
		return /* @__PURE__ */ b(l, {
			ref: By(t, o(c, n).collectionRef),
			children: r
		});
	});
	u.displayName = c;
	let d = e + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ Qy(d), m = t.forwardRef((e, n) => {
		let { scope: r, children: i, ...a } = e, s = t.useRef(null), c = By(n, s), l = o(d, r);
		return t.useEffect(() => (l.itemMap.set(s, {
			ref: s,
			...a
		}), () => void l.itemMap.delete(s))), /* @__PURE__ */ b(p, {
			[f]: "",
			ref: c,
			children: i
		});
	});
	m.displayName = d;
	function h(n) {
		let r = o(e + "CollectionConsumer", n);
		return t.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${f}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return [
		{
			Provider: s,
			Slot: u,
			ItemSlot: m
		},
		h,
		i
	];
}
//#endregion
//#region ../../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var bC = "DismissableLayer", xC = "dismissableLayer.update", SC = "dismissableLayer.pointerDownOutside", CC = "dismissableLayer.focusOutside", wC, TC = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set()
}), EC = e.forwardRef((t, n) => {
	let { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = t, u = e.useContext(TC), [d, f] = e.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, m] = e.useState({}), h = By(n, (e) => f(e)), g = Array.from(u.layers), [_] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = g.indexOf(_), y = d ? g.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, S = y >= v, C = kC((e) => {
		let t = e.target, n = [...u.branches].some((e) => e.contains(t));
		!S || n || (a?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), w = AC((e) => {
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p);
	return ob((e) => {
		y === u.layers.size - 1 && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	}, p), e.useEffect(() => {
		if (d) return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (wC = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), jC(), () => {
			r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = wC);
		};
	}, [
		d,
		p,
		r,
		u
	]), e.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), jC());
	}, [d, u]), e.useEffect(() => {
		let e = () => m({});
		return document.addEventListener(xC, e), () => document.removeEventListener(xC, e);
	}, []), /* @__PURE__ */ b($.div, {
		...l,
		ref: h,
		style: {
			pointerEvents: x ? S ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: vC(t.onFocusCapture, w.onFocusCapture),
		onBlurCapture: vC(t.onBlurCapture, w.onBlurCapture),
		onPointerDownCapture: vC(t.onPointerDownCapture, C.onPointerDownCapture)
	});
});
EC.displayName = bC;
var DC = "DismissableLayerBranch", OC = e.forwardRef((t, n) => {
	let r = e.useContext(TC), i = e.useRef(null), a = By(n, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return r.branches.add(e), () => {
			r.branches.delete(e);
		};
	}, [r.branches]), /* @__PURE__ */ b($.div, {
		...t,
		ref: a
	});
});
OC.displayName = DC;
function kC(t, n = globalThis?.document) {
	let r = ab(t), i = e.useRef(!1), a = e.useRef(() => {});
	return e.useEffect(() => {
		let e = (e) => {
			if (e.target && !i.current) {
				let t = function() {
					MC(SC, r, i, { discrete: !0 });
				}, i = { originalEvent: e };
				e.pointerType === "touch" ? (n.removeEventListener("click", a.current), a.current = t, n.addEventListener("click", a.current, { once: !0 })) : t();
			} else n.removeEventListener("click", a.current);
			i.current = !1;
		}, t = window.setTimeout(() => {
			n.addEventListener("pointerdown", e);
		}, 0);
		return () => {
			window.clearTimeout(t), n.removeEventListener("pointerdown", e), n.removeEventListener("click", a.current);
		};
	}, [n, r]), { onPointerDownCapture: () => i.current = !0 };
}
function AC(t, n = globalThis?.document) {
	let r = ab(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = (e) => {
			e.target && !i.current && MC(CC, r, { originalEvent: e }, { discrete: !1 });
		};
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: () => i.current = !0,
		onBlurCapture: () => i.current = !1
	};
}
function jC() {
	let e = new CustomEvent(xC);
	document.dispatchEvent(e);
}
function MC(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? ib(i, a) : i.dispatchEvent(a);
}
var NC = EC, PC = OC;
//#endregion
//#region ../../node_modules/@radix-ui/react-toast/node_modules/@radix-ui/react-presence/dist/index.mjs
function FC(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
var IC = (t) => {
	let { present: n, children: r } = t, i = LC(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = By(i.ref, zC(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
};
IC.displayName = "Presence";
function LC(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), [s, c] = FC(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		let e = RC(i.current);
		o.current = s === "mounted" ? e : "none";
	}, [s]), Wy(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = RC(e);
			t ? c("MOUNT") : i === "none" || e?.display === "none" ? c("UNMOUNT") : c(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, c]), Wy(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = (r) => {
				let o = RC(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (c("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, s = (e) => {
				e.target === n && (o.current = RC(i.current));
			};
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		} else c("ANIMATION_END");
	}, [n, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: e.useCallback((e) => {
			i.current = e ? getComputedStyle(e) : null, r(e);
		}, [])
	};
}
function RC(e) {
	return e?.animationName || "none";
}
function zC(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
//#endregion
//#region ../../node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var BC = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), VC = "VisuallyHidden", HC = e.forwardRef((e, t) => /* @__PURE__ */ b($.span, {
	...e,
	ref: t,
	style: {
		...BC,
		...e.style
	}
}));
HC.displayName = VC;
//#endregion
//#region ../../node_modules/@radix-ui/react-toast/dist/index.mjs
var UC = "ToastProvider", [WC, GC, KC] = yC("Toast"), [qC, JC] = Hy("Toast", [KC]), [YC, XC] = qC(UC), ZC = (t) => {
	let { __scopeToast: n, label: r = "Notification", duration: i = 5e3, swipeDirection: a = "right", swipeThreshold: o = 50, children: s } = t, [c, l] = e.useState(null), [u, d] = e.useState(0), f = e.useRef(!1), p = e.useRef(!1);
	return r.trim() || console.error(`Invalid prop \`label\` supplied to \`${UC}\`. Expected non-empty \`string\`.`), /* @__PURE__ */ b(WC.Provider, {
		scope: n,
		children: /* @__PURE__ */ b(YC, {
			scope: n,
			label: r,
			duration: i,
			swipeDirection: a,
			swipeThreshold: o,
			toastCount: u,
			viewport: c,
			onViewportChange: l,
			onToastAdd: e.useCallback(() => d((e) => e + 1), []),
			onToastRemove: e.useCallback(() => d((e) => e - 1), []),
			isFocusedToastEscapeKeyDownRef: f,
			isClosePausedRef: p,
			children: s
		})
	});
};
ZC.displayName = UC;
var QC = "ToastViewport", $C = ["F8"], ew = "toast.viewportPause", tw = "toast.viewportResume", nw = e.forwardRef((t, n) => {
	let { __scopeToast: r, hotkey: i = $C, label: a = "Notifications ({hotkey})", ...o } = t, s = XC(QC, r), c = GC(r), l = e.useRef(null), u = e.useRef(null), d = e.useRef(null), f = e.useRef(null), p = By(n, f, s.onViewportChange), m = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), h = s.toastCount > 0;
	e.useEffect(() => {
		let e = (e) => {
			i.length !== 0 && i.every((t) => e[t] || e.code === t) && f.current?.focus();
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [i]), e.useEffect(() => {
		let e = l.current, t = f.current;
		if (h && e && t) {
			let n = () => {
				if (!s.isClosePausedRef.current) {
					let e = new CustomEvent(ew);
					t.dispatchEvent(e), s.isClosePausedRef.current = !0;
				}
			}, r = () => {
				if (s.isClosePausedRef.current) {
					let e = new CustomEvent(tw);
					t.dispatchEvent(e), s.isClosePausedRef.current = !1;
				}
			}, i = (t) => {
				e.contains(t.relatedTarget) || r();
			}, a = () => {
				e.contains(document.activeElement) || r();
			};
			return e.addEventListener("focusin", n), e.addEventListener("focusout", i), e.addEventListener("pointermove", n), e.addEventListener("pointerleave", a), window.addEventListener("blur", n), window.addEventListener("focus", r), () => {
				e.removeEventListener("focusin", n), e.removeEventListener("focusout", i), e.removeEventListener("pointermove", n), e.removeEventListener("pointerleave", a), window.removeEventListener("blur", n), window.removeEventListener("focus", r);
			};
		}
	}, [h, s.isClosePausedRef]);
	let g = e.useCallback(({ tabbingDirection: e }) => {
		let t = c().map((t) => {
			let n = t.ref.current, r = [n, ...kw(n)];
			return e === "forwards" ? r : r.reverse();
		});
		return (e === "forwards" ? t.reverse() : t).flat();
	}, [c]);
	return e.useEffect(() => {
		let e = f.current;
		if (e) {
			let t = (t) => {
				let n = t.altKey || t.ctrlKey || t.metaKey;
				if (t.key === "Tab" && !n) {
					let n = document.activeElement, r = t.shiftKey;
					if (t.target === e && r) {
						u.current?.focus();
						return;
					}
					let i = g({ tabbingDirection: r ? "backwards" : "forwards" }), a = i.findIndex((e) => e === n);
					Aw(i.slice(a + 1)) ? t.preventDefault() : r ? u.current?.focus() : d.current?.focus();
				}
			};
			return e.addEventListener("keydown", t), () => e.removeEventListener("keydown", t);
		}
	}, [c, g]), /* @__PURE__ */ x(PC, {
		ref: l,
		role: "region",
		"aria-label": a.replace("{hotkey}", m),
		tabIndex: -1,
		style: { pointerEvents: h ? void 0 : "none" },
		children: [
			h && /* @__PURE__ */ b(iw, {
				ref: u,
				onFocusFromOutsideViewport: () => {
					Aw(g({ tabbingDirection: "forwards" }));
				}
			}),
			/* @__PURE__ */ b(WC.Slot, {
				scope: r,
				children: /* @__PURE__ */ b($.ol, {
					tabIndex: -1,
					...o,
					ref: p
				})
			}),
			h && /* @__PURE__ */ b(iw, {
				ref: d,
				onFocusFromOutsideViewport: () => {
					Aw(g({ tabbingDirection: "backwards" }));
				}
			})
		]
	});
});
nw.displayName = QC;
var rw = "ToastFocusProxy", iw = e.forwardRef((e, t) => {
	let { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = e, a = XC(rw, n);
	return /* @__PURE__ */ b(HC, {
		tabIndex: 0,
		...i,
		ref: t,
		style: { position: "fixed" },
		onFocus: (e) => {
			let t = e.relatedTarget;
			a.viewport?.contains(t) || r();
		}
	});
});
iw.displayName = rw;
var aw = "Toast", ow = "toast.swipeStart", sw = "toast.swipeMove", cw = "toast.swipeCancel", lw = "toast.swipeEnd", uw = e.forwardRef((e, t) => {
	let { forceMount: n, open: r, defaultOpen: i, onOpenChange: a, ...o } = e, [s, c] = Yy({
		prop: r,
		defaultProp: i ?? !0,
		onChange: a,
		caller: aw
	});
	return /* @__PURE__ */ b(IC, {
		present: n || s,
		children: /* @__PURE__ */ b(pw, {
			open: s,
			...o,
			ref: t,
			onClose: () => c(!1),
			onPause: ab(e.onPause),
			onResume: ab(e.onResume),
			onSwipeStart: vC(e.onSwipeStart, (e) => {
				e.currentTarget.setAttribute("data-swipe", "start");
			}),
			onSwipeMove: vC(e.onSwipeMove, (e) => {
				let { x: t, y: n } = e.detail.delta;
				e.currentTarget.setAttribute("data-swipe", "move"), e.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${t}px`), e.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${n}px`);
			}),
			onSwipeCancel: vC(e.onSwipeCancel, (e) => {
				e.currentTarget.setAttribute("data-swipe", "cancel"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), e.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
			}),
			onSwipeEnd: vC(e.onSwipeEnd, (e) => {
				let { x: t, y: n } = e.detail.delta;
				e.currentTarget.setAttribute("data-swipe", "end"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), e.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), e.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${t}px`), e.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${n}px`), c(!1);
			})
		})
	});
});
uw.displayName = aw;
var [dw, fw] = qC(aw, { onClose() {} }), pw = e.forwardRef((t, n) => {
	let { __scopeToast: r, type: i = "foreground", duration: a, open: o, onClose: s, onEscapeKeyDown: c, onPause: l, onResume: u, onSwipeStart: d, onSwipeMove: f, onSwipeCancel: p, onSwipeEnd: m, ...h } = t, g = XC(aw, r), [_, v] = e.useState(null), C = By(n, (e) => v(e)), w = e.useRef(null), T = e.useRef(null), E = a || g.duration, D = e.useRef(0), ee = e.useRef(E), te = e.useRef(0), { onToastAdd: ne, onToastRemove: re } = g, O = ab(() => {
		_?.contains(document.activeElement) && g.viewport?.focus(), s();
	}), k = e.useCallback((e) => {
		!e || e === Infinity || (window.clearTimeout(te.current), D.current = (/* @__PURE__ */ new Date()).getTime(), te.current = window.setTimeout(O, e));
	}, [O]);
	e.useEffect(() => {
		let e = g.viewport;
		if (e) {
			let t = () => {
				k(ee.current), u?.();
			}, n = () => {
				let e = (/* @__PURE__ */ new Date()).getTime() - D.current;
				ee.current -= e, window.clearTimeout(te.current), l?.();
			};
			return e.addEventListener(ew, n), e.addEventListener(tw, t), () => {
				e.removeEventListener(ew, n), e.removeEventListener(tw, t);
			};
		}
	}, [
		g.viewport,
		E,
		l,
		u,
		k
	]), e.useEffect(() => {
		o && !g.isClosePausedRef.current && k(E);
	}, [
		o,
		E,
		g.isClosePausedRef,
		k
	]), e.useEffect(() => (ne(), () => re()), [ne, re]);
	let A = e.useMemo(() => _ ? ww(_) : null, [_]);
	return g.viewport ? /* @__PURE__ */ x(y, { children: [A && /* @__PURE__ */ b(mw, {
		__scopeToast: r,
		role: "status",
		"aria-live": i === "foreground" ? "assertive" : "polite",
		children: A
	}), /* @__PURE__ */ b(dw, {
		scope: r,
		onClose: O,
		children: S.createPortal(/* @__PURE__ */ b(WC.ItemSlot, {
			scope: r,
			children: /* @__PURE__ */ b(NC, {
				asChild: !0,
				onEscapeKeyDown: vC(c, () => {
					g.isFocusedToastEscapeKeyDownRef.current || O(), g.isFocusedToastEscapeKeyDownRef.current = !1;
				}),
				children: /* @__PURE__ */ b($.li, {
					tabIndex: 0,
					"data-state": o ? "open" : "closed",
					"data-swipe-direction": g.swipeDirection,
					...h,
					ref: C,
					style: {
						userSelect: "none",
						touchAction: "none",
						...t.style
					},
					onKeyDown: vC(t.onKeyDown, (e) => {
						e.key === "Escape" && (c?.(e.nativeEvent), e.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, O()));
					}),
					onPointerDown: vC(t.onPointerDown, (e) => {
						e.button === 0 && (w.current = {
							x: e.clientX,
							y: e.clientY
						});
					}),
					onPointerMove: vC(t.onPointerMove, (e) => {
						if (!w.current) return;
						let t = e.clientX - w.current.x, n = e.clientY - w.current.y, r = !!T.current, i = ["left", "right"].includes(g.swipeDirection), a = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, o = i ? a(0, t) : 0, s = i ? 0 : a(0, n), c = e.pointerType === "touch" ? 10 : 2, l = {
							x: o,
							y: s
						}, u = {
							originalEvent: e,
							delta: l
						};
						r ? (T.current = l, Tw(sw, f, u, { discrete: !1 })) : Ew(l, g.swipeDirection, c) ? (T.current = l, Tw(ow, d, u, { discrete: !1 }), e.target.setPointerCapture(e.pointerId)) : (Math.abs(t) > c || Math.abs(n) > c) && (w.current = null);
					}),
					onPointerUp: vC(t.onPointerUp, (e) => {
						let t = T.current, n = e.target;
						if (n.hasPointerCapture(e.pointerId) && n.releasePointerCapture(e.pointerId), T.current = null, w.current = null, t) {
							let n = e.currentTarget, r = {
								originalEvent: e,
								delta: t
							};
							Ew(t, g.swipeDirection, g.swipeThreshold) ? Tw(lw, m, r, { discrete: !0 }) : Tw(cw, p, r, { discrete: !0 }), n.addEventListener("click", (e) => e.preventDefault(), { once: !0 });
						}
					})
				})
			})
		}), g.viewport)
	})] }) : null;
}), mw = (t) => {
	let { __scopeToast: n, children: r, ...i } = t, a = XC(aw, n), [o, s] = e.useState(!1), [c, l] = e.useState(!1);
	return Dw(() => s(!0)), e.useEffect(() => {
		let e = window.setTimeout(() => l(!0), 1e3);
		return () => window.clearTimeout(e);
	}, []), c ? null : /* @__PURE__ */ b(Lb, {
		asChild: !0,
		children: /* @__PURE__ */ b(HC, {
			...i,
			children: o && /* @__PURE__ */ x(y, { children: [
				a.label,
				" ",
				r
			] })
		})
	});
}, hw = "ToastTitle", gw = e.forwardRef((e, t) => {
	let { __scopeToast: n, ...r } = e;
	return /* @__PURE__ */ b($.div, {
		...r,
		ref: t
	});
});
gw.displayName = hw;
var _w = "ToastDescription", vw = e.forwardRef((e, t) => {
	let { __scopeToast: n, ...r } = e;
	return /* @__PURE__ */ b($.div, {
		...r,
		ref: t
	});
});
vw.displayName = _w;
var yw = "ToastAction", bw = e.forwardRef((e, t) => {
	let { altText: n, ...r } = e;
	return n.trim() ? /* @__PURE__ */ b(Cw, {
		altText: n,
		asChild: !0,
		children: /* @__PURE__ */ b(Sw, {
			...r,
			ref: t
		})
	}) : (console.error(`Invalid prop \`altText\` supplied to \`${yw}\`. Expected non-empty \`string\`.`), null);
});
bw.displayName = yw;
var xw = "ToastClose", Sw = e.forwardRef((e, t) => {
	let { __scopeToast: n, ...r } = e, i = fw(xw, n);
	return /* @__PURE__ */ b(Cw, {
		asChild: !0,
		children: /* @__PURE__ */ b($.button, {
			type: "button",
			...r,
			ref: t,
			onClick: vC(e.onClick, i.onClose)
		})
	});
});
Sw.displayName = xw;
var Cw = e.forwardRef((e, t) => {
	let { __scopeToast: n, altText: r, ...i } = e;
	return /* @__PURE__ */ b($.div, {
		"data-radix-toast-announce-exclude": "",
		"data-radix-toast-announce-alt": r || void 0,
		...i,
		ref: t
	});
});
function ww(e) {
	let t = [];
	return Array.from(e.childNodes).forEach((e) => {
		if (e.nodeType === e.TEXT_NODE && e.textContent && t.push(e.textContent), Ow(e)) {
			let n = e.ariaHidden || e.hidden || e.style.display === "none", r = e.dataset.radixToastAnnounceExclude === "";
			if (!n) if (r) {
				let n = e.dataset.radixToastAnnounceAlt;
				n && t.push(n);
			} else t.push(...ww(e));
		}
	}), t;
}
function Tw(e, t, n, { discrete: r }) {
	let i = n.originalEvent.currentTarget, a = new CustomEvent(e, {
		bubbles: !0,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? ib(i, a) : i.dispatchEvent(a);
}
var Ew = (e, t, n = 0) => {
	let r = Math.abs(e.x), i = Math.abs(e.y), a = r > i;
	return t === "left" || t === "right" ? a && r > n : !a && i > n;
};
function Dw(e = () => {}) {
	let t = ab(e);
	Wy(() => {
		let e = 0, n = 0;
		return e = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
			window.cancelAnimationFrame(e), window.cancelAnimationFrame(n);
		};
	}, [t]);
}
function Ow(e) {
	return e.nodeType === e.ELEMENT_NODE;
}
function kw(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
function Aw(e) {
	let t = document.activeElement;
	return e.some((e) => e === t ? !0 : (e.focus(), document.activeElement !== t));
}
var jw = ZC, Mw = nw, Nw = uw, Pw = gw, Fw = vw, Iw = bw, Lw = "\n  fixed z-10 top-6\n  w-[80%] left-[10%]\n  md:w-[60%] md:left-[20%]\n", Rw = "relative", zw = "flex-1", Bw = "font-medium text-base", Vw = "text-sm font-normal align-left", Hw = "h-5 w-5", Uw = "border-none bg-transparent cursor-pointer p-0", Ww = "\n  group rounded-lg my-2 p-4\n  flex items-start justify-between gap-x-2 md:gap-x-3\n\n  data-[variant=\"error\"]:bg-feedback-danger-50\n  data-[variant=\"success\"]:bg-feedback-success-50\n  data-[variant=\"information\"]:bg-feedback-info-50\n  data-[variant=\"warning\"]:bg-feedback-warning-50\n", Gw = "text-primary-100 ml-1", Kw = "\n  h-10 w-10 p-2 pl-2.5\n  rounded-lg flex items-center justify-between\n\n  group-data-[variant=\"information\"]:before:content-[\"ℹ️\"]\n  group-data-[variant=\"error\"]:before:content-[\"❗\"]\n  group-data-[variant=\"warning\"]:before:content-[\"⚠️\"]\n  group-data-[variant=\"success\"]:before:content-[\"🎉\"]\n  group-data-[variant=\"error\"]:bg-feedback-danger-100\n  group-data-[variant=\"success\"]:bg-feedback-success-100\n  group-data-[variant=\"information\"]:bg-feedback-info-100\n  group-data-[variant=\"warning\"]:bg-feedback-warning-100\n", qw = ({ toasts: e, onClose: t }) => /* @__PURE__ */ b("div", {
	className: Lw,
	children: /* @__PURE__ */ b(sp, { children: e.map((e) => /* @__PURE__ */ b(Sv.div, {
		className: Rw,
		initial: {
			translateY: -25,
			opacity: 0
		},
		animate: {
			translateY: 0,
			opacity: 1
		},
		exit: {
			translateY: -25,
			opacity: 0
		},
		transition: { duration: .2 },
		children: /* @__PURE__ */ x(jw, {
			swipeDirection: "right",
			children: [/* @__PURE__ */ x(Nw, {
				className: Ww,
				"data-variant": e.variant,
				duration: e.timeout || 5e3,
				children: [
					/* @__PURE__ */ b(Pw, { children: /* @__PURE__ */ b("div", {
						className: Kw,
						"data-variant": e.variant
					}) }),
					/* @__PURE__ */ x(Fw, {
						className: zw,
						children: [/* @__PURE__ */ b("div", {
							className: Bw,
							children: e.title
						}), /* @__PURE__ */ x("div", {
							className: Vw,
							children: [e.description, e.action && e.actionCallback && /* @__PURE__ */ b("button", {
								onClick: e.actionCallback,
								className: Gw,
								children: e.action
							})]
						})]
					}),
					/* @__PURE__ */ b(Iw, {
						asChild: !0,
						altText: "Close Toast Alert",
						children: t && /* @__PURE__ */ b("button", {
							className: Uw,
							onClick: () => e.id && t(e.id),
							type: "button",
							children: /* @__PURE__ */ b(Xv, { className: Hw })
						})
					})
				]
			}), /* @__PURE__ */ b(Mw, {})]
		})
	}, e.id)) })
}), Jw = [];
for (let e = 0; e < 256; ++e) Jw.push((e + 256).toString(16).slice(1));
function Yw(e, t = 0) {
	return (Jw[e[t + 0]] + Jw[e[t + 1]] + Jw[e[t + 2]] + Jw[e[t + 3]] + "-" + Jw[e[t + 4]] + Jw[e[t + 5]] + "-" + Jw[e[t + 6]] + Jw[e[t + 7]] + "-" + Jw[e[t + 8]] + Jw[e[t + 9]] + "-" + Jw[e[t + 10]] + Jw[e[t + 11]] + Jw[e[t + 12]] + Jw[e[t + 13]] + Jw[e[t + 14]] + Jw[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../node_modules/uuid/dist/rng.js
var Xw = new Uint8Array(16);
function Zw() {
	return crypto.getRandomValues(Xw);
}
//#endregion
//#region ../../node_modules/uuid/dist/v4.js
function Qw(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : $w(e, t, n);
}
function $w(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? Zw();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return Yw(r);
}
//#endregion
//#region src/components/ToastAlerts/ToastAlertsProvider/index.tsx
var eT = a({
	toastAlerts: [],
	openToastAlert: () => {},
	closeToastAlerts: () => {}
}), tT = () => u(eT), nT = ({ children: e }) => {
	let [t, n] = v([]), r = (e) => n((t) => t.filter((t) => t.id !== e));
	return /* @__PURE__ */ x(eT.Provider, {
		value: {
			toastAlerts: t,
			openToastAlert: ({ title: e, description: t, metadata: i, variant: a, action: o, actionCallback: s, timeout: c = 5e3 }) => {
				let l = `${Qw()}`;
				n((n) => [...n, {
					id: l,
					title: e,
					description: t,
					metadata: i,
					timeout: c,
					variant: a,
					action: o,
					actionCallback: s
				}]), setTimeout(() => r(l), c);
			},
			closeToastAlerts: r
		},
		children: [e, /* @__PURE__ */ b(qw, {
			toasts: t,
			onClose: r
		})]
	});
}, rT = "\n  text-center text-xs\n  leading-4 font-normal capitalize\n  rounded-md\n  py-1 px-3\n  data-[variant=\"dark\"]:bg-primary-100\n  data-[variant=\"dark\"]:text-white\n  data-[variant=\"light\"]:bg-primary-10\n  data-[variant=\"light\"]:text-primary-100\n  data-[variant=\"tertiary\"]:bg-primary-200\n  data-[variant=\"tertiary\"]:text-white\n  data-[variant=\"neutral\"]:bg-feedback-warning-200\n  data-[variant=\"neutral\"]:text-base-black\n  data-[variant=\"positive\"]:bg-feedback-success-100\n  data-[variant=\"positive\"]:text-base-black\n  data-[variant=\"negative\"]:bg-feedback-danger-100\n  data-[variant=\"negative\"]:text-base-black\n\n  data-[top-left-rounded=\"false\"]:rounded-tl-none\n  data-[top-left-rounded=\"false\"]:px-2.5\n  data-[top-right-rounded=\"false\"]:rounded-tr-none\n  data-[top-right-rounded=\"false\"]:px-2.5\n  data-[bottom-right-rounded=\"false\"]:rounded-br-none\n  data-[bottom-right-rounded=\"false\"]:px-2.5\n  data-[bottom-left-rounded=\"false\"]:rounded-bl-none\n  data-[bottom-left-rounded=\"false\"]:px-2.5\n", iT = ({ children: e, variant: t = "dark", isVisible: n = !0, isTopLeftRounded: r = !0, isTopRightRounded: i = !0, isBottomRightRounded: a = !0, isBottomLeftRounded: o = !0 }) => n ? /* @__PURE__ */ b("div", {
	className: rT,
	"data-variant": t,
	"data-top-left-rounded": r,
	"data-top-right-rounded": i,
	"data-bottom-right-rounded": a,
	"data-bottom-left-rounded": o,
	"data-testid": "tag-component",
	children: e
}) : null;
//#endregion
export { ft as Button, ht as Card, vt as ColorIcon, my as Form, cC as HorizontalScrollFilters, _C as Modal, iT as Tag, qw as ToastAlerts, nT as ToastAlertsProvider, tT as useToastAlerts };
